<template>
  <div>
    <el-dialog
      title="编辑抖店商品"
      :visible="visible"
      width="96%"
      top="2vh"
      custom-class="doudian-editor-shell"
      :close-on-click-modal="false"
      :before-close="handleBeforeClose"
      append-to-body
    >
      <template slot="title">
        <div class="dialog-title">
          <div class="dialog-title-main">
            <div class="dialog-title-text">抖店商品编辑</div>
            <div v-if="productInfo.product_title || productInfo.name" class="dialog-title-sub">
              {{ productInfo.product_title || productInfo.name }}
            </div>
          </div>
        </div>
      </template>
      <div v-loading="loading" class="editor-dialog">
        <el-empty v-if="!loading && !productInfo.id" description="暂无可编辑商品" :image-size="80"></el-empty>
        <el-container v-else class="editor-container" :class="{ 'is-sku-tab': activeTab === 'sku' }">
          <el-aside width="300px" class="editor-sidebar">
            <div class="sidebar-head">
              <div class="sidebar-head-title">商品列表</div>
              <div class="sidebar-head-desc">{{ sidebarPagination.total || sidebarList.length || 0 }} 个商品</div>
            </div>
            <div v-if="!useProvidedSidebarItems" class="sidebar-search">
              <el-input v-model="sidebarSearch.title" size="mini" placeholder="标题" clearable @keyup.enter.native="handleSidebarSearch"></el-input>
              <el-input v-model="sidebarSearch.platform_product_id" size="mini" placeholder="商品ID" clearable @keyup.enter.native="handleSidebarSearch"></el-input>
              <el-button size="mini" type="primary" @click="handleSidebarSearch">搜索</el-button>
            </div>
            <div v-loading="sidebarLoading" class="sidebar-list">
              <div
                v-for="item in sidebarList"
                :key="item.id"
                class="sidebar-item"
                :class="{ active: String(item.id) === String(currentEditingId), disabled: Number(item.mod_status) === 3 || !Number(item.platform_product_id) }"
                @click="switchProduct(item)"
              >
                <el-tooltip v-if="item.img" placement="right" :open-delay="300">
                  <div slot="content"><img :src="item.img" style="width:200px" /></div>
                  <img :src="item.img" class="sidebar-thumb" />
                </el-tooltip>
                <div v-else class="sidebar-thumb sidebar-thumb-empty">无图</div>
                <div class="sidebar-info">
                  <div class="sidebar-title">{{ item.product_title || item.name || '-' }}</div>
                  <div v-if="item.platform_product_id" class="sidebar-id">ID: {{ item.platform_product_id }}</div>
                  <div class="sidebar-status">
                    <el-tag v-if="item.status_text" :type="item.platform_status == 5 ? 'success' : 'info'" size="mini">{{ item.status_text }}</el-tag>
                    <el-tooltip v-if="Number(item.mod_status) === 3 && item.platform_error_msg" :content="item.platform_error_msg" placement="top">
                      <el-tag type="danger" size="mini">铺货失败</el-tag>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <el-empty v-if="!sidebarList.length && !sidebarLoading" description="暂无商品" :image-size="60"></el-empty>
            </div>
            <el-pagination
              v-if="sidebarPagination.total > sidebarPagination.page_size"
              background
              small
              layout="prev, pager, next"
              :current-page.sync="sidebarPagination.page"
              :page-size="sidebarPagination.page_size"
              :total="sidebarPagination.total"
              @current-change="handleSidebarPageChange"
              @size-change="handleSidebarSizeChange"
            ></el-pagination>
          </el-aside>
          <el-main class="editor-main">
        <el-form ref="editorForm" :model="form" label-width="120px" size="small" class="editor-form">
          <el-tabs v-model="activeTab" type="border-card" class="editor-tabs">
            <el-tab-pane label="商品信息" name="info">
              <div class="editor-section">
                <div class="section-title-row">
                  <div class="section-title">基础信息</div>
                  <div class="section-meta">
                    <span class="section-meta-item">店铺：{{ productInfo.shop_name || '-' }}</span>
                    <span class="section-meta-item">抖店商品ID：{{ productInfo.platform_product_id || '-' }}</span>
                  </div>
                </div>
                <div v-if="showAuditPendingWarning" class="editor-status-warning">
                  <i class="el-icon-warning-outline"></i>
                  <span>当前商品还在审核中，可能未获取到上次的修改，请稍后查看。审核中的商品获取到的详情不是提交审核时编辑的内容。</span>
                </div>
            <div class="sub-group">
            <el-form-item label="商品类目">
              <div class="category-select-row">
                <div
                  :class="['plain-field-value', { 'is-empty': !currentCategoryPath }]"
                  :title="currentCategoryPath"
                >{{ currentCategoryPath || '请通过类目预测选择类目' }}</div>
                <el-button
                  size="mini"
                  type="primary"
                  :loading="predictionLoadingSource === 'category'"
                  :disabled="!!predictionLoadingSource"
                  @click="requestCategoryPrediction('category')"
                >类目预测</el-button>
              </div>
                <div class="field-hint">商品类目只能从抖店预测结果中选择。</div>
              </el-form-item>
            </div>
            <div class="sub-group">
              <div class="sub-group-title">标题</div>
            <el-form-item label="商品标题" required>
              <div class="title-edit-row">
                <div
                  :class="['plain-field-value', { 'is-empty': !form.name }]"
                  :title="form.name"
                >{{ form.name || '暂无商品标题' }}</div>
                <el-button
                  class="critical-edit-trigger"
                  icon="el-icon-edit-outline"
                  :loading="predictionLoadingSource === 'title'"
                  :disabled="!!predictionLoadingSource"
                  @click="openTitleEditor"
                >修改标题</el-button>
              </div>
              <div class="field-hint">至少8个字符（4个汉字），最多60个字符（30个汉字）。</div>
            </el-form-item>
            <el-form-item label="短标题">
              <el-input
                class="title-field-input"
                v-model="form.short_product_name"
                placeholder="建议填写简明准确的标题内容"
              >
                <template slot="suffix">
                  <span class="char-counter" :class="{ 'char-over': shortTitleCharCount > 24 }">{{ shortTitleCharCount }}/24</span>
                </template>
              </el-input>
            </el-form-item>
            </div>
            <div class="sub-group">
              <div class="sub-group-title">规格与上架</div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="库存扣减">
                  <el-radio-group v-model="form.reduce_type">
                    <el-radio :label="1">下单减库存</el-radio>
                    <el-radio :label="2">付款减库存</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="上架设置">
                  <el-radio-group v-model="form.start_sale_type">
                    <el-radio :label="0">立即上架</el-radio>
                    <el-radio :label="1">放入仓库</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
            <div class="sub-group">
              <div class="sub-group-title">物流模板</div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="运费模板">
                  <div class="inline-field">
                    <el-select v-model="form.freight_id" filterable clearable placeholder="请选择" style="flex: 1;">
                      <el-option
                        v-for="item in freightTemplates"
                        :key="item.template_id"
                        :label="item.template_name"
                        :value="String(item.template_id)"
                      ></el-option>
                    </el-select>
                    <el-button size="small" :loading="freightLoading" @click="loadFreightTemplates(true)">刷新</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
            <div class="sub-group">
              <div class="sub-group-title">营销与限购</div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="测评短视频">
                  <el-radio-group v-model="form.is_evaluate_opened">
                    <el-radio :label="true">开启</el-radio>
                    <el-radio :label="false">关闭</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参考价">
                  <el-input-number
                    v-model="form.reference_price"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入参考价"
                    style="width: 100%;"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="每单限购">
                  <el-input-number v-model="form.maximum_per_order" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="每人限购">
                  <el-input-number v-model="form.limit_per_buyer" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="起购数量">
                  <el-input-number v-model="form.minimum_per_order" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
            <div class="sub-group">
              <div class="sub-group-title">售后</div>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="退货天数" :required="supplyDayReturnRequired">
                  <el-select
                    v-model="form.after_sale_service.supply_day_return_selector"
                    :clearable="!supplyDayReturnRequired"
                    placeholder="请选择"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in supplyDayOptions"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="三包服务">
                  <div class="inline-field">
                    <el-select
                      v-model="threeGuarantees.service_type"
                      clearable
                      placeholder="请选择服务类型"
                      style="flex: 1;"
                      @change="handleThreeGuaranteesTypeChange"
                    >
                      <el-option
                        v-for="item in threeGuaranteeTypeOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="threeGuarantees.duration"
                      clearable
                      placeholder="请选择有效期"
                      style="width: 160px;"
                      :disabled="!threeGuaranteeDurationOptions.length"
                    >
                      <el-option
                        v-for="item in threeGuaranteeDurationOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            </div>
              </div>

              <div class="editor-section" v-if="mainCategoryProperties.length">
                <div class="section-title">重要属性</div>
                <div class="property-grid">
                  <div v-for="item in mainCategoryProperties" :key="'main-prop-' + item.property_id" class="property-row">
                    <el-form-item :required="isRequiredProperty(item)" class="property-form-item">
                      <template slot="label">
                        <span>{{ item.property_name }}</span>
                      </template>
                      <template v-if="isTextProperty(item)">
                        <el-input v-model="form.Property[item.property_id]" @input="updatePropertyValue(item, form.Property[item.property_id])"></el-input>
                      </template>
                      <template v-else-if="item.type === 'select' && item.property_name === '品牌'">
                        <el-select
                          v-model="form.standard_brand_id"
                          clearable
                          filterable
                          placeholder="请选择"
                          style="width: 100%;"
                          @change="handleStandardBrandChange"
                        >
                          <el-option
                            v-for="option in brandOptions"
                            :key="option.brand_id || option.id"
                            :label="option.display_name"
                            :value="String(option.brand_id || option.id)"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-else-if="item.type === 'select'">
                        <el-select
                          v-model="form.Property[item.property_id]"
                          clearable
                          filterable
                          :allow-create="canCreatePropertyOption(item)"
                          :default-first-option="canCreatePropertyOption(item)"
                          :reserve-keyword="canCreatePropertyOption(item)"
                          :placeholder="getPropertyPlaceholder(item)"
                          :no-match-text="getPropertyNoMatchText(item)"
                          popper-class="doudian-property-select-dropdown"
                          style="width: 100%;"
                          @visible-change="handlePropertySelectVisible(item, $event)"
                          @change="updatePropertyValue(item, form.Property[item.property_id])"
                        >
                          <el-option
                            v-for="option in item.options || []"
                            :key="option.value_id"
                            :label="option.name"
                            :value="String(option.value_id)"
                          ></el-option>
                          <el-option
                            v-if="canCreatePropertyOption(item)"
                            disabled
                            :value="'diy-footer-' + item.property_id"
                            :class="['property-diy-option', { 'is-editing': isPropertyDiyEditing(item) }]"
                          >
                            <div class="property-diy-footer" @click.stop @mousedown.stop>
                              <el-button
                                v-if="!isPropertyDiyEditing(item)"
                                plain
                                size="mini"
                                type="primary"
                                @click.stop="openPropertyDiyInput(item)"
                              >新建{{ item.property_name }}</el-button>
                              <div v-else class="property-diy-input-row">
                                <el-input
                                  :value="getPropertyDiyDraft(item)"
                                  size="mini"
                                  placeholder="请输入自定义属性"
                                  @input="setPropertyDiyDraft(item, $event)"
                                  @keyup.enter.native.stop="confirmPropertyDiyInput(item)"
                                ></el-input>
                                <i class="el-icon-success property-diy-confirm" @click.stop="confirmPropertyDiyInput(item)"></i>
                                <i class="el-icon-error property-diy-cancel" @click.stop="cancelPropertyDiyInput(item)"></i>
                              </div>
                            </div>
                          </el-option>
                        </el-select>
                      </template>
                      <template v-else-if="item.type === 'multi_select'">
                        <el-select
                          v-model="form.Property[item.property_id]"
                          multiple
                          clearable
                          filterable
                          :allow-create="canCreatePropertyOption(item)"
                          :default-first-option="canCreatePropertyOption(item)"
                          :reserve-keyword="canCreatePropertyOption(item)"
                          :placeholder="getPropertyPlaceholder(item)"
                          :no-match-text="getPropertyNoMatchText(item)"
                          popper-class="doudian-property-select-dropdown"
                          style="width: 100%;"
                          @visible-change="handlePropertySelectVisible(item, $event)"
                          @change="updatePropertyValue(item, form.Property[item.property_id])"
                        >
                          <el-option
                            v-for="option in item.options || []"
                            :key="option.value_id"
                            :label="option.name"
                            :value="String(option.value_id)"
                          ></el-option>
                          <el-option
                            v-if="canCreatePropertyOption(item)"
                            disabled
                            :value="'diy-footer-' + item.property_id"
                            :class="['property-diy-option', { 'is-editing': isPropertyDiyEditing(item) }]"
                          >
                            <div class="property-diy-footer" @click.stop @mousedown.stop>
                              <el-button
                                v-if="!isPropertyDiyEditing(item)"
                                plain
                                size="mini"
                                type="primary"
                                @click.stop="openPropertyDiyInput(item)"
                              >新建{{ item.property_name }}</el-button>
                              <div v-else class="property-diy-input-row">
                                <el-input
                                  :value="getPropertyDiyDraft(item)"
                                  size="mini"
                                  placeholder="请输入自定义属性"
                                  @input="setPropertyDiyDraft(item, $event)"
                                  @keyup.enter.native.stop="confirmPropertyDiyInput(item)"
                                ></el-input>
                                <i class="el-icon-success property-diy-confirm" @click.stop="confirmPropertyDiyInput(item)"></i>
                                <i class="el-icon-error property-diy-cancel" @click.stop="cancelPropertyDiyInput(item)"></i>
                              </div>
                            </div>
                          </el-option>
                        </el-select>
                      </template>
                      <template v-else-if="isMeasureProperty(item)">
                        <div class="measure-group">
                          <div
                            v-for="(measureItem, measureIndex) in getMeasureRows(item)"
                            :key="'measure-' + item.property_id + '-' + measureIndex"
                            class="measure-row"
                          >
                            <div class="measure-row-main">
                              <div
                                v-for="(module, moduleIndex) in getMeasureModules(item, measureItem)"
                                :key="'measure-module-' + item.property_id + '-' + measureIndex + '-' + module.module_id"
                                class="measure-module-field"
                              >
                                <el-select
                                  v-if="isMeasureEnumModule(module)"
                                  v-model="measureItem.measure_info.values[moduleIndex].value"
                                  filterable
                                  allow-create
                                  default-first-option
                                  reserve-keyword
                                  :placeholder="getMeasureModulePlaceholder(module)"
                                  @change="syncMeasurePropertyName(item, measureItem)"
                                  >
                                  <el-option
                                    v-for="option in getMeasureModuleOptions(module)"
                                    :key="'measure-option-' + module.module_id + '-' + option.value_name"
                                    :label="option.value_name"
                                    :value="option.value_name"
                                  ></el-option>
                                </el-select>
                                <div v-else class="measure-module-input-wrap">
                                  <el-input
                                    v-if="isMeasureNumericModule(module)"
                                    v-model="measureItem.measure_info.values[moduleIndex].value"
                                    type="number"
                                    :min="getMeasureModuleMin(module)"
                                    :max="getMeasureModuleMax(module)"
                                    :step="getMeasureModuleStep(module)"
                                    :placeholder="getMeasureModulePlaceholder(module)"
                                    class="measure-module-number"
                                    @input="syncMeasurePropertyName(item, measureItem)"
                                  ></el-input>
                                  <el-input
                                    v-else
                                    v-model="measureItem.measure_info.values[moduleIndex].value"
                                    :type="getMeasureModuleInputType(module)"
                                    :placeholder="getMeasureModulePlaceholder(module)"
                                    @input="syncMeasurePropertyName(item, measureItem)"
                                  ></el-input>
                                  <el-select
                                    v-if="shouldShowMeasureUnitSelector(module)"
                                    v-model="measureItem.measure_info.values[moduleIndex].unit_id"
                                    class="measure-module-unit-select"
                                    placeholder="单位"
                                    @change="handleMeasureUnitChange(item, measureItem, moduleIndex, $event)"
                                  >
                                    <el-option
                                      v-for="unit in getMeasureModuleUnits(module)"
                                      :key="'measure-unit-' + module.module_id + '-' + unit.unit_id"
                                      :label="unit.unit_name"
                                      :value="unit.unit_id"
                                    ></el-option>
                                  </el-select>
                                  <span v-else-if="getMeasureModuleUnitName(item, measureItem, moduleIndex)" class="measure-module-unit-text">{{ getMeasureModuleUnitName(item, measureItem, moduleIndex) }}</span>
                                </div>
                              </div>
                            </div>
                            <el-button size="mini" @click="removeMeasureProperty(item, measureIndex)">删除</el-button>
                          </div>
                          <el-button v-if="isMultiValueMeasureProperty(item)" size="mini" plain class="measure-add-button" @click="addMeasureProperty(item)">新增</el-button>
                        </div>
                      </template>
                      <div v-if="shouldShowPropertyPicUploader(item)" class="property-pic-uploader">
                        <div class="property-pic-header">
                          <span class="property-pic-title">水洗标/吊牌图</span>
                          <span v-if="isRequiredPropertyPic(item)" class="property-pic-required">必传</span>
                          <span class="property-pic-limit">最多1张</span>
                        </div>
                        <div class="property-pic-list">
                          <div
                            v-for="(url, picIndex) in getPropertyPicUrls(item)"
                            :key="'main-prop-pic-' + item.property_id + '-' + picIndex"
                            class="property-pic-card"
                          >
                            <img :src="url" />
                            <div class="property-pic-mask">
                              <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                              <i class="el-icon-delete" @click="removePropertyPic(item, picIndex)"></i>
                            </div>
                          </div>
                          <div
                            v-if="canAddPropertyPic(item)"
                            class="property-pic-card property-pic-add"
                            @click="openPropertyPicDialog(item)"
                          >
                            <i class="el-icon-plus"></i>
                            <span>上传图片</span>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="editor-section" v-if="otherCategoryProperties.length">
                <div class="section-title">其他属性</div>
                <div class="property-grid">
                  <div v-for="item in otherCategoryProperties" :key="'other-prop-' + item.property_id" class="property-row">
                    <el-form-item :required="isRequiredProperty(item)" class="property-form-item">
                      <template slot="label">
                        <span>{{ item.property_name }}</span>
                      </template>
                      <template v-if="isTextProperty(item)">
                        <el-input v-model="form.Property[item.property_id]" @input="updatePropertyValue(item, form.Property[item.property_id])"></el-input>
                      </template>
                      <template v-else-if="item.type === 'select' && item.property_name === '品牌'">
                        <el-select
                          v-model="form.standard_brand_id"
                          clearable
                          filterable
                          placeholder="请选择"
                          style="width: 100%;"
                          @change="handleStandardBrandChange"
                        >
                          <el-option
                            v-for="option in brandOptions"
                            :key="option.brand_id || option.id"
                            :label="option.display_name"
                            :value="String(option.brand_id || option.id)"
                          ></el-option>
                        </el-select>
                      </template>
                      <template v-else-if="item.type === 'select'">
                        <el-select
                          v-model="form.Property[item.property_id]"
                          clearable
                          filterable
                          :allow-create="canCreatePropertyOption(item)"
                          :default-first-option="canCreatePropertyOption(item)"
                          :reserve-keyword="canCreatePropertyOption(item)"
                          :placeholder="getPropertyPlaceholder(item)"
                          :no-match-text="getPropertyNoMatchText(item)"
                          popper-class="doudian-property-select-dropdown"
                          style="width: 100%;"
                          @visible-change="handlePropertySelectVisible(item, $event)"
                          @change="updatePropertyValue(item, form.Property[item.property_id])"
                        >
                          <el-option
                            v-for="option in item.options || []"
                            :key="option.value_id"
                            :label="option.name"
                            :value="String(option.value_id)"
                          ></el-option>
                          <el-option
                            v-if="canCreatePropertyOption(item)"
                            disabled
                            :value="'diy-footer-' + item.property_id"
                            :class="['property-diy-option', { 'is-editing': isPropertyDiyEditing(item) }]"
                          >
                            <div class="property-diy-footer" @click.stop @mousedown.stop>
                              <el-button
                                v-if="!isPropertyDiyEditing(item)"
                                plain
                                size="mini"
                                type="primary"
                                @click.stop="openPropertyDiyInput(item)"
                              >新建{{ item.property_name }}</el-button>
                              <div v-else class="property-diy-input-row">
                                <el-input
                                  :value="getPropertyDiyDraft(item)"
                                  size="mini"
                                  placeholder="请输入自定义属性"
                                  @input="setPropertyDiyDraft(item, $event)"
                                  @keyup.enter.native.stop="confirmPropertyDiyInput(item)"
                                ></el-input>
                                <i class="el-icon-success property-diy-confirm" @click.stop="confirmPropertyDiyInput(item)"></i>
                                <i class="el-icon-error property-diy-cancel" @click.stop="cancelPropertyDiyInput(item)"></i>
                              </div>
                            </div>
                          </el-option>
                        </el-select>
                      </template>
                      <template v-else-if="item.type === 'multi_select'">
                        <el-select
                          v-model="form.Property[item.property_id]"
                          multiple
                          clearable
                          filterable
                          :allow-create="canCreatePropertyOption(item)"
                          :default-first-option="canCreatePropertyOption(item)"
                          :reserve-keyword="canCreatePropertyOption(item)"
                          :placeholder="getPropertyPlaceholder(item)"
                          :no-match-text="getPropertyNoMatchText(item)"
                          popper-class="doudian-property-select-dropdown"
                          style="width: 100%;"
                          @visible-change="handlePropertySelectVisible(item, $event)"
                          @change="updatePropertyValue(item, form.Property[item.property_id])"
                        >
                          <el-option
                            v-for="option in item.options || []"
                            :key="option.value_id"
                            :label="option.name"
                            :value="String(option.value_id)"
                          ></el-option>
                          <el-option
                            v-if="canCreatePropertyOption(item)"
                            disabled
                            :value="'diy-footer-' + item.property_id"
                            :class="['property-diy-option', { 'is-editing': isPropertyDiyEditing(item) }]"
                          >
                            <div class="property-diy-footer" @click.stop @mousedown.stop>
                              <el-button
                                v-if="!isPropertyDiyEditing(item)"
                                plain
                                size="mini"
                                type="primary"
                                @click.stop="openPropertyDiyInput(item)"
                              >新建{{ item.property_name }}</el-button>
                              <div v-else class="property-diy-input-row">
                                <el-input
                                  :value="getPropertyDiyDraft(item)"
                                  size="mini"
                                  placeholder="请输入自定义属性"
                                  @input="setPropertyDiyDraft(item, $event)"
                                  @keyup.enter.native.stop="confirmPropertyDiyInput(item)"
                                ></el-input>
                                <i class="el-icon-success property-diy-confirm" @click.stop="confirmPropertyDiyInput(item)"></i>
                                <i class="el-icon-error property-diy-cancel" @click.stop="cancelPropertyDiyInput(item)"></i>
                              </div>
                            </div>
                          </el-option>
                        </el-select>
                      </template>
                      <template v-else-if="isMeasureProperty(item)">
                        <div class="measure-group">
                          <div
                            v-for="(measureItem, measureIndex) in getMeasureRows(item)"
                            :key="'measure-other-' + item.property_id + '-' + measureIndex"
                            class="measure-row"
                          >
                            <div class="measure-row-main">
                              <div
                                v-for="(module, moduleIndex) in getMeasureModules(item, measureItem)"
                                :key="'measure-other-module-' + item.property_id + '-' + measureIndex + '-' + module.module_id"
                                class="measure-module-field"
                              >
                                <el-select
                                  v-if="isMeasureEnumModule(module)"
                                  v-model="measureItem.measure_info.values[moduleIndex].value"
                                  filterable
                                  allow-create
                                  default-first-option
                                  reserve-keyword
                                  :placeholder="getMeasureModulePlaceholder(module)"
                                  @change="syncMeasurePropertyName(item, measureItem)"
                                  >
                                  <el-option
                                    v-for="option in getMeasureModuleOptions(module)"
                                    :key="'measure-other-option-' + module.module_id + '-' + option.value_name"
                                    :label="option.value_name"
                                    :value="option.value_name"
                                  ></el-option>
                                </el-select>
                                <div v-else class="measure-module-input-wrap">
                                  <el-input
                                    v-if="isMeasureNumericModule(module)"
                                    v-model="measureItem.measure_info.values[moduleIndex].value"
                                    type="number"
                                    :min="getMeasureModuleMin(module)"
                                    :max="getMeasureModuleMax(module)"
                                    :step="getMeasureModuleStep(module)"
                                    :placeholder="getMeasureModulePlaceholder(module)"
                                    class="measure-module-number"
                                    @input="syncMeasurePropertyName(item, measureItem)"
                                  ></el-input>
                                  <el-input
                                    v-else
                                    v-model="measureItem.measure_info.values[moduleIndex].value"
                                    :type="getMeasureModuleInputType(module)"
                                    :placeholder="getMeasureModulePlaceholder(module)"
                                    @input="syncMeasurePropertyName(item, measureItem)"
                                  ></el-input>
                                  <el-select
                                    v-if="shouldShowMeasureUnitSelector(module)"
                                    v-model="measureItem.measure_info.values[moduleIndex].unit_id"
                                    class="measure-module-unit-select"
                                    placeholder="单位"
                                    @change="handleMeasureUnitChange(item, measureItem, moduleIndex, $event)"
                                  >
                                    <el-option
                                      v-for="unit in getMeasureModuleUnits(module)"
                                      :key="'measure-other-unit-' + module.module_id + '-' + unit.unit_id"
                                      :label="unit.unit_name"
                                      :value="unit.unit_id"
                                    ></el-option>
                                  </el-select>
                                  <span v-else-if="getMeasureModuleUnitName(item, measureItem, moduleIndex)" class="measure-module-unit-text">{{ getMeasureModuleUnitName(item, measureItem, moduleIndex) }}</span>
                                </div>
                              </div>
                            </div>
                            <el-button size="mini" @click="removeMeasureProperty(item, measureIndex)">删除</el-button>
                          </div>
                          <el-button v-if="isMultiValueMeasureProperty(item)" size="mini" plain class="measure-add-button" @click="addMeasureProperty(item)">新增</el-button>
                        </div>
                      </template>
                      <div v-if="shouldShowPropertyPicUploader(item)" class="property-pic-uploader">
                        <div class="property-pic-header">
                          <span class="property-pic-title">水洗标/吊牌图</span>
                          <span v-if="isRequiredPropertyPic(item)" class="property-pic-required">必传</span>
                          <span class="property-pic-limit">最多1张</span>
                        </div>
                        <div class="property-pic-list">
                          <div
                            v-for="(url, picIndex) in getPropertyPicUrls(item)"
                            :key="'other-prop-pic-' + item.property_id + '-' + picIndex"
                            class="property-pic-card"
                          >
                            <img :src="url" />
                            <div class="property-pic-mask">
                              <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                              <i class="el-icon-delete" @click="removePropertyPic(item, picIndex)"></i>
                            </div>
                          </div>
                          <div
                            v-if="canAddPropertyPic(item)"
                            class="property-pic-card property-pic-add"
                            @click="openPropertyPicDialog(item)"
                          >
                            <i class="el-icon-plus"></i>
                            <span>上传图片</span>
                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="SKU/价格库存" name="sku">
              <div class="sku-page">
                <div v-if="isSpotDeliveryMode" class="sku-delivery-card">
                  <el-form label-width="110px" size="small">
                    <el-form-item label="发货模式" required>
                      <el-radio-group v-model="form.presell_type" @change="markDirty">
                        <el-radio :label="0">现货</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="现货发货时间" required>
                      <el-radio-group v-model="form.delivery_delay_day" @change="markDirty">
                        <el-radio :label="9999">当日发</el-radio>
                        <el-radio :label="1">次日发</el-radio>
                        <el-radio :label="2">48小时</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="sku-summary">
                  <div>
                    <div class="section-title">规格价格库存</div>
                    <div class="field-hint">已生成 {{ specPrices.length }} 个 SKU，均价一半约 ￥{{ halfPrice }}</div>
                  </div>
                  <div class="sku-summary-actions">
                    <div class="action-group">
                    <el-button size="mini" type="primary" plain @click="openSpecDimSortDialog">上下移</el-button>
                    </div>
                    <div class="action-group">
                    <el-checkbox
                      :indeterminate="specSelectionIndeterminate"
                      v-model="allSpecValuesSelected"
                      @change="handleAllSpecValuesChange"
                    >全选</el-checkbox>
                    <el-button size="mini" type="danger" plain @click="batchRemoveSelectedSpecValues">批量删除</el-button>
                    <el-button size="mini" @click="batchClearSelectedStock">批量清库存</el-button>
                    </div>
                    <div class="action-group">
                    <el-popover placement="bottom" width="700" v-model="batchRemarkVisible">
                      <el-radio-group v-model="remarkForm.mode" class="remark-modes">
                        <el-radio :label="1" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式1：</span>
                            <span>增加备注：</span>
                            <el-input v-model="remarkForm.remark1" size="mini" :disabled="remarkForm.mode !== 1" placeholder="请输入" style="width: 380px"></el-input>
                          </div>
                        </el-radio>
                        <el-radio :label="2" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式2：</span>
                            <span>增加前缀：</span>
                            <el-input v-model="remarkForm.prefix" size="mini" :disabled="remarkForm.mode !== 2" placeholder="前缀" style="width: 140px"></el-input>
                            <span>后缀：</span>
                            <el-input v-model="remarkForm.suffix" size="mini" :disabled="remarkForm.mode !== 2" placeholder="后缀" style="width: 140px"></el-input>
                          </div>
                        </el-radio>
                        <el-radio :label="3" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式3：</span>
                            <span>备注关键字替换：</span>
                            <el-tooltip placement="top" :open-delay="300">
                              <div slot="content">备注关键字替换，对于备注中包含关键字即可替换</div>
                              <i class="el-icon-warning-outline remark-help-icon"></i>
                            </el-tooltip>
                            <div class="remark-pairs-inline">
                              <div v-for="(pair, pIndex) in remarkForm.pairs" :key="'rm3-' + pIndex" class="remark-pair-row">
                                <el-input v-model="pair.find" size="mini" :disabled="remarkForm.mode !== 3" placeholder="查找内容" style="width: 140px"></el-input>
                                <span class="remark-arrow">→</span>
                                <el-input v-model="pair.replace" size="mini" :disabled="remarkForm.mode !== 3" placeholder="替换为" style="width: 140px"></el-input>
                                <i v-if="pIndex === 0" class="el-icon-circle-plus-outline remark-add-icon" @click="addRemarkPair"></i>
                                <i v-else class="el-icon-remove-outline remark-del-icon" @click="removeRemarkPair(pIndex)"></i>
                              </div>
                            </div>
                          </div>
                        </el-radio>
                        <el-radio :label="4" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式4：</span>
                            <span>备注精准替换：</span>
                            <el-tooltip placement="top" :open-delay="300">
                              <div slot="content">输入内容必须与商品中的备注完全一致才可替换</div>
                              <i class="el-icon-warning-outline remark-help-icon"></i>
                            </el-tooltip>
                            <div class="remark-pairs-inline">
                              <div v-for="(pair, pIndex) in remarkForm.pairs" :key="'rm4-' + pIndex" class="remark-pair-row">
                                <el-input v-model="pair.find" size="mini" :disabled="remarkForm.mode !== 4" placeholder="查找内容" style="width: 140px"></el-input>
                                <span class="remark-arrow">→</span>
                                <el-input v-model="pair.replace" size="mini" :disabled="remarkForm.mode !== 4" placeholder="替换为" style="width: 140px"></el-input>
                                <i v-if="pIndex === 0" class="el-icon-circle-plus-outline remark-add-icon" @click="addRemarkPair"></i>
                                <i v-else class="el-icon-remove-outline remark-del-icon" @click="removeRemarkPair(pIndex)"></i>
                              </div>
                            </div>
                          </div>
                        </el-radio>
                        <el-radio :label="5" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式5：</span>
                            <span>删除备注关键词：</span>
                            <el-input v-model="remarkForm.remark5" size="mini" type="textarea" :rows="2" :disabled="remarkForm.mode !== 5" placeholder="多个关键词用英文逗号分隔" style="width: 380px"></el-input>
                          </div>
                        </el-radio>
                        <el-radio :label="6" class="remark-mode-row">
                          <div class="remark-mode-inner">
                            <span class="remark-mode-label">方式6：</span>
                            <span>删除备注</span>
                          </div>
                        </el-radio>
                      </el-radio-group>
                      <div class="remark-apply-bar">
                        <el-button size="mini" type="primary" plain @click="applyBatchRemark(false)">应用未填写</el-button>
                        <el-button size="mini" type="primary" plain @click="applyBatchRemark(true)">应用全部</el-button>
                      </div>
<!--                      <el-button slot="reference" size="mini" type="primary" plain>批量备注</el-button>-->
                    </el-popover>
                    <el-button size="mini" @click="skuOpen = !skuOpen">{{ skuOpen ? '收起sku' : '打开sku' }}</el-button>
                    </div>
                  </div>
                </div>

                <div class="sku-editor-layout">
                  <div class="sku-spec-panel" v-show="skuOpen">
                    <div v-if="!specs.length" class="spec-add-inline spec-add-inline-empty">
                      <el-select
                        v-model="newSpecPropertyId"
                        clearable
                        filterable
                        :allow-create="supportSpecPropertyDiy"
                        default-first-option
                        reserve-keyword
                        size="mini"
                        placeholder="选择或输入规格类型"
                        class="spec-inline-add-select"
                      >
                        <el-option
                          v-for="item in specTypeRuleOptions"
                          :key="'spec-type-empty-' + item.property_id"
                          :label="item.property_name"
                          :value="String(item.property_id)"
                          :disabled="isSpecTypeOptionDisabled(item)"
                        ></el-option>
                      </el-select>
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        @click="addSpecDimension"
                      >添加规格类型</el-button>
                    </div>
                    <div
                      v-for="(spec, specIndex) in specs"
                      :key="'spec-' + specIndex"
                      class="spec-card"
                    >
                      <div class="spec-block-head">
                        <div class="spec-block-head-main">
                          <el-select v-model="spec.name" filterable disabled placeholder="请选择" size="mini" class="spec-name-select">
                            <el-option
                              v-for="(row, i) in specs"
                              :key="i"
                              :label="row.name"
                              :value="row.name"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="spec-block-head-actions">
                          <template v-if="specIndex === specs.length - 1 && specs.length < maxSpecNumLimit">
                            <div class="spec-add-inline">
                              <el-select
                                v-model="newSpecPropertyId"
                                clearable
                                filterable
                                :allow-create="supportSpecPropertyDiy"
                                default-first-option
                                reserve-keyword
                                size="mini"
                                placeholder="选择或输入规格类型"
                                class="spec-inline-add-select"
                              >
                                <el-option
                                  v-for="item in specTypeRuleOptions"
                                  :key="'spec-type-' + item.property_id"
                                  :label="item.property_name"
                                  :value="String(item.property_id)"
                                  :disabled="isSpecTypeOptionDisabled(item)"
                                ></el-option>
                              </el-select>
                              <el-button
                                size="mini"
                                type="primary"
                                plain
                                @click="addSpecDimension"
                              >添加规格类型</el-button>
                            </div>
                          </template>
                          <span class="spec-sort-link" @click="openSpecSortDialog(specIndex)">排序</span>
                          <span class="spec-delete-link" @click="removeSpecDimension(specIndex)">删除</span>
                        </div>
                      </div>
                      <el-checkbox-group v-model="selectedSpecValueIds" @change="handleSpecValueSelectionChange" class="spec-values">
                        <div
                          v-for="(value, valueIndex) in spec.values"
                          :key="'spec-value-' + specIndex + '-' + valueIndex"
                          class="spec-value-row"
                        >
                          <el-checkbox :label="value.id"><span class="spec-checkbox-placeholder"></span></el-checkbox>
                          <el-select
                            v-if="!canSpecValueDiy(spec)"
                            v-model="value.value_id"
                            filterable
                            size="mini"
                            placeholder="请选择"
                            class="spec-value-input"
                            @change="handleSpecValueSelect(spec, value)"
                          >
                            <el-option
                              v-for="option in getSpecValueOptions(spec)"
                              :key="'spec-value-option-' + specIndex + '-' + option.value_id"
                              :label="option.value_name"
                              :value="option.value_id"
                              :disabled="isSpecValueOptionDisabled(spec, option, value)"
                            ></el-option>
                          </el-select>
                          <el-input
                            v-else
                            v-model="value.name"
                            size="mini"
                            placeholder="请输入"
                            class="spec-value-input"
                            @input="handleSpecValueInput(value)"
                          ></el-input>
                          <div class="sku-border-check" @click="onClickClearStock(value)">
                            <div class="custom-check" :class="{ checked: value.isClear }">
                              <i class="el-icon-check" v-if="value.isClear"></i>
                            </div>
                            清空库存
                          </div>
                          <el-tooltip content="恢复为加载时的原始规格值" placement="top" :open-delay="300">
                            <div class="sku-icon-btn" @click="restoreSpecValue(specIndex, valueIndex)"><i class="el-icon-refresh-left"></i></div>
                          </el-tooltip>
                          <div class="sku-icon-btn" @click="removeSpecValue(specIndex, valueIndex)"><i class="el-icon-delete"></i></div>
                        </div>
                        <i class="el-icon-circle-plus-outline sku-add-icon" @click="addSpecValue(specIndex)"></i>
                      </el-checkbox-group>
                    </div>
                  </div>

                  <div class="sku-table-panel">
                    <el-table :data="specPrices" border size="mini" class="sku-table" height="620">
                      <el-table-column min-width="240">
                        <template slot="header">
                          <span v-for="(item, index) in specs" :key="'sku-head-' + index" class="sku-spec-head">{{ item.name }}</span>
                        </template>
                        <template slot-scope="scope">
                          <span v-for="(item, index) in scope.row.sell_properties" :key="'sku-prop-' + index" class="sku-spec-cell">{{ item.value_name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="170">
                        <template slot="header">
                          <span>价格</span>
                          <el-tooltip content="此金额为SKU价格均值的一半" placement="top" :open-delay="300">
                            <span class="half-price-tip">￥{{ halfPrice }}</span>
                          </el-tooltip>
                          <el-button size="mini" type="text" class="sku-header-batch-btn" @click.stop="openAdvancedBatchDialog('price')">批量</el-button>
                        </template>
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.price" :min="0" :precision="2" :controls="false" style="width: 100%;"></el-input-number>
                        </template>
                      </el-table-column>
                      <el-table-column width="170">
                        <template slot="header">
                          <span>现货可售库存</span>
                          <el-button size="mini" type="text" class="sku-header-batch-btn" @click.stop="openAdvancedBatchDialog('stock')">批量</el-button>
                        </template>
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.stock_num" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
                        </template>
                      </el-table-column>
                      <el-table-column width="220">
                        <template slot="header">
                          <span>SKU商家编码(可不填)</span>
                          <el-button size="mini" type="text" class="sku-header-batch-btn" @click.stop="openAdvancedBatchDialog('code')">批量</el-button>
                        </template>
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.code" placeholder="SKU编码"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column width="130" align="center">
                        <template slot="header">
                          <span>SKU状态</span>
                          <el-tooltip placement="top" :open-delay="300">
                            <div slot="content" style="width: 200px">SKU操作下架后，消费者在抖音不能选中此SKU进行购买，更多操作规则详见 <a href="https://school.jinritemai.com/doudian/web/article/aHzP5tSxzHcu" target="_blank">SKU上下架手册</a></div>
                            <i class="el-icon-warning-outline" style="cursor:pointer;margin-right:4px;color:#909399"></i>
                          </el-tooltip>
                          <el-popover placement="bottom" width="300" trigger="click" popper-class="sku-batch-popover" v-model="visibleSkuStatus">
                            <div class="sku-batch-form-wrap sku-status-popover">
                              <span>批量设置为</span>
                              <el-switch v-model="allSkuStatus"></el-switch>
                              <div class="field-hint" v-if="!allSkuStatus">至少保留一个 SKU 上架。</div>
                              <el-button size="mini" type="primary" @click="applyAllSkuStatus">应用全部</el-button>
                            </div>
                            <el-button slot="reference" size="mini" type="text" class="sku-header-batch-btn">批量</el-button>
                          </el-popover>
                        </template>
                        <template slot-scope="scope">
                          <el-switch v-model="scope.row.sku_status"></el-switch>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane v-if="supportsSizeChart" label="尺码表" name="size-chart">
              <div class="size-chart-page" v-loading="sizeTemplateLoading || sizeChartLoading">
                <div class="size-chart-toolbar">
                  <div>
                    <div class="section-title">尺码表</div>
                    <div class="field-hint">尺码行会跟随规格中的尺码值自动同步。</div>
                  </div>
                  <el-popover
                    placement="bottom-end"
                    width="420"
                    trigger="click"
                    v-model="sizeChartSettingVisible"
                  >
                    <div class="size-setting-panel">
                      <div class="size-setting-group" v-if="sizeChartImportantOptions.length">
                        <div class="size-setting-title">重要参数</div>
                        <div class="size-setting-options">
                          <el-checkbox
                            v-for="option in sizeChartImportantOptions"
                            :key="'size-important-' + option.key"
                            v-model="option.selected"
                            @change="syncSizeChartWithSpecs(); markDirty()"
                          >{{ option.label }}</el-checkbox>
                        </div>
                      </div>
                      <div class="size-setting-group" v-if="sizeChartOtherOptions.length">
                        <div class="size-setting-title">其他参数</div>
                        <div class="size-setting-options">
                          <el-checkbox
                            v-for="option in sizeChartOtherOptions"
                            :key="'size-other-' + option.key"
                            v-model="option.selected"
                            @change="syncSizeChartWithSpecs(); markDirty()"
                          >{{ option.label }}</el-checkbox>
                        </div>
                      </div>
                    </div>
                    <el-button slot="reference" size="small">设置尺码参数</el-button>
                  </el-popover>
                </div>

                <div v-if="!sizeChartHasRows" class="size-chart-empty">
                  <el-empty description="当前还没有可编辑的尺码行，请先在规格中补充尺码值。" :image-size="90"></el-empty>
                </div>
                <div v-else class="size-chart-table-wrap">
                  <table class="size-chart-table">
                    <thead>
                      <tr>
                        <th class="size-chart-size-col">尺码</th>
                        <th
                          v-for="column in sizeChartSelectedColumns"
                          :key="'size-head-' + column.key"
                          class="size-chart-param-col"
                        >
                          <div class="size-chart-head-cell">
                            <div class="size-chart-head-title">
                              <span v-if="column.group === 'important'" class="size-important-badge">重要</span>
                              <span>{{ column.label }}</span>
                            </div>
                            <el-checkbox
                              v-model="column.range"
                              @change="toggleSizeChartRange(column.key, $event)"
                            >区间值</el-checkbox>
                          </div>
                        </th>
                        <th class="size-chart-action-col">操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, rowIndex) in sizeChart.rows" :key="'size-row-' + row.size + '-' + rowIndex">
                        <td class="size-chart-size-cell">{{ row.size }}</td>
                        <td
                          v-for="column in sizeChartSelectedColumns"
                          :key="'size-cell-' + row.size + '-' + column.key"
                          class="size-chart-param-cell"
                        >
                          <div v-if="column.range" class="size-chart-range-inputs">
                            <el-input
                              v-model="row.values[column.key].min"
                              :placeholder="getSizeChartCellPlaceholder(column, 'min')"
                            ></el-input>
                            <span class="size-chart-range-sep">-</span>
                            <el-input
                              v-model="row.values[column.key].max"
                              :placeholder="getSizeChartCellPlaceholder(column, 'max')"
                            ></el-input>
                          </div>
                          <el-input
                            v-else
                            v-model="row.values[column.key].value"
                            :placeholder="getSizeChartCellPlaceholder(column)"
                          ></el-input>
                        </td>
                        <td class="size-chart-action-cell">
                          <el-button
                            type="text"
                            :disabled="rowIndex === 0"
                            @click="moveSizeChartRow(rowIndex, -1)"
                          >上移</el-button>
                          <el-button
                            type="text"
                            :disabled="rowIndex === sizeChart.rows.length - 1"
                            @click="moveSizeChartRow(rowIndex, 1)"
                          >下移</el-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="商品图片" name="images">
              <div class="editor-section">
                <div class="section-title-row">
                  <div class="section-title">商品主图</div>
                  <el-button
                    size="small"
                    class="critical-section-action"
                    icon="el-icon-edit-outline"
                    :loading="predictionLoadingSource === 'images'"
                    :disabled="!!predictionLoadingSource"
                    @click="openMainImageEditor"
                  >修改主图</el-button>
                </div>
                <div class="field-hint" style="margin-bottom:10px">最多 5 张；修改、增删和排序请进入主图编辑弹窗。</div>
                <div class="image-list">
                  <div v-for="(url, index) in form.pic" :key="'pic-' + index" class="image-item image-card">
                    <img :src="url" class="thumb" />
                    <div class="img-hover-mask">
                      <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="editor-section">
                <div class="section-title">主图视频</div>
                <div class="field-hint" style="margin-bottom:10px">选择抖店素材中心视频，保存时提交主图视频ID。</div>
                <div class="image-list">
                  <div v-if="form.material_video_id" class="image-item image-card material-video-card">
                    <img v-if="materialVideoCoverUrl" :src="materialVideoCoverUrl" class="thumb" />
                    <video v-else-if="materialVideoPlayUrl" :src="materialVideoPlayUrl" class="thumb" muted></video>
                    <div v-else class="thumb empty-thumb video-empty-thumb">
                      <i class="el-icon-video-camera"></i>
                      <span>{{ form.material_video_id }}</span>
                    </div>
                    <div class="img-hover-mask">
                      <i class="el-icon-view" @click="previewCurrentMaterialVideo"></i>
                      <i class="el-icon-edit" @click="openMaterialVideoDialog"></i>
                      <i class="el-icon-delete" @click="clearMaterialVideo"></i>
                    </div>
                  </div>
                  <div v-else class="image-item image-slot" @click="openMaterialVideoDialog"><i class="el-icon-plus"></i></div>
                </div>
              </div>

              <div class="editor-section">
                <div class="section-title">主图 3:4</div>
                <div class="field-hint" style="margin-bottom:10px">最多 5 张，长按图片可拖动排序。</div>
                <div class="image-list">
                  <draggable v-model="form.main_image_three_to_four" :animation="200" class="image-drag-list" @end="onImageDragEnd">
                    <div v-for="(url, index) in form.main_image_three_to_four" :key="'34-' + index" class="image-item image-card">
                      <img :src="url" class="thumb portrait-thumb" />
                      <div class="img-hover-mask">
                        <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                        <i class="el-icon-delete" @click="removeImage('main_image_three_to_four', index)"></i>
                      </div>
                    </div>
                  </draggable>
                  <div v-for="n in mainImageAddSlots" :key="'34-add-' + n" class="image-item image-slot" @click="openImageDialog('main_image_three_to_four', true)"><i class="el-icon-plus"></i></div>
                </div>
              </div>

              <div class="editor-section" v-if="specPicRows.length">
                <div class="section-title">规格图</div>
                <div class="image-list spec-pic-list">
                  <div v-for="(item, index) in specPicRows" :key="'spec-pic-' + index" class="image-item spec-pic-item image-card">
                    <div class="spec-pic-label">{{ item.label }}</div>
                    <img v-if="item.pic" :src="item.pic" class="thumb" />
                    <div v-else class="thumb empty-thumb">未设置</div>
                    <div class="img-hover-mask">
                      <i class="el-icon-picture-outline" @click="openImageDialog('spec_pic', false, index)"></i>
                      <i v-if="item.pic" class="el-icon-view" @click="previewDialog = { visible: true, url: item.pic }"></i>
                      <i v-if="item.pic" class="el-icon-delete" @click="clearSpecPic(index)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="白底图/导购图" name="guide">
              <div class="editor-section">
                <div class="section-title">白底图</div>
                <div class="image-list">
                  <div v-if="form.white_back_ground_pic_url" class="image-item image-card">
                    <img :src="form.white_back_ground_pic_url" class="thumb" />
                    <div class="img-hover-mask">
                      <i class="el-icon-view" @click="previewDialog = { visible: true, url: form.white_back_ground_pic_url }"></i>
                      <i class="el-icon-delete" @click="form.white_back_ground_pic_url = ''; markDirty()"></i>
                    </div>
                  </div>
                  <div v-else class="image-item image-slot" @click="openImageDialog('white_back_ground_pic_url', false)"><i class="el-icon-plus"></i></div>
                </div>
              </div>

              <div class="editor-section">
                <div class="section-title">导购图</div>
                <div class="image-list">
                  <div v-if="form.long_pic_url" class="image-item image-card">
                    <img :src="form.long_pic_url" class="thumb portrait-thumb" />
                    <div class="img-hover-mask">
                      <i class="el-icon-view" @click="previewDialog = { visible: true, url: form.long_pic_url }"></i>
                      <i class="el-icon-delete" @click="form.long_pic_url = ''; markDirty()"></i>
                    </div>
                  </div>
                  <div v-else class="image-item image-slot image-slot-portrait" @click="openImageDialog('long_pic_url', false)"><i class="el-icon-plus"></i></div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="商品详情图" name="detail">
              <div class="editor-section">
                <div class="section-title">商品详情图</div>
                <div class="field-hint" style="margin-bottom:10px">已上传 {{ form.description.length }}/50 张，长按图片可拖动排序。</div>
                <div class="image-list detail-image-list">
                  <draggable v-model="form.description" :animation="200" class="image-drag-list" @end="onImageDragEnd">
                    <div v-for="(url, index) in form.description" :key="'desc-' + index" class="image-item image-card">
                      <img :src="url" class="thumb detail-thumb" />
                      <div class="img-hover-mask">
                        <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                        <i class="el-icon-delete" @click="removeImage('description', index)"></i>
                      </div>
                    </div>
                  </draggable>
                  <div v-for="n in descAddSlots" :key="'desc-add-' + n" class="image-item image-slot" @click="openImageDialog('description', true)"><i class="el-icon-plus"></i></div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="其他信息" name="other">
              <div class="editor-section">
                <div class="section-title">其他信息</div>
                <div v-if="qualificationRules.length" class="quality-list">
                  <div
                    v-for="item in qualificationRules"
                    :key="'quality-' + item.key"
                    class="quality-row"
                  >
                    <div class="quality-label">
                      <span v-if="item.is_required" class="quality-required">*</span>
                      <span>{{ item.name }}</span>
                    </div>
                    <div class="quality-content">
                      <div v-if="item.text_list.length" class="quality-hints">
                        <div v-for="(text, textIndex) in item.text_list" :key="'quality-text-' + item.key + '-' + textIndex">{{ text }}</div>
                      </div>
                      <div class="quality-image-list">
                        <div
                          v-for="(url, imageIndex) in getQualityUrls(item)"
                          :key="'quality-img-' + item.key + '-' + imageIndex"
                          class="quality-image-card"
                        >
                          <img :src="url" />
                          <div class="quality-image-mask">
                            <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
                            <i class="el-icon-delete" @click="removeQualityImage(item, imageIndex)"></i>
                          </div>
                        </div>
                        <div
                          v-if="canAddQualityImage(item)"
                          class="quality-image-card quality-image-add"
                          @click="openQualityImageDialog(item)"
                        >
                          <i class="el-icon-plus"></i>
                          <span>{{ getQualityUrls(item).length }}/20</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <el-empty v-else description="当前类目暂无资质要求" :image-size="80"></el-empty>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
          </el-main>
        </el-container>
      </div>
      <span slot="footer" class="dialog-footer">
        <span class="dialog-footer-meta">
          <span v-if="dirty" class="dirty-tip">有未保存修改</span>
        </span>
        <span class="dialog-footer-actions">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" :loading="saving" :disabled="!!predictionLoadingSource" @click="submit">保存修改</el-button>
        </span>
      </span>
    </el-dialog>

    <el-dialog
      title="修改商品标题"
      :visible.sync="titleEditor.visible"
      width="620px"
      custom-class="critical-edit-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="critical-edit-dialog-intro">
        <i class="el-icon-edit-outline"></i>
        <div>
          <div class="critical-edit-dialog-intro-title">先修改标题，再确认预测类目</div>
          <div class="critical-edit-dialog-intro-desc">选择预测类目后，新标题才会应用到商品。</div>
        </div>
      </div>
      <el-form label-width="90px" size="small">
        <el-form-item label="商品标题" required>
          <el-input v-model="titleEditor.value" maxlength="60" placeholder="请输入商品标题">
            <template slot="suffix">
              <span class="char-counter" :class="{ 'char-over': titleEditorCharCount > 60 || (titleEditorCharCount > 0 && titleEditorCharCount < 8) }">{{ titleEditorCharCount }}/60</span>
            </template>
          </el-input>
          <div class="field-hint">至少8个字符（4个汉字），最多60个字符（30个汉字）。</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="critical-edit-dialog-footer">
        <el-button @click="titleEditor.visible = false">取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-position"
          :loading="predictionLoadingSource === 'title'"
          @click="confirmTitleEdit"
        >确认并预测类目</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改商品主图"
      :visible.sync="mainImageEditor.visible"
      width="760px"
      custom-class="critical-edit-dialog critical-image-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="critical-edit-dialog-intro">
        <i class="el-icon-picture-outline"></i>
        <div>
          <div class="critical-edit-dialog-intro-title">集中完成主图修改</div>
          <div class="critical-edit-dialog-intro-desc">支持 3～5 张，拖动图片可调整顺序；确认后将预测类目。</div>
        </div>
        <span class="critical-image-count">{{ mainImageEditor.images.length }}/5</span>
      </div>
      <div class="image-list critical-image-editor-list">
        <draggable v-model="mainImageEditor.images" :animation="200" class="image-drag-list">
          <div v-for="(url, index) in mainImageEditor.images" :key="'main-image-draft-' + index" class="image-item image-card">
            <img :src="url" class="thumb" />
            <span class="critical-image-index">{{ index + 1 }}</span>
            <div class="img-hover-mask">
              <i class="el-icon-view" @click="previewDialog = { visible: true, url }"></i>
              <i class="el-icon-delete" @click="removeMainImageDraft(index)"></i>
            </div>
          </div>
        </draggable>
        <div
          v-for="n in mainImageEditorAddSlots"
          :key="'main-image-draft-add-' + n"
          class="image-item image-slot"
          aria-label="添加商品主图"
          @click="openImageDialog('main_image_draft', true)"
        >
          <i class="el-icon-plus"></i>
          <span>添加主图</span>
        </div>
      </div>
      <span slot="footer" class="critical-edit-dialog-footer">
        <el-button @click="mainImageEditor.visible = false">取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-position"
          :loading="predictionLoadingSource === 'images'"
          @click="confirmMainImageEdit"
        >确认并预测类目</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择抖店预测类目"
      :visible.sync="categoryPrediction.visible"
      width="620px"
      custom-class="critical-edit-dialog critical-category-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="critical-edit-dialog-intro prediction-summary">
        <i class="el-icon-data-analysis"></i>
        <div>
          <div class="critical-edit-dialog-intro-title">类目预测已完成</div>
          <div class="critical-edit-dialog-intro-desc">本次预测由{{ predictionSourceText }}触发，请选择一个可用类目。</div>
        </div>
      </div>
      <el-radio-group v-model="categoryPrediction.selectedLeafId" class="prediction-category-list">
        <el-radio
          v-for="item in categoryPrediction.items"
          :key="item.category_leaf_id"
          :label="item.category_leaf_id"
          :disabled="!item.available"
          border
        >
          <span>{{ item.category_path_text || item.category_leaf_id }}</span>
          <span v-if="!item.available" class="prediction-unavailable">（店铺资质不可用）</span>
        </el-radio>
      </el-radio-group>
      <span slot="footer" class="critical-edit-dialog-footer">
        <el-button @click="categoryPrediction.visible = false">取消</el-button>
        <el-button type="primary" icon="el-icon-check" @click="confirmPredictedCategory">确认类目</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量设置价格" :visible.sync="visiblePrice" width="620px" append-to-body :close-on-click-modal="false" @open="initBatchRange">
      <div class="sku-batch-form-wrap">
        <el-form label-width="90px" size="mini" class="sku-batch-form">
          <el-form-item label="修改方式">
            <el-radio-group v-model="priceBatch.mode" size="mini" class="batch-toggle-group">
              <el-radio-button :label="1">统一价格</el-radio-button>
              <el-radio-button :label="2">公式计算</el-radio-button>
              <el-radio-button :label="3">设置小数</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="统一价格" v-if="priceBatch.mode === 1">
            <el-input-number v-model="priceBatch.value" :min="0" :precision="2" :controls="false" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="公式计算" v-if="priceBatch.mode === 2">
            <div class="inline-field">
              <span>当前价 x</span>
              <el-input-number v-model="priceBatch.rate" :precision="2" :controls="false" placeholder="百分比"></el-input-number>
              <span>% +</span>
              <el-input-number v-model="priceBatch.add" :precision="2" :controls="false"></el-input-number>
              <span>-</span>
              <el-input-number v-model="priceBatch.dec" :precision="2" :controls="false"></el-input-number>
            </div>
          </el-form-item>
          <el-form-item label="小数位" v-if="priceBatch.mode === 3">
            <el-input-number v-model="priceBatch.decimal" :min="0" :max="99" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
            <div class="field-hint">批量修改小数点后的数字，例如商品价格为15.45，设置9，则变为15.9</div>
          </el-form-item>
          <el-form-item label="修改范围">
            <el-radio-group v-model="priceBatch.range" size="mini" class="batch-toggle-group">
              <el-radio-button label="all">全部SKU</el-radio-button>
              <el-radio-button label="selected">指定规格SKU</el-radio-button>
            </el-radio-group>
            <div class="batch-range-select" v-if="priceBatch.range === 'selected'">
              <div v-for="(dim, dimIndex) in batchRange.specs" :key="'price-dim-' + dimIndex" class="batch-range-dim">
                <el-checkbox :indeterminate="dim.indeterminate" v-model="dim.checkAll" @change="onBatchCheckAll(dimIndex)">全选{{ dim.name }}</el-checkbox>
                <el-checkbox-group v-model="dim.selectedIds" @change="onBatchValueChange(dimIndex)" class="batch-range-values">
                  <el-checkbox v-for="val in dim.values" :key="val.id" :label="val.id">{{ val.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="applyAdvancedBatchPrice">应用价格</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="批量设置库存" :visible.sync="visibleStock" width="620px" append-to-body :close-on-click-modal="false" @open="initBatchRange">
      <div class="sku-batch-form-wrap">
        <el-form label-width="90px" size="mini" class="sku-batch-form">
          <el-form-item label="修改方式">
            <el-radio-group v-model="stockBatch.mode" size="mini" class="batch-toggle-group">
              <el-radio-button :label="1">统一库存</el-radio-button>
              <el-radio-button :label="2">增加库存</el-radio-button>
              <el-radio-button :label="3">减少库存</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="库存值" v-if="stockBatch.mode === 1">
            <el-input-number v-model="stockBatch.value" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="增加数量" v-if="stockBatch.mode === 2">
            <el-input-number v-model="stockBatch.add" :min="0" :precision="0" :controls="false" style="width: 100%;"></el-input-number>
          </el-form-item>
          <el-form-item label="减少数量" v-if="stockBatch.mode === 3">
            <div class="inline-field">
              <el-input-number v-model="stockBatch.dec" :min="0" :precision="0" :controls="false"></el-input-number>
              <span>且不小于</span>
              <el-input-number v-model="stockBatch.min" :min="0" :precision="0" :controls="false"></el-input-number>
            </div>
          </el-form-item>
          <el-form-item label="保护">
            <el-checkbox v-model="stockBatch.skipZero">库存为 0 的 SKU 不调整</el-checkbox>
          </el-form-item>
          <el-form-item label="修改范围">
            <el-radio-group v-model="stockBatch.range" size="mini" class="batch-toggle-group">
              <el-radio-button label="all">全部SKU</el-radio-button>
              <el-radio-button label="selected">指定规格SKU</el-radio-button>
            </el-radio-group>
            <div class="batch-range-select" v-if="stockBatch.range === 'selected'">
              <div v-for="(dim, dimIndex) in batchRange.specs" :key="'stock-dim-' + dimIndex" class="batch-range-dim">
                <el-checkbox :indeterminate="dim.indeterminate" v-model="dim.checkAll" @change="onBatchCheckAll(dimIndex)">全选{{ dim.name }}</el-checkbox>
                <el-checkbox-group v-model="dim.selectedIds" @change="onBatchValueChange(dimIndex)" class="batch-range-values">
                  <el-checkbox v-for="val in dim.values" :key="val.id" :label="val.id">{{ val.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="applyAdvancedBatchStock">应用库存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="批量设置编码" :visible.sync="visibleCode" width="520px" append-to-body :close-on-click-modal="false" @open="initBatchRange">
      <div class="sku-batch-form-wrap">
        <el-form label-width="90px" size="mini" class="sku-batch-form">
          <el-form-item label="编码内容">
            <el-input v-model="codeBatch.value"></el-input>
          </el-form-item>
          <el-form-item label="修改范围">
            <el-radio-group v-model="codeBatch.range" size="mini" class="batch-toggle-group">
              <el-radio-button label="all">全部SKU</el-radio-button>
              <el-radio-button label="selected">指定规格SKU</el-radio-button>
            </el-radio-group>
            <div class="batch-range-select" v-if="codeBatch.range === 'selected'">
              <div v-for="(dim, dimIndex) in batchRange.specs" :key="'code-dim-' + dimIndex" class="batch-range-dim">
                <el-checkbox :indeterminate="dim.indeterminate" v-model="dim.checkAll" @change="onBatchCheckAll(dimIndex)">全选{{ dim.name }}</el-checkbox>
                <el-checkbox-group v-model="dim.selectedIds" @change="onBatchValueChange(dimIndex)" class="batch-range-values">
                  <el-checkbox v-for="val in dim.values" :key="val.id" :label="val.id">{{ val.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="applyAdvancedBatchCode">应用编码</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog
      :title="imageDialog.title"
      :visible.sync="imageDialog.visible"
      width="980px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="material-dialog">
        <div class="material-sidebar">
          <div class="material-media-tabs">
            <div
              v-for="item in visibleMaterialMediaTypes"
              :key="'material-media-' + item.id"
              class="material-media-tab"
              :class="{ active: materialMediaType === item.id }"
              @click="switchMaterialMediaType(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="material-root-tabs">
            <div
              v-for="item in visibleMaterialRootCategories"
              :key="'material-root-' + item.id"
              class="material-root-tab"
              :class="{ active: String(materialRootCategory) === String(item.id) }"
              @click="switchMaterialRootCategory(item.id)"
            >
              {{ item.name }}
            </div>
          </div>
          <div
            v-for="item in materialFolders"
            :key="item.folder_id"
            class="material-folder"
            :class="{ active: String(materialFolderId) === String(item.folder_id) }"
            @click="selectMaterialFolder(item)"
          >
            <i class="el-icon-folder-opened"></i>
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="material-main">
          <div class="material-toolbar">
            <div class="field-hint">{{ materialToolbarHint }}</div>
            <div>
              <el-upload
                v-if="materialMediaType === 'image' || materialMediaType === 'video'"
                action=""
                :accept="materialUploadAccept"
                :show-file-list="false"
                :http-request="uploadDoudianMaterial"
                :before-upload="beforeDoudianMaterialUpload"
              >
                <el-button size="mini" type="primary" :loading="materialUploading">本地上传到抖店</el-button>
              </el-upload>
              <el-dropdown
                trigger="click"
                :hide-on-click="true"
                :disabled="materialDeleting"
                @command="handleMaterialDeleteCommand"
              >
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  :loading="materialDeleting"
                >一键删素材<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="to_recycle">移入回收站</el-dropdown-item>
                  <el-dropdown-item command="delete_forever">彻底删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="mini" :loading="materialLoading" @click="loadMaterialFolderFiles">刷新</el-button>
            </div>
          </div>
          <div v-loading="materialLoading" class="material-grid">
            <div
              v-for="item in materialList"
              :key="item.material_id || item.byte_url"
              class="material-card"
              :class="{ selected: isMaterialSelected(item) }"
              @click="toggleMaterialItem(item)"
            >
              <img v-if="materialMediaType === 'image'" :src="item.byte_url" />
              <img v-else-if="getMaterialVideoCoverUrl(item)" :src="getMaterialVideoCoverUrl(item)" class="material-video-thumb" />
              <video v-else-if="getMaterialVideoPlayUrl(item)" :src="getMaterialVideoPlayUrl(item)" class="material-video-thumb" muted></video>
              <div v-else class="material-video-thumb material-video-placeholder">
                <i class="el-icon-video-camera"></i>
                <span>{{ getMaterialSelectValue(item) }}</span>
              </div>
              <div class="material-card-mask">
                <el-button
                  size="mini"
                  type="primary"
                  class="material-use-btn"
                  @click.stop="useMaterialItem(item)"
                >使用</el-button>
              </div>
              <div class="material-size" v-if="item.photo_info">{{ item.photo_info.width }} x {{ item.photo_info.height }}</div>
              <i v-if="materialMediaType === 'image'" class="el-icon-view material-preview" @click.stop="previewDialog = { visible: true, url: item.byte_url }"></i>
              <i v-else class="el-icon-view material-preview" @click.stop="previewMaterialVideoItem(item)"></i>
            </div>
            <el-empty v-if="!materialList.length && !materialLoading" :description="materialEmptyText" :image-size="80"></el-empty>
          </div>
          <el-pagination
            background
            small
            :current-page="materialPagination.page"
            :page-size="materialPagination.size"
            :total="materialPagination.total"
            :page-sizes="[15, 25, 30, 50, 100]"
            layout="total, sizes, prev, pager, next"
            @size-change="handleMaterialSizeChange"
            @current-change="handleMaterialPageChange"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer">
        <span class="field-hint">已选择 {{ imageDialog.selectedUrls.length }}/{{ imageDialog.maxSelect }} {{ materialSelectUnit }}</span>
        <el-button size="small" @click="imageDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmMaterialImages">使用所选</el-button>
      </span>
    </el-dialog>

    <el-dialog title="自定义排序" :visible.sync="specSortDialog.visible" width="420px" append-to-body>
      <div class="field-hint" style="margin-bottom:10px">长按拖动调整规格值顺序</div>
      <draggable v-model="specSortDialog.list" :animation="200" class="spec-sort-list">
        <div v-for="(value, index) in specSortDialog.list" :key="'sort-' + index" class="spec-sort-item">
          <i class="el-icon-rank drag-handle"></i>
          <span>{{ value.name || ('规格值' + (index + 1)) }}</span>
        </div>
      </draggable>
      <div v-if="!specSortDialog.list.length" class="field-hint">暂无规格值</div>
      <span slot="footer">
        <el-button size="small" @click="resetSpecSort">顺序重置</el-button>
        <el-button size="small" @click="specSortDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmSpecSort">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="规格排序" :visible.sync="specDimSortDialog.visible" width="420px" append-to-body>
      <div class="field-hint" style="margin-bottom:10px;color:#e6a23c">重排规格会清空规格图，请谨慎操作</div>
      <draggable v-model="specDimSortDialog.list" :animation="200" class="spec-sort-list">
        <div v-for="(spec, index) in specDimSortDialog.list" :key="'dim-sort-' + index" class="spec-sort-item">
          <i class="el-icon-rank drag-handle"></i>
          <span>{{ spec.name || ('规格' + (index + 1)) }}</span>
        </div>
      </draggable>
      <span slot="footer">
        <el-button size="small" @click="specDimSortDialog.visible = false">取消</el-button>
        <el-button size="small" type="primary" @click="confirmSpecDimSort">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="previewDialog.type === 'video' ? '视频预览' : '图片预览'" :visible.sync="previewDialog.visible" width="760px" append-to-body>
      <video v-if="previewDialog.type === 'video' && previewDialog.url" :src="previewDialog.url" class="preview-video" controls autoplay></video>
      <img v-else-if="previewDialog.url" :src="previewDialog.url" class="preview-image" />
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
import config from '@/assets/js/conf/config'
import { uploadDirectOss } from '@/assets/js/utils/ossDirectUpload'

function clone(data) {
  return JSON.parse(JSON.stringify(data))
}

function createEmptySizeChartState() {
  return {
    template_id: '',
    template_sub_type: '',
    title: '',
    desc: '',
    tempName: '',
    options: [],
    rows: [],
  }
}

function getLengthConsideringChineseChars(value) {
  if (!value) return 0
  let length = 0
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i)
    if (code > 127 || (code >= 0x4e00 && code <= 0x9fff)) {
      length += 2
    } else {
      length += 1
    }
  }
  return length
}

export default {
  name: 'DoudianProductEditorDialog',
  components: { draggable },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: [Number, String],
      default: '',
    },
    searchParams: {
      type: Object,
      default: () => ({}),
    },
    goodsStatus: {
      type: [Number, String],
      default: 0,
    },
    tabStatus: {
      type: String,
      default: '',
    },
    sidebarMode: {
      type: String,
      default: 'provided',
    },
    initialSidebarPage: {
      type: [Number, String],
      default: 1,
    },
    initialSidebarPageSize: {
      type: [Number, String],
      default: 20,
    },
    sidebarItems: {
      type: Array,
      default: () => [],
    },
    shopType: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      dirty: false,
      activeTab: 'info',
      bootstrapping: false,
      freightLoading: false,
      sizeTemplateLoading: false,
      productInfo: {},
      brandList: [],
      freightTemplates: [],
      sizeTemplateList: [],
      materialFolders: [],
      materialList: [],
      materialMediaType: 'image',
      materialMediaTypes: [
        { id: 'image', name: '图片' },
        { id: 'video', name: '视频' },
      ],
      materialRootCategory: '0',
      materialRootCategories: [
        { id: '0', name: '开放平台', media_type: 'image' },
        { id: '1', name: '我的图片', media_type: 'image' },
        { id: '2', name: '我的视频', media_type: 'video' },
      ],
      materialVideoCoverUrl: '',
      materialVideoPlayUrl: '',
      updateRule: {},
      categoryProperties: [],
      newSpecPropertyId: '',
      supportTemplateSubType: '',
      materialFolderId: '',
      materialLoading: false,
      materialUploading: false,
      materialDeleting: false,
      materialPagination: {
        page: 1,
        size: 15,
        total: 0,
      },
      form: this.createEmptyForm(),
      specs: [],
      specPrices: [],
      specsBackup: [],
      specPricesBackup: [],
      selectedSpecValueIds: [],
      allSpecValuesSelected: false,
      specSelectionIndeterminate: false,
      skuOpen: true,
      batchEditVisible: false,
      batchRemarkVisible: false,
      visiblePrice: false,
      visibleStock: false,
      visibleCode: false,
      visibleSkuStatus: false,
      batchForm: {
        range: 'all',
        price: null,
        stock: null,
        code: '',
        sku_status: true,
      },
      priceBatch: {
        mode: 1,
        value: null,
        rate: 100,
        add: 0,
        dec: 0,
        decimal: null,
        range: 'all',
      },
      stockBatch: {
        mode: 1,
        value: null,
        add: 0,
        dec: 0,
        min: 0,
        skipZero: false,
        range: 'all',
      },
      codeBatch: {
        value: '',
        range: 'all',
      },
      allSkuStatus: true,
      remarkForm: {
        mode: 1,
        remark1: '',
        prefix: '',
        suffix: '',
        pairs: [{ find: '', replace: '' }],
        remark5: '',
      },
      batchRange: {
        specs: [],
      },
      threeGuarantees: {
        service_type: '',
        duration: '',
      },
      sizeChartLoading: false,
      sizeChartSettingVisible: false,
      sizeChart: createEmptySizeChartState(),
      initialSizeChartSnapshot: '',
      previewDialog: {
        visible: false,
        url: '',
        type: 'image',
      },
      imageDialog: {
        visible: false,
        target: '',
        multiple: true,
        index: -1,
        propertyId: '',
        title: '添加图片',
        existingUrls: [],
        selectedUrls: [],
        maxSelect: 1,
      },
      titleEditor: {
        visible: false,
        value: '',
      },
      mainImageEditor: {
        visible: false,
        images: [],
      },
      predictionLoadingSource: '',
      recommendIds: {},
      criticalPredictionSnapshot: {
        title: '',
        images: [],
        category_leaf_id: 0,
      },
      categoryPrediction: {
        visible: false,
        source: '',
        recommendId: '',
        selectedLeafId: 0,
        items: [],
        predictedSnapshot: {
          title: '',
          images: [],
        },
      },
      sidebarList: [],
      sidebarLoading: false,
      sidebarPagination: {
        page: 1,
        page_size: 20,
        total: 0,
      },
      sidebarSearch: {
        title: '',
        platform_product_id: '',
      },
      currentEditingId: '',
      propertyDiyDrafts: {},
      propertyDiyEditing: {},
      initialDirtySnapshot: '',
      specSortDialog: {
        visible: false,
        specIndex: -1,
        list: [],
      },
      specDimSortDialog: {
        visible: false,
        list: [],
      },
    }
  },
  computed: {
    currentCategoryLeafId() {
      if (Array.isArray(this.form.categoryLeafPath) && this.form.categoryLeafPath.length) {
        return Number(this.form.categoryLeafPath[this.form.categoryLeafPath.length - 1] || 0)
      }
      return Number(this.form.category_leaf_id || 0)
    },
    currentCategoryPath() {
      return this.form.categoryPathText || (this.currentCategoryLeafId ? String(this.currentCategoryLeafId) : '')
    },
    titleNeedsPrediction() {
      return String(this.form.name || '').trim() !== String(this.criticalPredictionSnapshot.title || '').trim()
    },
    mainImagesNeedPrediction() {
      return JSON.stringify(this.form.pic || []) !== JSON.stringify(this.criticalPredictionSnapshot.images || [])
    },
    categoryNeedsPrediction() {
      return Number(this.currentCategoryLeafId) !== Number(this.criticalPredictionSnapshot.category_leaf_id || 0)
    },
    predictionSourceText() {
      const map = {
        title: '标题确认',
        images: '主图确认',
        category: '类目修改',
      }
      return map[this.categoryPrediction.source] || '类目预测'
    },
    isSpotDeliveryMode() {
      return Number(this.form.presell_type || 0) === 0
    },
    brandOptions() {
      const options = [
        { brand_id: '596120136', id: '596120136', name_cn: '无品牌', name: '无品牌', display_name: '无品牌' },
      ]
      const seen = new Set(['596120136'])
      ;(this.brandList || []).forEach(item => {
        const id = String(item.brand_id || item.id || '')
        if (!id || seen.has(id)) return
        seen.add(id)
        options.push({
          ...item,
          display_name: item.name_cn || item.name_en || item.name || id,
        })
      })
      const current = String(this.form.standard_brand_id || '')
      if (current && !seen.has(current)) {
        options.push({ brand_id: current, id: current, name_cn: current, name: current, display_name: current })
      }
      return options
    },
    brandPropertyItem() {
      return (this.categoryProperties || []).find(item => item.property_name === '品牌') || null
    },
    specPicRows() {
      if (!this.specs.length || !this.specs[0].values) return []
      return this.specs[0].values.map((value, index) => ({
        spec_detail_id: value.id,
        label: value.name || `规格${index + 1}`,
        pic: (this.form.spec_pic[index] && this.form.spec_pic[index].pic) || '',
      }))
    },
    mainCategoryProperties() {
      return this.categoryProperties.filter(item => Number(item.important_type) === 1)
    },
    otherCategoryProperties() {
      return this.categoryProperties.filter(item => Number(item.important_type) !== 1)
    },
    productSpecRule() {
      return ((this.updateRule || {}).product_spec_rule) || {}
    },
    allSpecPicRequired() {
      return this.parsePropertyFlag(this.productSpecRule.all_spec_pic_required) === 1
    },
    supportSpecPropertyDiy() {
      if (this.productSpecRule.support_property_diy === undefined || this.productSpecRule.support_property_diy === null) return true
      return this.parsePropertyFlag(this.productSpecRule.support_property_diy) === 1
    },
    maxSpecNumLimit() {
      const limit = Number(this.productSpecRule.max_spec_num_limit || 0)
      return limit > 0 ? limit : 3
    },
    specCombinationLimit() {
      const limit = Number(this.productSpecRule.spec_combination_limit || 0)
      return limit > 0 ? limit : 0
    },
    specSingleLimit() {
      const limit = Number(this.productSpecRule.spec_single_limit || 0)
      return limit > 0 ? limit : 0
    },
    specTypeRuleOptions() {
      const details = (this.productSpecRule.required_spec_details) || []
      if (!Array.isArray(details)) return []
      return details.map(item => {
        const rawPropertyId = item.sell_property_id !== undefined && item.sell_property_id !== null
          ? item.sell_property_id
          : (item.property_id !== undefined && item.property_id !== null ? item.property_id : '')
        return {
          property_id: String(rawPropertyId),
          property_name: item.sell_property_name || item.property_name || '',
          support_diy: item.support_diy === undefined || item.support_diy === null ? true : this.parsePropertyFlag(item.support_diy) === 1,
          property_values: this.normalizeSpecRuleValues(item.property_values),
        }
      }).filter(item => item.property_id !== '' && item.property_name)
    },
    threeGuaranteeTypeOptions() {
      return (((this.updateRule || {}).after_sale_rule || {}).three_guarantees || {}).options || []
    },
    threeGuaranteeDurationOptions() {
      const target = this.threeGuaranteeTypeOptions.find(item => String(item.value) === String(this.threeGuarantees.service_type))
      return target && Array.isArray(target.options) ? target.options : []
    },
    supplyDayReturnRule() {
      return (((this.updateRule || {}).after_sale_rule || {}).supply_day_return_rule) || {}
    },
    supplyDayReturnRequired() {
      const rule = this.supplyDayReturnRule
      const required = rule.must_select !== undefined
        ? rule.must_select
        : (rule.required !== undefined ? rule.required : rule.enable)
      return this.parsePropertyFlag(required) === 1 && this.supplyDayOptions.length > 0
    },
    supplyDayOptions() {
      const options = this.supplyDayReturnRule.options || []
      if (!Array.isArray(options)) return []
      return options.map(item => {
        const value = String(item.value === undefined || item.value === null ? '' : item.value).trim()
        return {
          value,
          name: item.name || `${value.split('-')[0]}天无理由退货`,
        }
      }).filter(item => item.value)
    },
    supportsSizeChart() {
      const componentRule = ((this.updateRule || {}).component_template_rule) || {}
      return this.parsePropertyFlag(componentRule.is_show) === 1 || !!this.supportTemplateSubType || !!this.form.size_info_template_id || !!this.sizeSpec
    },
    qualificationRules() {
      const rules = ((this.updateRule || {}).qualification_rule) || []
      if (!Array.isArray(rules)) return []
      return rules.map(item => {
        const key = String((item || {}).key || (item || {}).quality_key || '').trim()
        const name = String((item || {}).name || (item || {}).quality_name || '').trim()
        const textList = Array.isArray((item || {}).text_list)
          ? item.text_list.map(text => String(text || '').trim()).filter(Boolean)
          : []
        return {
          ...item,
          key,
          name,
          text_list: textList,
          is_required: !!((item || {}).is_required),
        }
      }).filter(item => item.key && item.name)
    },
    sizeSpec() {
      return this.specs.find(spec => this.isSizeSpecName(spec.name)) || null
    },
    sizeChartImportantOptions() {
      return (this.sizeChart.options || []).filter(item => item.group === 'important')
    },
    sizeChartOtherOptions() {
      return (this.sizeChart.options || []).filter(item => item.group !== 'important')
    },
    sizeChartSelectedColumns() {
      return (this.sizeChart.options || []).filter(item => item.selected)
    },
    sizeChartHasRows() {
      return Array.isArray(this.sizeChart.rows) && this.sizeChart.rows.length > 0
    },
    allSpecValueIds() {
      return this.specs.reduce((ids, spec) => {
        ;(spec.values || []).forEach(value => ids.push(value.id))
        return ids
      }, [])
    },
    halfPrice() {
      if (!this.specPrices.length) return '0.00'
      const total = this.specPrices.reduce((sum, item) => sum + Number(item.price || 0), 0)
      return (total / this.specPrices.length / 2).toFixed(2)
    },
    titleEditorCharCount() {
      return getLengthConsideringChineseChars(this.titleEditor.value)
    },
    shortTitleCharCount() {
      return getLengthConsideringChineseChars(this.form.short_product_name)
    },
    mainImageEditorAddSlots() {
      return Math.max(0, 5 - this.mainImageEditor.images.length)
    },
    mainImageAddSlots() {
      return Math.max(0, 5 - this.form.main_image_three_to_four.length)
    },
    descAddSlots() {
      return Math.min(1, Math.max(0, 50 - this.form.description.length))
    },
    sidebarTotalPages() {
      return Math.ceil(this.sidebarPagination.total / this.sidebarPagination.page_size) || 1
    },
    useProvidedSidebarItems() {
      return this.sidebarMode === 'provided' && Array.isArray(this.sidebarItems) && this.sidebarItems.length > 0
    },
    showAuditPendingWarning() {
      const checkStatus = this.productInfo.check_status
      if (checkStatus !== undefined && checkStatus !== null && checkStatus !== '') {
        return Number(checkStatus) === 2
      }
      return Number(this.productInfo.platform_status || 0) === 1
    },
    visibleMaterialRootCategories() {
      return (this.materialRootCategories || []).filter(item => item.media_type === this.materialMediaType)
    },
    visibleMaterialMediaTypes() {
      const mediaType = this.imageDialog.target === 'material_video_id' ? 'video' : 'image'
      return (this.materialMediaTypes || []).filter(item => item.id === mediaType)
    },
    materialToolbarHint() {
      return this.materialMediaType === 'image'
        ? '上传的图片抖店会进行审核，提示“上传成功”不会立刻显示在素材库中，需等待审核通过。'
        : '本地上传会先同步到抖店素材库当前文件夹，审核通过后可选择为主图视频。'
    },
    materialEmptyText() {
      return this.materialMediaType === 'image' ? '暂无素材图片' : '暂无素材视频'
    },
    materialSelectUnit() {
      return this.imageDialog.target === 'material_video_id' ? '个' : '张'
    },
    materialUploadAccept() {
      return this.materialMediaType === 'video' ? '.mp4' : '.jpg,.png'
    },
  },
  watch: {
    visible(value) {
      if (value && this.productId) {
        this.open(true)
      }
      if (!value) {
        this.resetState()
      }
    },
    productId(value, oldValue) {
      if (this.visible && value && value !== oldValue) {
        this.open(false)
      }
    },
    activeTab(value) {
      if (value === 'images') {
        this.loadMaterialVideoPreview()
      }
    },
    sidebarItems: {
      deep: true,
      handler() {
        if (this.visible) {
          this.syncSidebarList()
        }
      },
    },
    form: {
      deep: true,
      handler() {
        this.markDirty()
      },
    },
    specs: {
      deep: true,
      handler() {
        this.markDirty()
      },
    },
    specPrices: {
      deep: true,
      handler() {
        this.markDirty()
      },
    },
    sizeChart: {
      deep: true,
      handler() {
        this.markDirty()
      },
    },
    threeGuarantees: {
      deep: true,
      handler() {
        this.markDirty()
      },
    },
  },
  methods: {
    ...mapActions({
      getDoudianProductEditDetail: 'ucenter/getDoudianProductEditDetail',
      saveDoudianProductEdit: 'ucenter/saveDoudianProductEdit',
      predictDoudianProductCategory: 'ucenter/predictDoudianProductCategory',
      getDoudianProductFreightTemplates: 'ucenter/getDoudianProductFreightTemplates',
      getDoudianProductBrands: 'ucenter/getDoudianProductBrands',
      getDoudianProductCategoryProperties: 'ucenter/getDoudianProductCategoryProperties',
      getDoudianProductUpdateRule: 'ucenter/getDoudianProductUpdateRule',
      getDoudianProductSizeTemplates: 'ucenter/getDoudianProductSizeTemplates',
      getDoudianProductMaterialFolders: 'ucenter/getDoudianProductMaterialFolders',
      getDoudianProductMaterialFolderFiles: 'ucenter/getDoudianProductMaterialFolderFiles',
      getDoudianProductMaterialDetail: 'ucenter/getDoudianProductMaterialDetail',
      getDoudianProductMaterialOssUploadToken: 'ucenter/getDoudianProductMaterialOssUploadToken',
      uploadDoudianProductMaterialImage: 'ucenter/uploadDoudianProductMaterialImage',
      uploadDoudianProductMaterialVideo: 'ucenter/uploadDoudianProductMaterialVideo',
      recycleDoudianProductMaterialFolderFiles: 'ucenter/recycleDoudianProductMaterialFolderFiles',
      getGoodsList: 'ucenter/getGoodsList',
    }),
    createEmptyForm() {
      return {
        id: '',
        category_leaf_id: 0,
        categoryLeafPath: [],
        categoryPathText: '',
        name: '',
        short_product_name: '',
        standard_brand_id: '',
        reduce_type: 1,
        freight_id: '',
        start_sale_type: 0,
        presell_type: 0,
        delivery_delay_day: 2,
        presell_delay: null,
        presell_end_time: '',
        maximum_per_order: null,
        minimum_per_order: null,
        limit_per_buyer: null,
        is_evaluate_opened: false,
        reference_price: null,
        after_sale_service: {
          supply_day_return_selector: '',
        },
        after_sale_service_v2: {},
        size_info_template_id: '',
        pic: [],
        description: [],
        spec_pic: [],
        main_image_three_to_four: [],
        material_video_id: '',
        white_back_ground_pic_url: '',
        long_pic_url: '',
        product_format_new: {},
        category_property_pics: {},
        quality_list: {},
        Property: {},
      }
    },
    actionRequest(action, payload) {
      return new Promise((resolve, reject) => {
        action({
          ...payload,
          success: res => {
            if (res && res.code === 200) {
              resolve(res)
              return
            }
            reject(new Error((res && (res.message || res.msg)) || '请求失败'))
          },
        })
      })
    },
    buildDirtyState() {
      return {
        form: clone(this.form),
        specs: clone(this.specs),
        specPrices: clone(this.specPrices),
        sizeChart: clone(this.sizeChart),
        threeGuarantees: clone(this.threeGuarantees),
      }
    },
    serializeSizeChartState() {
      return JSON.stringify(this.sizeChart || createEmptySizeChartState())
    },
    serializeDirtyState() {
      return JSON.stringify(this.buildDirtyState())
    },
    async capturePristineSnapshot() {
      await this.$nextTick()
      this.criticalPredictionSnapshot = this.buildCriticalPredictionSnapshot()
      this.recommendIds = {}
      this.initialSizeChartSnapshot = this.serializeSizeChartState()
      this.initialDirtySnapshot = this.serializeDirtyState()
      this.dirty = false
    },
    buildCriticalPredictionSnapshot() {
      return {
        title: String(this.form.name || '').trim(),
        images: clone(this.form.pic || []),
        category_leaf_id: this.currentCategoryLeafId,
      }
    },
    async open(resetSidebar = false) {
      const targetId = String(this.productId || '')
      if (!targetId) return
      if (this.loading && String(this.currentEditingId) === targetId) return
      this.loading = true
      this.bootstrapping = true
      this.currentEditingId = targetId
      if (resetSidebar && !this.useProvidedSidebarItems) {
        this.sidebarPagination.page = Number(this.initialSidebarPage) || 1
        this.sidebarPagination.page_size = Number(this.initialSidebarPageSize) || 20
      }
      await this.syncSidebarList()
      try {
        const detailRes = await this.actionRequest(this.getDoudianProductEditDetail, { id: targetId })
        const data = detailRes.data || {}
        const sidebarProduct = this.sidebarList.find(item => String(item.id) === targetId)
        this.productInfo = this.buildEditorProductInfo(data, sidebarProduct)
        this.applyDetail(data.detail || {})
        await this.loadFreightTemplates(false)
        await this.refreshCategoryDependencies(false)
        this.alignSpecPics()
        await this.capturePristineSnapshot()
      } catch (error) {
        this.$message.error(error.message || '加载编辑数据失败')
      } finally {
        this.bootstrapping = false
        this.loading = false
      }
    },
    async loadSidebar() {
      this.sidebarLoading = true
      try {
        const param = {
          page_size: this.sidebarPagination.page_size,
          page: this.sidebarPagination.page,
          shop_type: this.shopType,
        }
        Object.assign(param, this.searchParams || {})
        if (this.shopType === 1) {
          delete param.status
          if (this.tabStatus) {
            param.tab_status = this.tabStatus
          } else {
            delete param.tab_status
          }
        } else {
          param.status = this.goodsStatus
        }
        if (this.sidebarSearch.title) {
          param.title = this.sidebarSearch.title
        }
        if (this.sidebarSearch.platform_product_id) {
          param.platform_product_id = this.sidebarSearch.platform_product_id
        }
        const res = await this.actionRequest(this.getGoodsList, { data: param })
        this.sidebarList = (res.data || {}).list || []
        this.sidebarPagination.total = ((res.data || {}).pagination || {}).total || 0
      } catch (error) {
        this.$message.error(error.message || '获取商品列表失败')
      } finally {
        this.sidebarLoading = false
      }
    },
    async syncSidebarList() {
      if (this.useProvidedSidebarItems) {
        this.sidebarList = clone(this.sidebarItems || [])
        this.sidebarPagination.total = this.sidebarList.length
        this.sidebarPagination.page = 1
        return
      }
      await this.loadSidebar()
    },
    handleSidebarSearch() {
      if (this.useProvidedSidebarItems) return
      this.sidebarPagination.page = 1
      this.loadSidebar()
    },
    handleSidebarPageChange(page) {
      if (this.useProvidedSidebarItems) return
      this.sidebarPagination.page = page
      this.loadSidebar()
    },
    handleSidebarSizeChange(size) {
      if (this.useProvidedSidebarItems) return
      this.sidebarPagination.page_size = size
      this.sidebarPagination.page = 1
      this.loadSidebar()
    },
    buildEditorProductInfo(data, sidebarProduct = null) {
      const detail = data.detail || {}
      const productInfo = {
        ...((data.product || {})),
        status: detail.status,
        check_status: detail.check_status,
      }
      if (sidebarProduct && sidebarProduct.platform_product_id) {
        productInfo.platform_product_id = String(sidebarProduct.platform_product_id)
      } else if (productInfo.platform_product_id !== null && productInfo.platform_product_id !== undefined) {
        productInfo.platform_product_id = String(productInfo.platform_product_id)
      }
      return productInfo
    },
    switchProduct(item) {
      const targetId = item.id
      if (String(targetId) === String(this.currentEditingId)) return
      if (Number(item.mod_status) === 3) {
        this.$message.warning('该商品铺货失败，暂不可编辑')
        return
      }
      if (!Number(item.platform_product_id)) {
        this.$message.warning('该商品未铺货成功，暂不可编辑')
        return
      }
      const doSwitch = () => {
        this.$emit('update:product-id', targetId)
      }
      if (!this.dirty) {
        doSwitch()
        return
      }
      this.$confirm('当前有未保存修改，是否保存？', '提示', {
        type: 'warning',
        confirmButtonText: '保存并切换',
        cancelButtonText: '不保存切换',
        distinguishCancelAndClose: true,
      }).then(() => {
        this.submit(true).then(() => {
          doSwitch()
        }).catch(() => {})
      }).catch(action => {
        if (action === 'cancel') {
          doSwitch()
        }
      })
    },
    openSpecSortDialog(specIndex) {
      this.specSortDialog = {
        visible: true,
        specIndex,
        list: clone(this.specs[specIndex].values || []),
      }
    },
    confirmSpecSort() {
      const { specIndex, list } = this.specSortDialog
      if (specIndex >= 0 && this.specs[specIndex]) {
        this.$set(this.specs[specIndex], 'values', clone(list))
        this.recalculateSpecPrices()
        this.syncSizeChartWithSpecs()
        this.markDirty()
      }
      this.specSortDialog.visible = false
    },
    resetSpecSort() {
      const { specIndex } = this.specSortDialog
      if (specIndex >= 0 && this.specsBackup[specIndex]) {
        this.specSortDialog.list = clone(this.specsBackup[specIndex].values || [])
      }
    },
    openSpecDimSortDialog() {
      this.specDimSortDialog = {
        visible: true,
        list: clone(this.specs),
      }
    },
    confirmSpecDimSort() {
      this.$set(this, 'specs', clone(this.specDimSortDialog.list))
      this.recalculateSpecPrices()
      this.alignSpecPics()
      this.syncSizeChartWithSpecs()
      this.markDirty()
      this.specDimSortDialog.visible = false
    },
    onImageDragEnd() {
      this.markDirty()
    },
    applyDetail(detail) {
      this.sizeChart = createEmptySizeChartState()
      const categoryLeafId = Number(detail.category_leaf_id || 0)
      const categoryLeafPath = this.buildCategoryLeafPath(detail, categoryLeafId)
      const normalizedProductFormat = this.normalizeIncomingProductFormatNew(detail.product_format_new)
      const presellType = this.normalizePresellType(detail.presell_type)
      this.form = {
        id: this.productInfo.id || '',
        category_leaf_id: categoryLeafId,
        categoryLeafPath,
        categoryPathText: this.buildCategoryPathText(detail),
        name: detail.name || '',
        short_product_name: detail.short_product_name || '',
        standard_brand_id: this.normalizeBrandValue(detail.standard_brand_id),
        reduce_type: Number(detail.reduce_type || 1),
        freight_id: detail.freight_id !== null && detail.freight_id !== undefined ? String(detail.freight_id) : '',
        start_sale_type: Number(detail.start_sale_type || 0),
        presell_type: presellType,
        delivery_delay_day: presellType === 0 ? this.normalizeDeliveryDelayDay(detail.delivery_delay_day) : detail.delivery_delay_day,
        presell_delay: this.toNullableNumber(detail.presell_delay),
        presell_end_time: detail.presell_end_time || '',
        maximum_per_order: this.toNullableNumber(detail.maximum_per_order),
        minimum_per_order: this.toNullableNumber(detail.minimum_per_order),
        limit_per_buyer: this.toNullableNumber(detail.limit_per_buyer),
        is_evaluate_opened: !!detail.is_evaluate_opened,
        reference_price: this.toNullableNumber(detail.reference_price),
        after_sale_service: {
          supply_day_return_selector: (((detail.after_sale_service || {}).supply_day_return_selector) || ''),
        },
        after_sale_service_v2: detail.after_sale_service_v2 || {},
        size_info_template_id: detail.size_info_template_id ? String(detail.size_info_template_id) : '',
        pic: Array.isArray(detail.pic) ? clone(detail.pic) : [],
        description: Array.isArray(detail.descriptionImgList) ? clone(detail.descriptionImgList) : [],
        spec_pic: Array.isArray(detail.spec_pics) ? clone(detail.spec_pics) : [],
        main_image_three_to_four: Array.isArray(detail.main_pic_3_4) ? clone(detail.main_pic_3_4) : [],
        material_video_id: detail.material_video_id ? String(detail.material_video_id) : '',
        white_back_ground_pic_url: detail.white_back_ground_pic_url || '',
        long_pic_url: detail.long_pic_url || '',
        product_format_new: normalizedProductFormat,
        category_property_pics: this.normalizeCategoryPropertyPics(detail.category_property_pics),
        quality_list: this.normalizeIncomingQualityList(detail.quality_list),
        Property: {},
      }
      this.materialVideoCoverUrl = ''
      this.materialVideoPlayUrl = ''
      const guarantees = ((detail.after_sale_service_v2 || {}).three_guarantees) || {}
      this.threeGuarantees = {
        service_type: guarantees.service_type !== undefined ? guarantees.service_type : '',
        duration: guarantees.duration !== undefined ? guarantees.duration : '',
      }
      this.newSpecPropertyId = ''
      this.specs = this.normalizeSpecs(detail.specs || [])
      this.specPrices = this.normalizeSpecPrices(detail.spec_prices || [])
      if (!this.specPrices.length && this.specs.length) {
        this.recalculateSpecPrices()
      }
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.selectedSpecValueIds = []
      this.syncSpecSelectionState()
    },
    toNullableNumber(value) {
      if (value === '' || value === null || value === undefined) return null
      return Number(value)
    },
    normalizePresellType(value) {
      const numberValue = Number(value)
      return [0, 1, 2].includes(numberValue) ? numberValue : 0
    },
    normalizeDeliveryDelayDay(value) {
      const numberValue = Number(value)
      return [9999, 1, 2].includes(numberValue) ? numberValue : 2
    },
    buildCategoryLeafPath(detail, leafId) {
      const categoryDetail = detail && typeof detail.category_detail === 'object' ? detail.category_detail : {}
      const keys = ['first_cid', 'second_cid', 'third_cid', 'fourth_cid']
      const path = keys.map(key => Number(categoryDetail[key] || 0)).filter(id => id > 0)
      if (leafId && !path.some(id => String(id) === String(leafId))) {
        path.push(Number(leafId))
      }
      return path.length ? path : (leafId ? [Number(leafId)] : [])
    },
    buildCategoryPathText(detail) {
      const categoryDetail = detail && typeof detail.category_detail === 'object' ? detail.category_detail : {}
      const keys = ['first_cname', 'second_cname', 'third_cname', 'fourth_cname']
      return keys.map(key => String(categoryDetail[key] || '').trim()).filter(Boolean).join('>')
    },
    normalizeBrandValue(value) {
      const NO_BRAND_ID = '596120136'
      if (value === null || value === undefined || value === '' || Number(value) === 0) return NO_BRAND_ID
      return String(value)
    },
    isSpecProperty(item) {
      if (!item || item.property_id === undefined || item.property_id === null) return false
      return Number(item.property_type || 0) === 1
    },
    isSizeSpecName(name) {
      const text = String(name || '').trim()
      if (!text) return false
      return ['尺码大小', '码数', '鞋码大小'].includes(text) || /尺码|鞋码|码数|size/i.test(text)
    },
    normalizeSpecs(specs) {
      return (Array.isArray(specs) ? specs : []).map((spec, specIndex) => {
        const specId = spec.id !== undefined && spec.id !== null && spec.id !== ''
          ? spec.id
          : (spec.property_id !== undefined && spec.property_id !== null && spec.property_id !== '' ? spec.property_id : `spec_${specIndex}`)
        const propertyId = spec.property_id !== undefined && spec.property_id !== null && spec.property_id !== ''
          ? spec.property_id
          : specId
        return {
          ...spec,
          id: specId,
          property_id: propertyId,
          name: spec.name || spec.property_name || '',
          values: (spec.values || []).map((value, valueIndex) => ({
            ...value,
            id: value.id !== undefined && value.id !== null && value.id !== '' ? value.id : (value.value_id !== undefined && value.value_id !== null && value.value_id !== '' ? value.value_id : `${specId}_${valueIndex}`),
            pid: value.pid !== undefined && value.pid !== null && value.pid !== '' ? value.pid : specId,
            name: value.name || value.value_name || '',
            value_id: String(value.value_id !== undefined && value.value_id !== null && value.value_id !== '' ? value.value_id : (value.id !== undefined && value.id !== null && value.id !== '' ? value.id : 0)),
            remark: value.remark || '',
            isClear: false,
          })),
        }
      })
    },
    normalizeSpecPrices(specPrices) {
      return (Array.isArray(specPrices) ? specPrices : []).map(item => ({
        sell_properties: Array.isArray(item.sell_properties) ? clone(item.sell_properties) : [],
        spec_detail_ids: Array.isArray(item.spec_detail_ids)
          ? clone(item.spec_detail_ids)
          : (Array.isArray(item.sell_properties) ? item.sell_properties.map(row => row.value_spec_detail_id) : []),
        stock_num: Number(item.stock_num || 0),
        price: Number(item.price || 0),
        code: item.code || '',
        sku_status: item.sku_status !== false,
      }))
    },
    async loadFreightTemplates(refresh) {
      this.freightLoading = true
      try {
        const res = await this.actionRequest(this.getDoudianProductFreightTemplates, {
          id: this.productId,
          data: refresh ? { refresh: 1 } : {},
        })
        this.freightTemplates = Array.isArray(res.data) ? res.data : []
      } finally {
        this.freightLoading = false
      }
    },
    async refreshCategoryDependencies(resetProperties) {
      if (!this.currentCategoryLeafId) return
      const [brandRes, propertyRes, ruleRes] = await Promise.all([
        this.actionRequest(this.getDoudianProductBrands, {
          id: this.productId,
          data: { category_leaf_id: this.currentCategoryLeafId },
        }),
        this.actionRequest(this.getDoudianProductCategoryProperties, {
          id: this.productId,
          data: { category_leaf_id: this.currentCategoryLeafId },
        }),
        this.actionRequest(this.getDoudianProductUpdateRule, {
          id: this.productId,
          data: { category_leaf_id: this.currentCategoryLeafId },
        }),
      ])
      this.brandList = ((brandRes.data || {}).auth_brand_list) || []
      this.categoryProperties = this.normalizeCategoryPropertyList(propertyRes.data || {})
      this.updateRule = ruleRes.data || {}
      this.supportTemplateSubType = ((((this.updateRule || {}).component_template_rule) || {}).support_template_sub_type) || ''
      this.syncSpecValuesWithRules()
      this.syncSupplyDayReturnSelector()
      this.applyPropertyState(resetProperties)
      await this.loadSizeTemplates(false, true)
    },
    async loadSizeTemplates(refresh, includeTemplateId = true) {
      const templateId = includeTemplateId ? (this.form.size_info_template_id || '') : ''
      if (!this.supportsSizeChart) {
        this.sizeTemplateList = []
        this.sizeChart = createEmptySizeChartState()
        return
      }
      this.sizeTemplateLoading = true
      try {
        if (!templateId) {
          this.sizeTemplateList = []
          this.applyCurrentSizeChartTemplate(null)
          return
        }
        const res = await this.actionRequest(this.getDoudianProductSizeTemplates, {
          id: this.productId,
          data: {
            template_sub_type: this.supportTemplateSubType,
            page: 1,
            page_size: 50,
            template_id: templateId,
            refresh: refresh ? 1 : 0,
          },
        })
        this.sizeTemplateList = Array.isArray((res.data || {}).component_template_info_list)
          ? res.data.component_template_info_list
          : []
        this.applyCurrentSizeChartTemplate(this.sizeTemplateList[0] || null)
      } finally {
        this.sizeTemplateLoading = false
      }
    },
    applyCurrentSizeChartTemplate(templateItem) {
      const nextState = this.normalizeSizeChartState(templateItem)
      this.sizeChart = nextState
      this.syncSizeChartWithSpecs()
    },
    normalizeSizeChartState(templateItem) {
      const state = createEmptySizeChartState()
      state.template_id = templateItem && templateItem.template_id ? String(templateItem.template_id) : (this.form.size_info_template_id || '')
      state.template_sub_type = this.supportTemplateSubType || ''

      const frontData = this.parseSizeChartFrontData((templateItem || {}).component_front_data)
      state.title = String(frontData.title || '商品尺码表')
      state.desc = String(frontData.desc || '')
      state.tempName = String(frontData.tempName || frontData.title || '商品尺码表')

      const selectedSpecKeys = Array.isArray(frontData.selectedSpecs) ? frontData.selectedSpecs.map(item => String(item || '').trim()).filter(Boolean) : []
      const optionList = this.buildSizeChartOptions(frontData, selectedSpecKeys)
      const optionMap = {}
      optionList.forEach(item => {
        optionMap[item.key] = item
      })

      const rows = Array.isArray(frontData.configTable) ? frontData.configTable.map(row => {
        const size = String((row || {}).size || '').trim()
        const specMap = (row && typeof row.specMap === 'object' && row.specMap) ? row.specMap : {}
        const values = {}
        optionList.forEach(option => {
          const parsed = this.parseSizeChartCell(specMap[option.label], option.range)
          values[option.key] = parsed
          if (parsed.range) {
            optionMap[option.key].range = true
          }
        })
        return {
          size,
          values,
        }
      }).filter(row => row.size) : []

      state.options = optionList
      state.rows = rows
      if (!state.options.length) {
        state.options = this.buildSizeChartOptions({}, [])
      }
      return state
    },
    parseSizeChartFrontData(rawData) {
      if (!rawData) return {}
      if (typeof rawData === 'string') {
        try {
          return JSON.parse(rawData)
        } catch (error) {
          return {}
        }
      }
      return typeof rawData === 'object' ? clone(rawData) : {}
    },
    buildSizeChartOptions(frontData, selectedSpecKeys = []) {
      const selectedSet = new Set(selectedSpecKeys)
      const merged = []
      const pushOption = (raw, group = 'other') => {
        const option = this.normalizeSizeChartOption(raw, group)
        if (!option || !option.key) return
        const isSelected = selectedSet.has(option.key) || selectedSet.has(option.label)
        const exists = merged.find(item => item.key === option.key)
        if (exists) {
          if (!exists.label && option.label) exists.label = option.label
          if (exists.group !== 'important' && option.group === 'important') exists.group = 'important'
          exists.selected = exists.selected || isSelected
          return
        }
        option.selected = isSelected
        merged.push(option)
      }

      ;(((((this.updateRule || {}).component_template_rule) || {}).size_dimensions || {}).useful_dimensions || []).forEach(item => pushOption(item, 'important'))
      ;(((((this.updateRule || {}).component_template_rule) || {}).size_dimensions || {}).other_dimensions || []).forEach(item => pushOption(item, 'other'))
      ;((frontData.specOptions) || []).forEach(item => pushOption(item, 'other'))
      ;((frontData.selectedSpecs) || []).forEach(item => pushOption(item, 'other'))

      if (!merged.length) {
        ;['身高(cm)', '体重(斤)', '衣长(cm)', '胸围(cm)'].forEach(item => pushOption(item, 'important'))
      }
      if (!selectedSet.size && merged.length) {
        merged.forEach((item, index) => {
          item.selected = index < 4
        })
      }
      return merged
    },
    normalizeSizeChartOption(raw, group = 'other') {
      if (raw === null || raw === undefined) return null
      let label = ''
      let key = ''
      if (typeof raw === 'string' || typeof raw === 'number') {
        label = String(raw).trim()
        key = label
      } else if (typeof raw === 'object') {
        label = String(raw.display_name || raw.dimension_name || raw.name || raw.label || raw.value || raw.spec_name || '').trim()
        key = String(raw.key || raw.dimension_key || label).trim()
      }
      if (!key && label) {
        key = label
      }
      if (!label) {
        label = key
      }
      if (!key || !label) return null
      return {
        key,
        label,
        group,
        selected: false,
        range: false,
      }
    },
    parseSizeChartCell(rawValue, preferRange = false) {
      const value = String(rawValue === undefined || rawValue === null ? '' : rawValue).trim()
      const matched = value.match(/^(.+?)\s*[-~]\s*(.+)$/)
      if (matched) {
        return {
          value: '',
          min: matched[1].trim(),
          max: matched[2].trim(),
          range: true,
        }
      }
      return {
        value,
        min: '',
        max: '',
        range: !!preferRange,
      }
    },
    getCurrentSizeSpecValues() {
      const spec = this.sizeSpec
      if (!spec) return []
      return (spec.values || []).map(item => String(item.name || '').trim()).filter(Boolean)
    },
    syncSizeChartWithSpecs() {
      const state = this.sizeChart || createEmptySizeChartState()
      const optionKeys = (state.options || []).map(item => item.key)
      const nextRows = []
      const sizeValues = this.getCurrentSizeSpecValues()
      const currentRows = Array.isArray(state.rows) ? state.rows : []
      const currentMap = {}
      currentRows.forEach(row => {
        if (row && row.size) {
          currentMap[String(row.size)] = clone(row)
        }
      })

      currentRows.forEach(row => {
        const size = String((row || {}).size || '').trim()
        if (!size || !sizeValues.includes(size)) return
        nextRows.push(this.ensureSizeChartRowStructure(currentMap[size], optionKeys))
      })

      sizeValues.forEach(size => {
        if (nextRows.some(row => row.size === size)) return
        nextRows.push(this.ensureSizeChartRowStructure({ size, values: {} }, optionKeys))
      })

      this.$set(this.sizeChart, 'rows', nextRows)
      this.$set(this.sizeChart, 'template_sub_type', this.supportTemplateSubType || state.template_sub_type || '')
      if (!state.title) {
        this.$set(this.sizeChart, 'title', '商品尺码表')
      }
      if (!state.tempName) {
        this.$set(this.sizeChart, 'tempName', '商品尺码表')
      }
    },
    ensureSizeChartRowStructure(row, optionKeys) {
      const nextRow = {
        size: String((row || {}).size || '').trim(),
        values: {},
      }
      const currentValues = (row && typeof row.values === 'object' && row.values) ? row.values : {}
      optionKeys.forEach(key => {
        const current = currentValues[key] || {}
        nextRow.values[key] = {
          value: String(current.value || ''),
          min: String(current.min || ''),
          max: String(current.max || ''),
          range: !!current.range,
        }
      })
      return nextRow
    },
    toggleSizeChartRange(key, value) {
      const option = (this.sizeChart.options || []).find(item => item.key === key)
      if (!option) return
      option.range = !!value
      ;(this.sizeChart.rows || []).forEach(row => {
        if (!row.values[key]) {
          this.$set(row.values, key, { value: '', min: '', max: '', range: !!value })
        } else {
          this.$set(row.values[key], 'range', !!value)
          if (value) {
            if (!row.values[key].min && row.values[key].value) {
              row.values[key].min = row.values[key].value
              row.values[key].value = ''
            }
          } else if (!row.values[key].value && row.values[key].min && row.values[key].max && row.values[key].min === row.values[key].max) {
            row.values[key].value = row.values[key].min
            row.values[key].min = ''
            row.values[key].max = ''
          }
        }
      })
      this.markDirty()
    },
    moveSizeChartRow(index, step) {
      const rows = this.sizeChart.rows || []
      const target = index + step
      if (target < 0 || target >= rows.length) return
      const current = rows.splice(index, 1)[0]
      rows.splice(target, 0, current)
      this.markDirty()
    },
    getSizeChartCellPlaceholder(column, mode) {
      if (mode === 'min') return '最小值'
      if (mode === 'max') return '最大值'
      return `请输入${column.label}`
    },
    buildSizeChartForSubmit() {
      const selectedColumns = this.sizeChartSelectedColumns
      if (!selectedColumns.length) return null
      const rows = (this.sizeChart.rows || []).filter(row => String(row.size || '').trim())
      return {
        template_id: this.sizeChart.template_id || this.form.size_info_template_id || '',
        template_sub_type: this.sizeChart.template_sub_type || this.supportTemplateSubType || '',
        template_name: this.sizeChart.tempName || this.sizeChart.title || '商品尺码表',
        title: this.sizeChart.title || '商品尺码表',
        desc: this.sizeChart.desc || '',
        tempName: this.sizeChart.tempName || this.sizeChart.title || '商品尺码表',
        selectedSize: rows.map(row => row.size),
        selectedSpecs: selectedColumns.map(item => item.label),
        specOptions: (this.sizeChart.options || []).map(item => item.label),
        configTable: rows.map(row => {
          const specMap = {}
          selectedColumns.forEach(column => {
            const cell = ((row.values || {})[column.key]) || {}
            specMap[column.label] = column.range
              ? `${String(cell.min || '').trim()}-${String(cell.max || '').trim()}`
              : String(cell.value || '').trim()
          })
          return {
            size: row.size,
            specMap,
          }
        }),
      }
    },
    validateSizeChart() {
      if (!this.supportsSizeChart) return true
      const sizeValues = this.getCurrentSizeSpecValues()
      if (!sizeValues.length) return true
      if (!this.sizeChartSelectedColumns.length) {
        this.$message.warning('请至少选择一个尺码参数')
        return false
      }
      const rowMap = {}
      ;(this.sizeChart.rows || []).forEach(row => {
        rowMap[String(row.size || '').trim()] = row
      })
      for (const size of sizeValues) {
        const row = rowMap[size]
        if (!row) {
          this.$message.warning(`请补全尺码 ${size} 的尺码表信息`)
          return false
        }
        for (const column of this.sizeChartSelectedColumns) {
          const cell = ((row.values || {})[column.key]) || {}
          if (column.range) {
            const min = String(cell.min || '').trim()
            const max = String(cell.max || '').trim()
            if (!min || !max) {
              this.$message.warning(`请填写尺码 ${size} 的 ${column.label} 区间值`)
              return false
            }
            const minNum = Number(min)
            const maxNum = Number(max)
            if (Number.isFinite(minNum) && Number.isFinite(maxNum) && minNum > maxNum) {
              this.$message.warning(`尺码 ${size} 的 ${column.label} 最小值不能大于最大值`)
              return false
            }
            continue
          }
          if (!String(cell.value || '').trim()) {
            this.$message.warning(`请填写尺码 ${size} 的 ${column.label}`)
            return false
          }
        }
      }
      return true
    },
    isSizeChartDirty() {
      return this.serializeSizeChartState() !== this.initialSizeChartSnapshot
    },
    applyPropertyState(resetProperties) {
      const propertyState = {}
      const nextFormat = resetProperties ? {} : clone(this.form.product_format_new || {})

      ;(this.categoryProperties || []).forEach(item => {
        const key = item.property_id
        const current = Array.isArray(nextFormat[key]) ? nextFormat[key] : []

        if (this.isMeasureProperty(item)) {
          nextFormat[key] = this.normalizeMeasurePropertyRows(item, current)
          return
        }

        if (!current.length) {
          propertyState[key] = item.type === 'multi_select' ? [] : ''
          return
        }

        if (item.type === 'multi_select') {
          propertyState[key] = current.map(row => {
            const optionValue = String(row.diy_type === 1 ? row.name : row.value)
            if (row.diy_type === 1 && row.name) {
              this.ensurePropertyOptionExists(item, row.name)
            }
            return optionValue
          }).filter(Boolean)
          return
        }

        const first = current[0] || {}
        if (first.diy_type === 1 && first.name) {
          this.ensurePropertyOptionExists(item, first.name)
        }
        propertyState[key] = this.getPropertyDisplayValue(item, first)
      })

      this.form.product_format_new = nextFormat
      this.form.Property = propertyState
      this.syncBrandToProductFormat()
    },
    handleStandardBrandChange() {
      this.syncBrandToProductFormat()
      this.markDirty()
    },
    syncBrandToProductFormat() {
      const NO_BRAND_ID = '596120136'
      const brandItem = this.brandPropertyItem
      if (!brandItem) return
      const key = brandItem.property_id
      const saved = Array.isArray(this.form.product_format_new[key]) ? this.form.product_format_new[key][0] : null
      if (!this.form.standard_brand_id && saved && saved.value) {
        this.form.standard_brand_id = String(saved.value)
      }
      let value = this.form.standard_brand_id
      if (!value) {
        value = NO_BRAND_ID
        this.form.standard_brand_id = NO_BRAND_ID
      }
      const option = this.brandOptions.find(item => String(item.brand_id || item.id) === String(value))
      const name = option ? (option.display_name || option.name_cn || option.name_en || option.name || '') : ''
      this.$set(this.form.product_format_new, key, [{
        value: Number(value),
        name,
        diy_type: 0,
      }])
      this.$set(this.form.Property, key, String(value))
    },
    isMeasureProperty(item) {
      return ['measure', 'multi_value_measure'].includes((item || {}).type)
    },
    isMultiValueMeasureProperty(item) {
      return (item || {}).type === 'multi_value_measure'
    },
    getMeasureRows(item) {
      return Array.isArray(this.form.product_format_new[item.property_id]) ? this.form.product_format_new[item.property_id] : []
    },
    getMeasureTemplate(item, measureItem) {
      const templates = Array.isArray((item || {}).measure_templates) ? item.measure_templates : []
      if (!templates.length) return null
      const templateId = (((measureItem || {}).measure_info || {}).template_id) || ''
      return templates.find(template => String(template.template_id) === String(templateId)) || templates[0]
    },
    getMeasureModules(item, measureItem) {
      const template = this.getMeasureTemplate(item, measureItem)
      return Array.isArray((template || {}).value_modules) ? template.value_modules : []
    },
    getMeasureModuleByIndex(item, measureItem, moduleIndex) {
      const modules = this.getMeasureModules(item, measureItem)
      const measureValues = ((((measureItem || {}).measure_info) || {}).values) || []
      const currentValue = measureValues[moduleIndex] || {}
      if (currentValue.module_id) {
        return modules.find(module => String(module.module_id) === String(currentValue.module_id)) || modules[moduleIndex] || null
      }
      return modules[moduleIndex] || null
    },
    isMeasureEnumModule(module) {
      return ((module || {}).input_type) === 'enum_diy'
    },
    getMeasureModuleOptions(module) {
      return Array.isArray((module || {}).values) ? module.values : []
    },
    getMeasureModuleValidateRule(module) {
      return ((module || {}).validate_rule) || {}
    },
    getMeasureModulePlaceholder(module) {
      if (this.isMeasureEnumModule(module)) {
        return '请选择或输入'
      }
      return ((module || {}).display_name) || '请输入'
    },
    isMeasureNumericModule(module) {
      const dataType = String((this.getMeasureModuleValidateRule(module).data_type || '')).toLowerCase()
      return ['float', 'int', 'integer', 'number'].includes(dataType)
    },
    getMeasureModuleInputType(module) {
      return this.isMeasureNumericModule(module) ? 'number' : 'text'
    },
    getMeasureModulePrecision(module) {
      const precision = this.getMeasureModuleValidateRule(module).precision
      return Number.isFinite(Number(precision)) ? Number(precision) : 0
    },
    getMeasureModuleMin(module) {
      const rule = this.getMeasureModuleValidateRule(module)
      const min = rule.min
      if (Number(min) === 0 && Number(rule.max) === 0) return undefined
      return min === '' || min === null || min === undefined ? undefined : Number(min)
    },
    getMeasureModuleMax(module) {
      const rule = this.getMeasureModuleValidateRule(module)
      const max = rule.max
      if (Number(rule.min) === 0 && Number(max) === 0) return undefined
      return max === '' || max === null || max === undefined ? undefined : Number(max)
    },
    getMeasureModuleStep(module) {
      const precision = this.getMeasureModulePrecision(module)
      if (!precision) return 1
      return Number((1 / Math.pow(10, precision)).toFixed(precision))
    },
    getMeasureModuleUnits(module) {
      return Array.isArray((module || {}).units) ? module.units : []
    },
    shouldShowMeasureUnitSelector(module) {
      return this.getMeasureModuleUnits(module).length > 1
    },
    handleMeasureUnitChange(propertyItem, measureItem, moduleIndex, unitId) {
      const module = this.getMeasureModuleByIndex(propertyItem, measureItem, moduleIndex)
      const unit = this.getMeasureModuleUnits(module).find(row => String(row.unit_id) === String(unitId)) || {}
      const current = ((((measureItem || {}).measure_info) || {}).values || [])[moduleIndex]
      if (!current) return
      current.unit_id = unit.unit_id || unitId || 0
      current.unit_name = unit.unit_name || ''
      this.syncMeasurePropertyName(propertyItem, measureItem)
    },
    getMeasureModuleUnitName(item, measureItem, moduleIndex) {
      const measureValues = ((((measureItem || {}).measure_info) || {}).values) || []
      const current = measureValues[moduleIndex] || {}
      if (current.unit_name) {
        return current.unit_name
      }
      const module = this.getMeasureModuleByIndex(item, measureItem, moduleIndex)
      const firstUnit = (((module || {}).units) || [])[0] || {}
      return firstUnit.unit_name || ''
    },
    createDefaultMeasureItem(item, templateId = '') {
      const template = templateId
        ? ((item.measure_templates || []).find(row => String(row.template_id) === String(templateId)) || null)
        : ((((item.measure_templates || [])[0] || {}).value_modules) ? (item.measure_templates || [])[0] : null)
      if (!template || !Array.isArray(template.value_modules) || !template.value_modules.length) {
        return null
      }
      return {
        measure_info: {
          template_id: template.template_id,
          values: template.value_modules.map(module => {
            const firstUnit = ((module.units || [])[0]) || {}
            return {
              module_id: module.module_id,
              unit_id: firstUnit.unit_id || 0,
              unit_name: firstUnit.unit_name || '',
              value: '',
              prefix: module.prefix || '',
              suffix: module.suffix || '',
            }
          }),
        },
        value: 0,
        name: '',
        diy_type: 1,
      }
    },
    normalizeMeasurePropertyRows(item, rows) {
      const normalizedRows = (Array.isArray(rows) ? rows : []).map(row => this.normalizeMeasurePropertyRow(item, row)).filter(Boolean)
      if (normalizedRows.length) {
        return this.isMultiValueMeasureProperty(item) ? normalizedRows : normalizedRows.slice(0, 1)
      }
      const defaultMeasure = this.createDefaultMeasureItem(item)
      return defaultMeasure ? [defaultMeasure] : []
    },
    normalizeMeasurePropertyRow(item, row) {
      const template = this.getMeasureTemplate(item, row)
      if (!template) return null
      const rawValues = Array.isArray((((row || {}).measure_info) || {}).values) ? row.measure_info.values : []
      const values = (template.value_modules || []).map((module, moduleIndex) => {
        const firstUnit = ((module.units || [])[0]) || {}
        const current = rawValues.find(value => String(value.module_id) === String(module.module_id)) || rawValues[moduleIndex] || {}
        return {
          module_id: module.module_id,
          unit_id: current.unit_id !== undefined && current.unit_id !== null && current.unit_id !== '' ? current.unit_id : (firstUnit.unit_id || 0),
          unit_name: current.unit_name || firstUnit.unit_name || '',
          value: current.value !== undefined && current.value !== null ? current.value : '',
          prefix: current.prefix || module.prefix || '',
          suffix: current.suffix || module.suffix || '',
        }
      })
      const normalized = {
        ...row,
        measure_info: {
          template_id: template.template_id,
          values,
        },
        value: row && row.value !== undefined ? row.value : 0,
        diy_type: this.parsePropertyFlag(row && row.diy_type !== undefined ? row.diy_type : 1),
      }
      normalized.name = this.composeMeasureRowName(normalized)
      return normalized
    },
    openTitleEditor() {
      this.titleEditor = {
        visible: true,
        value: String(this.form.name || ''),
      }
    },
    async confirmTitleEdit() {
      const title = String(this.titleEditor.value || '').trim()
      if (!title) {
        this.$message.warning('请填写商品标题')
        return
      }
      const titleLength = getLengthConsideringChineseChars(title)
      if (titleLength < 8) {
        this.$message.warning('商品标题至少8个字符（4个汉字）')
        return
      }
      if (titleLength > 60) {
        this.$message.warning('商品标题最多60个字符（30个汉字）')
        return
      }
      if (title === String(this.form.name || '').trim()) {
        this.titleEditor.visible = false
        this.$message.info('商品标题未发生变化')
        return
      }

      const predicted = await this.requestCategoryPrediction('title', {
        name: title,
        images: clone(this.form.pic || []),
      })
      if (predicted) {
        this.titleEditor.visible = false
      }
    },
    openMainImageEditor() {
      this.mainImageEditor = {
        visible: true,
        images: clone(this.form.pic || []),
      }
    },
    removeMainImageDraft(index) {
      this.mainImageEditor.images.splice(index, 1)
    },
    async confirmMainImageEdit() {
      const images = clone(this.mainImageEditor.images || [])
      if (images.length < 3 || images.length > 5) {
        this.$message.warning('商品主图需保留3～5张')
        return
      }
      if (JSON.stringify(images) === JSON.stringify(this.form.pic || [])) {
        this.mainImageEditor.visible = false
        this.$message.info('商品主图未发生变化')
        return
      }

      const predicted = await this.requestCategoryPrediction('images', {
        name: String(this.form.name || '').trim(),
        images,
      })
      if (predicted) {
        this.mainImageEditor.visible = false
      }
    },
    async requestCategoryPrediction(source, predictionInput = {}) {
      const name = String(
        predictionInput.name !== undefined ? predictionInput.name : (this.form.name || '')
      ).trim()
      const images = clone(
        predictionInput.images !== undefined ? predictionInput.images : (this.form.pic || [])
      )
      if (!name) {
        this.$message.warning('请先填写商品标题')
        return false
      }
      if (!images.length) {
        this.$message.warning('请先选择商品主图')
        return false
      }

      this.predictionLoadingSource = source
      const predictionProductId = String(this.productId || '')
      try {
        let asyncTaskId = ''
        for (let attempt = 0; attempt < 6; attempt++) {
          const res = await this.actionRequest(this.predictDoudianProductCategory, {
            id: this.productId,
            data: {
              name,
              images,
              async_task_id: asyncTaskId,
            },
          })
          if (
            !this.visible
            || String(this.productId || '') !== predictionProductId
            || String(this.currentEditingId) !== predictionProductId
          ) {
            return false
          }
          const data = res.data || {}
          if (!data.pending) {
            const items = Array.isArray(data.categories) ? data.categories : []
            if (!items.length) {
              throw new Error('抖店未预测到可选类目，请调整标题或主图后重试')
            }
            this.categoryPrediction = {
              visible: true,
              source,
              recommendId: String(data.recommend_id || ''),
              selectedLeafId: 0,
              items,
              predictedSnapshot: {
                title: name,
                images,
              },
            }
            return true
          }
          asyncTaskId = String(data.async_task_id || '')
          if (!asyncTaskId) {
            throw new Error('抖店类目预测任务状态异常')
          }
          await new Promise(resolve => setTimeout(resolve, Number(data.interval || 1000)))
        }
        throw new Error('类目预测耗时较长，请稍后重试')
      } catch (error) {
        this.$message.error(error.message || '类目预测失败')
        return false
      } finally {
        this.predictionLoadingSource = ''
      }
    },
    async confirmPredictedCategory() {
      const selected = (this.categoryPrediction.items || []).find(
        item => Number(item.category_leaf_id) === Number(this.categoryPrediction.selectedLeafId)
      )
      if (!selected || !selected.available) {
        this.$message.warning('请选择一个可用的预测类目')
        return
      }
      const predictedSnapshot = this.categoryPrediction.predictedSnapshot || {}
      const source = this.categoryPrediction.source
      const currentTitle = String(this.form.name || '').trim()
      const currentImages = JSON.stringify(this.form.pic || [])
      const titleChangedAfterPrediction = String(predictedSnapshot.title || '') !== currentTitle
      const imagesChangedAfterPrediction = JSON.stringify(predictedSnapshot.images || []) !== currentImages
      const predictionExpired = source === 'title'
        ? imagesChangedAfterPrediction
        : (source === 'images' ? titleChangedAfterPrediction : (titleChangedAfterPrediction || imagesChangedAfterPrediction))
      if (predictionExpired) {
        this.$message.warning('标题或主图已变化，请重新进行类目预测')
        this.categoryPrediction.visible = false
        return
      }

      const oldLeafId = this.currentCategoryLeafId
      const newLeafId = Number(selected.category_leaf_id || 0)
      if (oldLeafId && oldLeafId !== newLeafId) {
        try {
          await this.$confirm('修改类目后将保留符合新类目规则的属性、规格和SKU，仅清除不兼容内容，确认修改？', '提示', {
            confirmButtonText: '确认修改',
            cancelButtonText: '取消',
            type: 'warning',
          })
        } catch (error) {
          return
        }
      }

      if (source === 'title') {
        this.form.name = String(predictedSnapshot.title || '').trim()
      }
      if (source === 'images') {
        this.form.pic = clone(predictedSnapshot.images || [])
      }
      const categoryStateSnapshot = oldLeafId !== newLeafId ? this.createSpecStateSnapshot() : null
      this.form.category_leaf_id = newLeafId
      this.form.categoryLeafPath = clone(selected.category_leaf_path || [newLeafId])
      this.form.categoryPathText = selected.category_path_text || ''
      let specPreservationResult = null
      if (oldLeafId !== newLeafId) {
        const specSnapshot = categoryStateSnapshot
        this.resetCategoryDependentState()
        try {
          await this.refreshCategoryDependencies(true)
          specPreservationResult = {
            ...this.restoreCompatibleSpecState(specSnapshot),
            ...this.restoreCompatiblePropertyState(specSnapshot),
          }
        } catch (error) {
          this.restoreSpecStateSnapshot(specSnapshot)
          this.$message.error(error.message || '刷新类目依赖失败')
          return
        }
      }
      this.recommendIds = {
        category_recommend_id: this.categoryPrediction.recommendId,
      }
      const confirmedSnapshot = clone(this.criticalPredictionSnapshot)
      if (source === 'title') {
        confirmedSnapshot.title = String(this.form.name || '').trim()
      }
      if (source === 'images') {
        confirmedSnapshot.images = clone(this.form.pic || [])
      }
      confirmedSnapshot.category_leaf_id = this.currentCategoryLeafId
      this.criticalPredictionSnapshot = confirmedSnapshot
      this.categoryPrediction.visible = false
      this.markDirty()
      if (specPreservationResult && (
        specPreservationResult.removedSpecCount
        || specPreservationResult.removedValueCount
        || specPreservationResult.removedSkuCount
        || specPreservationResult.removedPropertyValueCount
        || specPreservationResult.removedSizeChartRowCount
        || specPreservationResult.sizeChartCleared
      )) {
        const removedParts = []
        if (specPreservationResult.removedPropertyValueCount) {
          removedParts.push(`${specPreservationResult.removedPropertyValueCount}个属性值`)
        }
        if (specPreservationResult.removedSpecCount) {
          removedParts.push(`${specPreservationResult.removedSpecCount}个规格项`)
        }
        if (specPreservationResult.removedValueCount) {
          removedParts.push(`${specPreservationResult.removedValueCount}个规格值`)
        }
        if (specPreservationResult.removedSkuCount) {
          removedParts.push(`${specPreservationResult.removedSkuCount}个SKU`)
        }
        if (specPreservationResult.removedSizeChartRowCount) {
          removedParts.push(`${specPreservationResult.removedSizeChartRowCount}行尺码数据`)
        } else if (specPreservationResult.sizeChartCleared) {
          removedParts.push('尺码表')
        }
        const keptParts = []
        if (specPreservationResult.keptPropertyValueCount) {
          keptParts.push(`${specPreservationResult.keptPropertyValueCount}个兼容属性值`)
        }
        keptParts.push(`${specPreservationResult.keptSkuCount}个兼容SKU`)
        this.$message.warning(`已保留${keptParts.join('、')}，清除不兼容的${removedParts.join('、')}`)
      } else if (specPreservationResult) {
        const sizeChartText = specPreservationResult.sizeChartPreserved ? '和尺码表' : ''
        const propertyText = specPreservationResult.keptPropertyValueCount
          ? `${specPreservationResult.keptPropertyValueCount}个属性值、`
          : ''
        this.$message.success(`已确认预测类目，保留${propertyText}${specPreservationResult.keptSkuCount}个SKU${sizeChartText}`)
      } else {
        this.$message.success('已确认预测类目')
      }
    },
    createSpecStateSnapshot() {
      return {
        specs: clone(this.specs),
        specPrices: clone(this.specPrices),
        specsBackup: clone(this.specsBackup),
        specPricesBackup: clone(this.specPricesBackup),
        selectedSpecValueIds: clone(this.selectedSpecValueIds),
        specPic: clone(this.form.spec_pic || []),
        sizeInfoTemplateId: this.form.size_info_template_id || '',
        supportTemplateSubType: this.supportTemplateSubType || '',
        sizeTemplateList: clone(this.sizeTemplateList || []),
        sizeChart: clone(this.sizeChart || createEmptySizeChartState()),
        afterSaleService: clone(this.form.after_sale_service || {}),
        afterSaleServiceV2: clone(this.form.after_sale_service_v2 || {}),
        threeGuarantees: clone(this.threeGuarantees || {}),
        categoryLeafId: this.form.category_leaf_id,
        categoryLeafPath: clone(this.form.categoryLeafPath || []),
        categoryPathText: this.form.categoryPathText || '',
        standardBrandId: this.form.standard_brand_id || '',
        productFormatNew: clone(this.form.product_format_new || {}),
        categoryPropertyPics: clone(this.form.category_property_pics || {}),
        qualityList: clone(this.form.quality_list || {}),
        propertyState: clone(this.form.Property || {}),
        categoryProperties: clone(this.categoryProperties || []),
        brandList: clone(this.brandList || []),
        updateRule: clone(this.updateRule || {}),
      }
    },
    restoreSpecStateSnapshot(snapshot) {
      this.specs = clone(snapshot.specs || [])
      this.specPrices = clone(snapshot.specPrices || [])
      this.specsBackup = clone(snapshot.specsBackup || [])
      this.specPricesBackup = clone(snapshot.specPricesBackup || [])
      this.selectedSpecValueIds = clone(snapshot.selectedSpecValueIds || [])
      this.form.spec_pic = clone(snapshot.specPic || [])
      this.form.size_info_template_id = snapshot.sizeInfoTemplateId || ''
      this.supportTemplateSubType = snapshot.supportTemplateSubType || ''
      this.sizeTemplateList = clone(snapshot.sizeTemplateList || [])
      this.sizeChart = clone(snapshot.sizeChart || createEmptySizeChartState())
      this.form.after_sale_service = clone(snapshot.afterSaleService || {})
      this.form.after_sale_service_v2 = clone(snapshot.afterSaleServiceV2 || {})
      this.threeGuarantees = clone(snapshot.threeGuarantees || {
        service_type: '',
        duration: '',
      })
      this.form.category_leaf_id = snapshot.categoryLeafId || 0
      this.form.categoryLeafPath = clone(snapshot.categoryLeafPath || [])
      this.form.categoryPathText = snapshot.categoryPathText || ''
      this.form.standard_brand_id = snapshot.standardBrandId || ''
      this.form.product_format_new = clone(snapshot.productFormatNew || {})
      this.form.category_property_pics = clone(snapshot.categoryPropertyPics || {})
      this.form.quality_list = clone(snapshot.qualityList || {})
      this.form.Property = clone(snapshot.propertyState || {})
      this.categoryProperties = clone(snapshot.categoryProperties || [])
      this.brandList = clone(snapshot.brandList || [])
      this.updateRule = clone(snapshot.updateRule || {})
      this.syncSpecSelectionState()
    },
    getSpecMatchText(value) {
      return String(value || '').trim().toLowerCase()
    },
    getSemanticSkuKey(rows) {
      return (rows || []).map(row => {
        return `${this.getSpecMatchText(row.property_name)}:${this.getSpecMatchText(row.value_name)}`
      }).sort().join('|')
    },
    hasPropertyRowValue(item, row) {
      if (!row || typeof row !== 'object') return false
      if (this.isMeasureProperty(item)) {
        return this.isMeasureRowStarted(row)
      }
      const name = String(row.name || '').trim()
      const value = row.value
      return !!name || (value !== '' && value !== null && value !== undefined && String(value) !== '0')
    },
    matchCompatiblePropertyRows(item, rows) {
      const current = (Array.isArray(rows) ? rows : []).filter(row => this.hasPropertyRowValue(item, row))
      if (!current.length) return []
      if (this.isMeasureProperty(item)) {
        const normalized = current.map(row => this.normalizeMeasurePropertyRow(item, row)).filter(Boolean)
        return this.isMultiValueMeasureProperty(item) ? normalized : normalized.slice(0, 1)
      }
      if (this.isTextProperty(item)) {
        const row = current[0]
        return [{
          ...row,
          property_id: String(item.property_id),
          property_name: item.property_name,
        }]
      }

      const matched = []
      const seen = new Set()
      current.forEach(row => {
        const oldValue = row.value === undefined || row.value === null ? '' : String(row.value)
        const oldName = String(row.name || '').trim()
        const option = (item.options || []).find(candidate => String(candidate.value_id) === oldValue)
          || (item.options || []).find(candidate => {
            return this.getSpecMatchText(candidate.name) === this.getSpecMatchText(oldName)
          })
        if (option) {
          const optionId = String(option.value_id)
          const key = `option:${optionId}`
          if (seen.has(key)) return
          seen.add(key)
          matched.push({
            ...row,
            property_id: String(item.property_id),
            property_name: item.property_name,
            value: /^-?\d+$/.test(optionId) ? Number(optionId) : option.value_id,
            name: option.name,
            diy_type: 0,
          })
          return
        }
        if (!oldName || !this.canCreatePropertyOption(item)) return
        const key = `diy:${this.getSpecMatchText(oldName)}`
        if (seen.has(key)) return
        seen.add(key)
        matched.push({
          ...row,
          property_id: String(item.property_id),
          property_name: item.property_name,
          value: 0,
          name: oldName,
          diy_type: 1,
        })
      })
      return item.type === 'multi_select' ? matched : matched.slice(0, 1)
    },
    restoreCompatiblePropertyState(snapshot) {
      const oldProperties = clone(snapshot.categoryProperties || [])
      const oldFormat = clone(snapshot.productFormatNew || {})
      const oldPics = clone(snapshot.categoryPropertyPics || {})
      const nextFormat = {}
      const nextPics = {}
      const usedPropertyIds = new Set()
      const oldBrandItem = oldProperties.find(item => item.property_name === '品牌')
      const sourceKeys = Array.from(new Set([...Object.keys(oldFormat), ...Object.keys(oldPics)]))
      let keptPropertyValueCount = 0
      let removedPropertyValueCount = 0

      sourceKeys.forEach(oldKey => {
        const oldItem = oldProperties.find(item => String(item.property_id) === String(oldKey)) || null
        if ((oldItem && oldItem.property_name === '品牌') || (oldBrandItem && String(oldBrandItem.property_id) === String(oldKey))) {
          return
        }
        const rows = Array.isArray(oldFormat[oldKey]) ? oldFormat[oldKey] : []
        const firstRow = rows[0] || {}
        const oldName = String((oldItem || {}).property_name || firstRow.property_name || '').trim()
        let target = (this.categoryProperties || []).find(item => {
          return !usedPropertyIds.has(String(item.property_id)) && String(item.property_id) === String(oldKey)
        })
        if (!target && oldName) {
          target = (this.categoryProperties || []).find(item => {
            return !usedPropertyIds.has(String(item.property_id))
              && this.getSpecMatchText(item.property_name) === this.getSpecMatchText(oldName)
          })
        }
        const oldValueCount = rows.filter(row => this.hasPropertyRowValue(oldItem || {}, row)).length
        if (!target) {
          removedPropertyValueCount += oldValueCount
          return
        }
        usedPropertyIds.add(String(target.property_id))
        const matchedRows = this.matchCompatiblePropertyRows(target, rows)
        if (matchedRows.length) {
          nextFormat[target.property_id] = matchedRows
        }
        keptPropertyValueCount += matchedRows.length
        removedPropertyValueCount += Math.max(0, oldValueCount - matchedRows.length)
        const oldPicUrls = (((oldPics[oldKey] || {}).urls) || []).filter(Boolean).slice(0, 1)
        if (oldPicUrls.length && this.getPropertyPicRule(target)) {
          nextPics[target.property_id] = { urls: oldPicUrls }
        }
      })

      const oldBrandId = String(snapshot.standardBrandId || '')
      const brandItem = this.brandPropertyItem
      const brandAvailable = oldBrandId === '596120136' || (this.brandList || []).some(item => {
        return String(item.brand_id || item.id || '') === oldBrandId
      })
      if (brandItem && oldBrandId && brandAvailable) {
        this.form.standard_brand_id = oldBrandId
        keptPropertyValueCount += 1
      } else {
        this.form.standard_brand_id = ''
        if (oldBrandId) removedPropertyValueCount += 1
      }

      this.form.product_format_new = nextFormat
      this.form.category_property_pics = nextPics
      this.applyPropertyState(false)
      return {
        keptPropertyValueCount,
        removedPropertyValueCount,
      }
    },
    restoreCompatibleSpecState(snapshot) {
      const oldSpecs = clone(snapshot.specs || [])
      const oldSpecPrices = clone(snapshot.specPrices || [])
      const rules = this.specTypeRuleOptions
      const usedRuleIds = new Set()
      const matchedSpecs = []
      const customSpecTimestamp = Date.now()
      let removedSpecCount = 0
      let removedValueCount = 0

      oldSpecs.forEach((oldSpec, specIndex) => {
        const oldValues = Array.isArray(oldSpec.values) ? oldSpec.values : []
        if (matchedSpecs.length >= this.maxSpecNumLimit) {
          removedSpecCount += 1
          removedValueCount += oldValues.length
          return
        }

        const oldPropertyId = String(oldSpec.property_id !== undefined && oldSpec.property_id !== null
          ? oldSpec.property_id
          : oldSpec.id)
        const oldPropertyName = String(oldSpec.name || oldSpec.property_name || '').trim()
        const oldPropertyNameKey = this.getSpecMatchText(oldPropertyName)
        let rule = rules.find(item => {
          return !usedRuleIds.has(String(item.property_id)) && String(item.property_id) === oldPropertyId
        })
        if (!rule) {
          rule = rules.find(item => {
            return !usedRuleIds.has(String(item.property_id))
              && this.getSpecMatchText(item.property_name) === oldPropertyNameKey
          })
        }
        if (!rule && !this.supportSpecPropertyDiy) {
          removedSpecCount += 1
          removedValueCount += oldValues.length
          return
        }

        const newSpecId = rule
          ? String(rule.property_id)
          : `custom_spec_${customSpecTimestamp}_${specIndex}`
        const newSpecName = rule ? rule.property_name : oldPropertyName
        if (rule) {
          usedRuleIds.add(String(rule.property_id))
        }

        const matchedValues = []
        oldValues.forEach((oldValue, valueIndex) => {
          const oldValueName = String(oldValue.name || oldValue.value_name || '').trim()
          if (!oldValueName) {
            removedValueCount += 1
            return
          }
          const oldValueId = String(oldValue.value_id !== undefined && oldValue.value_id !== null
            ? oldValue.value_id
            : '')
          const oldValueNameKey = this.getSpecMatchText(oldValueName)
          let option = null
          if (rule) {
            option = (rule.property_values || []).find(item => String(item.value_id) === oldValueId)
              || (rule.property_values || []).find(item => {
                return this.getSpecMatchText(item.value_name) === oldValueNameKey
              })
          }
          if (rule && !option && !rule.support_diy) {
            removedValueCount += 1
            return
          }

          const newValueName = option ? option.value_name : oldValueName
          const newValueId = option ? String(option.value_id) : '0'
          const newValue = {
            ...oldValue,
            id: oldValue.id !== undefined && oldValue.id !== null && oldValue.id !== ''
              ? oldValue.id
              : `${newSpecId}_${valueIndex}`,
            pid: newSpecId,
            name: newValueName,
            value_id: newValueId,
            isClear: false,
          }
          matchedValues.push({
            oldDetailId: String(oldValue.id !== undefined && oldValue.id !== null ? oldValue.id : ''),
            oldValueId,
            oldValueNameKey,
            newValue,
          })
        })

        if (this.specSingleLimit && matchedValues.length > this.specSingleLimit) {
          removedValueCount += matchedValues.length - this.specSingleLimit
          matchedValues.splice(this.specSingleLimit)
        }
        if (!matchedValues.length) {
          removedSpecCount += 1
          return
        }

        matchedSpecs.push({
          oldPropertyNameKey,
          spec: {
            ...oldSpec,
            id: newSpecId,
            property_id: newSpecId,
            name: newSpecName,
            values: matchedValues.map(item => item.newValue),
          },
          values: matchedValues,
        })
      })

      while (
        this.specCombinationLimit
        && this.getSpecCombinationCount(matchedSpecs.map(item => item.values.length)) > this.specCombinationLimit
      ) {
        let targetIndex = matchedSpecs.length - 1
        while (targetIndex >= 0 && matchedSpecs[targetIndex].values.length <= 1) {
          targetIndex -= 1
        }
        if (targetIndex < 0) break
        matchedSpecs[targetIndex].values.pop()
        matchedSpecs[targetIndex].spec.values.pop()
        removedValueCount += 1
      }

      const compatibleSkuMap = new Map()
      if (matchedSpecs.length === oldSpecs.length) {
        oldSpecPrices.forEach((oldSku, skuIndex) => {
          const oldRows = Array.isArray(oldSku.sell_properties) ? oldSku.sell_properties : []
          const usedRowIndexes = new Set()
          const mappedRows = []
          let compatible = true
          matchedSpecs.forEach(mapping => {
            if (!compatible) return
            let rowIndex = oldRows.findIndex((row, index) => {
              if (usedRowIndexes.has(index)) return false
              return mapping.values.some(value => {
                return value.oldDetailId
                  && String(row.value_spec_detail_id || '') === value.oldDetailId
              })
            })
            if (rowIndex < 0) {
              rowIndex = oldRows.findIndex((row, index) => {
                return !usedRowIndexes.has(index)
                  && this.getSpecMatchText(row.property_name) === mapping.oldPropertyNameKey
              })
            }
            if (rowIndex < 0) {
              compatible = false
              return
            }
            const oldRow = oldRows[rowIndex]
            const valueMapping = mapping.values.find(value => {
              const sameDetailId = value.oldDetailId
                && String(oldRow.value_spec_detail_id || '') === value.oldDetailId
              const sameValueId = value.oldValueId
                && String(oldRow.value_id || '') === value.oldValueId
              const sameValueName = this.getSpecMatchText(oldRow.value_name) === value.oldValueNameKey
              return sameDetailId || sameValueId || sameValueName
            })
            if (!valueMapping) {
              compatible = false
              return
            }
            usedRowIndexes.add(rowIndex)
            mappedRows.push({
              property_name: mapping.spec.name,
              value_name: valueMapping.newValue.name,
              value_spec_detail_id: valueMapping.newValue.id,
            })
          })
          if (!compatible || mappedRows.length !== matchedSpecs.length) return
          const key = this.getSemanticSkuKey(mappedRows)
          if (!compatibleSkuMap.has(key)) {
            compatibleSkuMap.set(key, {
              sku: oldSku,
              skuIndex,
            })
          }
        })
      }

      this.specs = matchedSpecs.map(item => item.spec)
      const combinations = this.specs.length
        ? this.cartesianProduct(...this.specs.map(spec => spec.values || []))
        : []
      const usedSkuIndexes = new Set()
      this.specPrices = combinations.map(group => {
        const sellProperties = group.map((value, index) => ({
          value_name: value.name,
          property_name: this.specs[index] ? this.specs[index].name : '',
          value_spec_detail_id: value.id,
        }))
        const oldEntry = compatibleSkuMap.get(this.getSemanticSkuKey(sellProperties))
        if (oldEntry) {
          usedSkuIndexes.add(oldEntry.skuIndex)
        }
        const oldSku = oldEntry ? oldEntry.sku : null
        return {
          sell_properties: sellProperties,
          spec_detail_ids: sellProperties.map(item => item.value_spec_detail_id),
          stock_num: oldSku ? Number(oldSku.stock_num || 0) : 0,
          price: oldSku ? Number(oldSku.price || 0) : 0,
          code: oldSku ? oldSku.code || '' : '',
          sku_status: oldSku ? oldSku.sku_status !== false : true,
        }
      })

      this.form.spec_pic = clone(snapshot.specPic || [])
      this.alignSpecPics()
      const availableValueIds = new Set(this.allSpecValueIds.map(id => String(id)))
      this.selectedSpecValueIds = (snapshot.selectedSpecValueIds || []).filter(id => {
        return availableValueIds.has(String(id))
      })
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.syncSpecSelectionState()
      const sizeChartResult = this.restoreCompatibleSizeChart(snapshot)

      return {
        keptSkuCount: usedSkuIndexes.size,
        removedSpecCount,
        removedValueCount,
        removedSkuCount: Math.max(0, oldSpecPrices.length - usedSkuIndexes.size),
        ...sizeChartResult,
      }
    },
    restoreCompatibleSizeChart(snapshot) {
      const oldChart = clone(snapshot.sizeChart || createEmptySizeChartState())
      const oldRows = Array.isArray(oldChart.rows) ? oldChart.rows : []
      const hasSizeChart = !!(
        snapshot.sizeInfoTemplateId
        || oldChart.template_id
        || oldRows.length
        || (oldChart.options || []).some(item => item.selected)
      )
      if (!hasSizeChart) {
        return {
          sizeChartPreserved: false,
          sizeChartCleared: false,
          removedSizeChartRowCount: 0,
        }
      }

      const oldSizeSpec = (snapshot.specs || []).find(spec => this.isSizeSpecName(spec.name))
      const newSizeSpec = this.sizeSpec
      if (!this.supportsSizeChart || !oldSizeSpec || !newSizeSpec) {
        this.form.size_info_template_id = ''
        this.sizeChart = createEmptySizeChartState()
        return {
          sizeChartPreserved: false,
          sizeChartCleared: true,
          removedSizeChartRowCount: oldRows.length,
        }
      }

      const sizeNameMap = {}
      ;(oldSizeSpec.values || []).forEach(oldValue => {
        const oldName = String(oldValue.name || '').trim()
        const matched = (newSizeSpec.values || []).find(newValue => {
          const sameDetailId = oldValue.id !== undefined && oldValue.id !== null
            && String(newValue.id) === String(oldValue.id)
          const sameValueId = oldValue.value_id !== undefined && oldValue.value_id !== null
            && String(newValue.value_id) === String(oldValue.value_id)
          const sameName = this.getSpecMatchText(newValue.name) === this.getSpecMatchText(oldName)
          return sameDetailId || sameValueId || sameName
        })
        if (oldName && matched) {
          sizeNameMap[this.getSpecMatchText(oldName)] = String(matched.name || '').trim()
        }
      })
      oldChart.rows = oldRows.map(row => ({
        ...row,
        size: sizeNameMap[this.getSpecMatchText(row.size)] || row.size,
      }))

      const oldTemplateSubType = String(snapshot.supportTemplateSubType || oldChart.template_sub_type || '')
      const newTemplateSubType = String(this.supportTemplateSubType || '')
      const templateCompatible = oldTemplateSubType === newTemplateSubType
      this.form.size_info_template_id = templateCompatible ? (snapshot.sizeInfoTemplateId || '') : ''
      oldChart.template_id = templateCompatible ? (oldChart.template_id || this.form.size_info_template_id) : ''
      oldChart.template_sub_type = newTemplateSubType
      this.sizeChart = oldChart
      this.syncSizeChartWithSpecs()

      return {
        sizeChartPreserved: true,
        sizeChartCleared: false,
        removedSizeChartRowCount: Math.max(0, oldRows.length - this.sizeChart.rows.length),
      }
    },
    resetCategoryDependentState() {
      this.form.standard_brand_id = ''
      this.form.size_info_template_id = ''
      this.form.product_format_new = {}
      this.form.category_property_pics = {}
      this.form.quality_list = {}
      this.form.Property = {}
      this.form.after_sale_service = {
        supply_day_return_selector: '',
      }
      this.form.after_sale_service_v2 = {}

      this.brandList = []
      this.categoryProperties = []
      this.updateRule = {}
      this.supportTemplateSubType = ''
      this.sizeTemplateList = []
      this.sizeChart = createEmptySizeChartState()
      this.sizeChartSettingVisible = false

      this.newSpecPropertyId = ''
      this.specs = []
      this.specPrices = []
      this.specsBackup = []
      this.specPricesBackup = []
      this.selectedSpecValueIds = []
      this.allSpecValuesSelected = false
      this.specSelectionIndeterminate = false
      this.form.spec_pic = []

      this.threeGuarantees = {
        service_type: '',
        duration: '',
      }
    },
    handleThreeGuaranteesTypeChange() {
      if (!this.threeGuaranteeDurationOptions.some(item => String(item.value) === String(this.threeGuarantees.duration))) {
        this.threeGuarantees.duration = ''
      }
      this.markDirty()
    },
    isTextProperty(item) {
      return !['select', 'multi_select', 'multi_value_measure', 'measure'].includes(item.type)
    },
    parsePropertyFlag(value) {
      if (value === true || value === 1 || value === '1') return 1
      if (value === false || value === 0 || value === '0' || value === '' || value === null || value === undefined) return 0
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        if (['true', 'yes', 'y'].includes(normalized)) return 1
        if (['false', 'no', 'n'].includes(normalized)) return 0
      }
      return Number(value) ? 1 : 0
    },
    isRequiredProperty(item) {
      return this.parsePropertyFlag(item.required || item.is_required || 0) === 1
    },
    canCreatePropertyOption(item) {
      if (!item || item.property_name === '品牌') return false
      return this.parsePropertyFlag(item.diy_type || item.support_diy_type || 0) === 1
    },
    getPropertyPlaceholder(item) {
      if (this.canCreatePropertyOption(item)) {
        return item.type === 'multi_select' ? '请选择或输入自定义属性，回车确认' : '请选择或输入自定义属性'
      }
      return '请选择'
    },
    getPropertyNoMatchText(item) {
      return this.canCreatePropertyOption(item) ? '按回车创建自定义属性' : '无匹配数据'
    },
    getPropertyDisplayValue(item, row) {
      if (!row || typeof row !== 'object') return ''
      const name = String(row.name || '').trim()
      const rawValue = row.value
      const value = rawValue === undefined || rawValue === null ? '' : String(rawValue)
      if (this.isTextProperty(item)) {
        if (name) return name
        return value === '0' ? '' : value
      }
      const option = (item.options || []).find(option => String(option.value_id) === value)
      if (option) return value
      if (name && (row.diy_type === 1 || value === '' || value === '0')) {
        if (this.canCreatePropertyOption(item)) {
          this.ensurePropertyOptionExists(item, name)
        }
        return name
      }
      return value === '0' ? '' : value
    },
    getPropertyDiyKey(item) {
      return String((item || {}).property_id || '')
    },
    isPropertyDiyEditing(item) {
      return !!this.propertyDiyEditing[this.getPropertyDiyKey(item)]
    },
    getPropertyDiyDraft(item) {
      return this.propertyDiyDrafts[this.getPropertyDiyKey(item)] || ''
    },
    setPropertyDiyDraft(item, value) {
      this.$set(this.propertyDiyDrafts, this.getPropertyDiyKey(item), value)
    },
    openPropertyDiyInput(item) {
      const key = this.getPropertyDiyKey(item)
      this.$set(this.propertyDiyEditing, key, true)
      this.$set(this.propertyDiyDrafts, key, '')
    },
    cancelPropertyDiyInput(item) {
      const key = this.getPropertyDiyKey(item)
      this.$set(this.propertyDiyEditing, key, false)
      this.$set(this.propertyDiyDrafts, key, '')
    },
    confirmPropertyDiyInput(item) {
      const key = this.getPropertyDiyKey(item)
      const value = String(this.propertyDiyDrafts[key] || '').trim()
      if (!value) {
        this.$message.warning('请输入自定义属性')
        return
      }
      this.ensurePropertyOptionExists(item, value)
      if (item.type === 'multi_select') {
        const current = Array.isArray(this.form.Property[key]) ? clone(this.form.Property[key]) : []
        if (!current.some(row => String(row) === value)) {
          current.push(value)
        }
        this.$set(this.form.Property, key, current)
      } else {
        this.$set(this.form.Property, key, value)
      }
      this.updatePropertyValue(item, this.form.Property[key])
      this.cancelPropertyDiyInput(item)
    },
    handlePropertySelectVisible(item, visible) {
      if (visible) return
      this.cancelPropertyDiyInput(item)
    },
    normalizeCategoryPropertyList(payload) {
      const sources = [
        payload,
        payload && payload.data,
        payload && payload.data && payload.data.data,
        payload && payload.raw,
        payload && payload.raw && payload.raw.data,
        payload && payload.raw && payload.raw.data && payload.raw.data.data,
      ]
      let list = []
      for (const source of sources) {
        if (Array.isArray(source)) {
          list = source
          break
        }
      }
      return list.map(item => this.normalizeCategoryPropertyItem(item)).filter(Boolean)
    },
    normalizeIncomingProductFormatNew(value) {
      if (!value || typeof value !== 'object') return {}
      const result = {}
      Object.keys(value).forEach(rawKey => {
        const rows = Array.isArray(value[rawKey]) ? value[rawKey] : []
        const propertyKey = String(rawKey)
        result[propertyKey] = rows.map(row => this.normalizeIncomingProductFormatRow(row, propertyKey)).filter(Boolean)
      })
      return result
    },
    normalizeIncomingProductFormatRow(row, propertyKey) {
      if (!row || typeof row !== 'object') return null
      const measureInfo = row.measure_info || row.MeasureInfo || null
      const normalizedMeasureInfo = measureInfo && typeof measureInfo === 'object'
        ? {
          ...measureInfo,
          template_id: measureInfo.template_id || measureInfo.TemplateId || '',
          values: Array.isArray(measureInfo.values || measureInfo.Values)
            ? (measureInfo.values || measureInfo.Values).map(item => ({
              ...item,
              module_id: item.module_id || item.ModuleId || '',
              unit_id: item.unit_id !== undefined ? item.unit_id : (item.UnitId !== undefined ? item.UnitId : 0),
              unit_name: item.unit_name || item.UnitName || '',
              value: item.value !== undefined ? item.value : (item.Value !== undefined ? item.Value : ''),
            }))
            : [],
        }
        : null
      return {
        ...row,
        property_id: String(row.property_id || row.PropertyId || propertyKey),
        property_name: row.property_name || row.PropertyName || '',
        value: row.value !== undefined ? row.value : (row.Value !== undefined ? row.Value : 0),
        name: row.name || row.Name || '',
        diy_type: this.parsePropertyFlag(row.diy_type !== undefined ? row.diy_type : row.DiyType),
        measure_info: normalizedMeasureInfo,
      }
    },
    normalizeCategoryPropertyItem(item) {
      if (!item || typeof item !== 'object') return null
      const propertyValues = Array.isArray(item.property_values) ? item.property_values : []
      const options = Array.isArray(item.options) && item.options.length
        ? item.options
        : propertyValues.map(option => {
          const valueId = option.value_id !== undefined && option.value_id !== null && option.value_id !== ''
            ? option.value_id
            : (option.value !== undefined && option.value !== null && option.value !== '' ? option.value : option.name)
          return {
            ...option,
            name: option.name || option.value_name || String(valueId || ''),
            value_id: valueId,
            value: valueId,
          }
        })
      return {
        ...item,
        type: item.type || 'text',
        important_type: this.parsePropertyFlag(item.important_type || 0),
        required: this.parsePropertyFlag(item.required || item.is_required || 0),
        diy_type: this.parsePropertyFlag(item.diy_type || item.support_diy_type || 0),
        options,
        property_values: propertyValues,
        measure_templates: Array.isArray(item.measure_templates) ? item.measure_templates : [],
      }
    },
    normalizeCategoryPropertyPics(value) {
      if (!value || typeof value !== 'object') return {}
      const result = {}
      Object.keys(value).forEach(propertyId => {
        const item = value[propertyId]
        if (!item || typeof item !== 'object') return
        const urls = Array.isArray(item.urls)
          ? item.urls.map(url => String(url || '').trim()).filter(Boolean).slice(0, 1)
          : []
        if (!urls.length) return
        this.$set(result, String(propertyId), { urls })
      })
      return result
    },
    normalizeIncomingQualityList(value) {
      if (!Array.isArray(value)) return {}
      const result = {}
      value.forEach(item => {
        if (!item || typeof item !== 'object') return
        const key = String(item.quality_key || item.QualityKey || item.key || '').trim()
        if (!key) return
        const attachments = item.quality_attachments || item.QualityAttachments || []
        const urls = Array.isArray(attachments)
          ? attachments.map(row => String((row || {}).url || (row || {}).Url || '').trim()).filter(Boolean)
          : []
        if (!urls.length) return
        result[key] = {
          quality_key: key,
          quality_name: String(item.quality_name || item.QualityName || item.name || ''),
          urls: Array.from(new Set(urls)).slice(0, 20),
        }
      })
      return result
    },
    getQualityUrls(item) {
      const key = String((item || {}).key || '')
      const current = (((this.form || {}).quality_list || {})[key] || {}).urls
      return Array.isArray(current) ? current.filter(Boolean) : []
    },
    canAddQualityImage(item) {
      return this.getQualityUrls(item).length < 20
    },
    openQualityImageDialog(item) {
      const key = String((item || {}).key || '')
      if (!key) return
      const existingUrls = this.getQualityUrls(item)
      this.imageDialog = {
        visible: true,
        target: 'quality_list',
        multiple: true,
        index: -1,
        propertyId: key,
        title: '选择抖店素材图片',
        existingUrls,
        selectedUrls: [],
        maxSelect: Math.max(1, 20 - existingUrls.length),
      }
      this.materialMediaType = 'image'
      this.materialRootCategory = this.getDefaultMaterialRootCategory('image')
      this.materialFolders = []
      this.materialFolderId = ''
      this.materialList = []
      this.materialPagination.page = 1
      this.materialPagination.total = 0
      this.openMaterialDialog()
    },
    removeQualityImage(item, index) {
      const key = String((item || {}).key || '')
      const current = (((this.form || {}).quality_list || {})[key] || {}).urls
      if (!Array.isArray(current)) return
      current.splice(index, 1)
      if (!current.length) {
        this.$delete(this.form.quality_list, key)
      }
      this.markDirty()
    },
    buildQualityListForSubmit() {
      return this.qualificationRules.map(item => {
        const urls = this.getQualityUrls(item).slice(0, 20)
        if (!urls.length) return null
        return {
          quality_key: item.key,
          quality_name: item.name,
          quality_attachments: urls.map(url => ({
            media_type: 1,
            url,
          })),
        }
      }).filter(Boolean)
    },
    getPropertyPicRule(item) {
      return item && typeof item.property_pic_rule === 'object' ? item.property_pic_rule : null
    },
    shouldShowPropertyPicUploader(item) {
      const rule = this.getPropertyPicRule(item)
      if (!rule) return false
      if (this.getPropertyPicUrls(item).length) return true
      return this.parsePropertyFlag(rule.available || rule.required || 0) === 1
    },
    isRequiredPropertyPic(item) {
      const rule = this.getPropertyPicRule(item)
      return this.parsePropertyFlag((rule || {}).required || 0) === 1
    },
    getPropertyPicLimit() {
      return 1
    },
    getPropertyPicUrls(item) {
      const key = String((item || {}).property_id || '')
      const current = (((this.form || {}).category_property_pics || {})[key] || {}).urls
      return Array.isArray(current) ? current.filter(Boolean) : []
    },
    getPropertyPicItem(propertyId) {
      return (this.categoryProperties || []).find(item => String(item.property_id) === String(propertyId)) || null
    },
    canAddPropertyPic(item) {
      return this.getPropertyPicUrls(item).length < this.getPropertyPicLimit(item)
    },
    openPropertyPicDialog(item) {
      const propertyId = String((item || {}).property_id || '')
      if (!propertyId) return
      const existingUrls = this.getPropertyPicUrls(item)
      this.imageDialog = {
        visible: true,
        target: 'category_property_pics',
        multiple: false,
        index: -1,
        propertyId,
        title: '选择抖店素材图片',
        existingUrls,
        selectedUrls: [],
        maxSelect: 1,
      }
      this.openMaterialDialog()
    },
    removePropertyPic(item, index) {
      const propertyId = String((item || {}).property_id || '')
      const current = (((this.form || {}).category_property_pics || {})[propertyId] || {}).urls
      if (!Array.isArray(current)) return
      current.splice(index, 1)
      if (!current.length) {
        this.$delete(this.form.category_property_pics, propertyId)
      }
      this.markDirty()
    },
    updatePropertyValue(item, value) {
      const key = item.property_id
      if (item.type === 'multi_select') {
        this.form.product_format_new[key] = (Array.isArray(value) ? value : []).map(selected => {
          const option = (item.options || []).find(row => String(row.value_id) === String(selected))
          if (!option && this.canCreatePropertyOption(item)) {
            this.ensurePropertyOptionExists(item, selected)
          }
          return {
            value: Number(selected),
            name: option ? option.name : selected,
            diy_type: option ? 0 : 1,
          }
        })
        this.markDirty()
        return
      }
      if (item.type === 'select') {
        const option = (item.options || []).find(row => String(row.value_id) === String(value))
        if (!option && this.canCreatePropertyOption(item) && value !== '' && value !== null && value !== undefined) {
          this.ensurePropertyOptionExists(item, value)
        }
        this.form.product_format_new[key] = value === '' || value === null || value === undefined ? [] : [{
          value: option ? Number(option.value_id) : 0,
          name: option ? option.name : String(value),
          diy_type: option ? 0 : 1,
        }]
        this.markDirty()
        return
      }
      if (this.isTextProperty(item)) {
        this.form.product_format_new[key] = value === '' ? [] : [{
          value: 0,
          name: String(value),
          diy_type: 0,
        }]
        this.markDirty()
      }
    },
    addMeasureProperty(item) {
      const data = this.createDefaultMeasureItem(item)
      if (!data) {
        this.$message.warning('当前属性缺少可用模板')
        return
      }
      if (!Array.isArray(this.form.product_format_new[item.property_id])) {
        this.$set(this.form.product_format_new, item.property_id, [])
      }
      this.form.product_format_new[item.property_id].push(data)
      this.markDirty()
    },
    removeMeasureProperty(item, index) {
      if (!Array.isArray(this.form.product_format_new[item.property_id])) return
      this.form.product_format_new[item.property_id].splice(index, 1)
      this.markDirty()
    },
    getSpecCombinationCount(valueCounts) {
      const counts = (Array.isArray(valueCounts) ? valueCounts : this.specs.map(spec => (spec.values || []).length))
        .filter(count => Number(count) > 0)
      if (!counts.length) return 0
      return counts.reduce((total, count) => total * Number(count), 1)
    },
    isSpecCombinationLimitExceededForNewValue(specIndex) {
      if (!this.specCombinationLimit) return false
      const valueCounts = this.specs.map((spec, index) => {
        const count = (spec.values || []).length
        return index === specIndex ? count + 1 : count
      })
      if (specIndex < 0) {
        valueCounts.push(1)
      }
      return this.getSpecCombinationCount(valueCounts) > this.specCombinationLimit
    },
    isSpecTypeOptionDisabled(item) {
      return this.specs.some(spec => {
        const propertyId = spec.property_id !== undefined && spec.property_id !== null && spec.property_id !== ''
          ? spec.property_id
          : (spec.id !== undefined && spec.id !== null ? spec.id : '')
        return String(propertyId) === String(item.property_id)
      })
    },
    normalizeSpecRuleValues(values) {
      return (Array.isArray(values) ? values : []).map(item => {
        const rawValueId = item.sell_property_value_id !== undefined && item.sell_property_value_id !== null
          ? item.sell_property_value_id
          : (item.value_id !== undefined && item.value_id !== null ? item.value_id : '')
        return {
          value_id: String(rawValueId),
          value_name: item.sell_property_value_name || item.value_name || item.name || '',
        }
      }).filter(item => item.value_id !== '' && item.value_name)
    },
    getSpecRuleBySpec(spec) {
      if (!spec) return null
      const propertyId = spec.property_id !== undefined && spec.property_id !== null && spec.property_id !== ''
        ? spec.property_id
        : spec.id
      return this.specTypeRuleOptions.find(item => String(item.property_id) === String(propertyId)) || null
    },
    canSpecValueDiy(spec) {
      const rule = this.getSpecRuleBySpec(spec)
      return !rule || rule.support_diy
    },
    getSpecValueOptions(spec) {
      const rule = this.getSpecRuleBySpec(spec)
      return rule ? rule.property_values || [] : []
    },
    isSpecValueOptionDisabled(spec, option, currentValue) {
      return (spec.values || []).some(value => {
        return value !== currentValue && String(value.value_id) === String(option.value_id)
      })
    },
    getSpecValueNameFromPrices(spec, value) {
      for (const price of this.specPrices || []) {
        const row = (price.sell_properties || []).find(item => {
          const sameSpec = !item.property_name || !spec.name || String(item.property_name) === String(spec.name)
          if (!sameSpec) return false
          return String(item.value_id) === String(value.value_id) ||
            String(item.value_spec_detail_id) === String(value.id)
        })
        if (row && row.value_name) return row.value_name
      }
      return ''
    },
    findSpecRuleValueOption(spec, value) {
      const options = this.getSpecValueOptions(spec)
      const nameCandidates = [
        value.name,
        value.value_name,
        this.getSpecValueNameFromPrices(spec, value),
      ].map(item => String(item || '').trim()).filter(Boolean)
      return options.find(item => String(item.value_id) === String(value.value_id)) ||
        options.find(item => nameCandidates.includes(String(item.value_name || '').trim())) ||
        null
    },
    syncSpecValuesWithRules() {
      let changed = false
      this.specs.forEach(spec => {
        if (this.canSpecValueDiy(spec)) return
        ;(spec.values || []).forEach(value => {
          const option = this.findSpecRuleValueOption(spec, value)
          if (!option) {
            if (value.value_id !== '') {
              value.value_id = ''
              changed = true
            }
            return
          }
          if (String(value.value_id) !== String(option.value_id) || value.name !== option.value_name) {
            value.value_id = option.value_id
            value.name = option.value_name
            this.handleSpecValueInput(value)
            changed = true
          }
        })
      })
      if (changed) {
        this.specsBackup = clone(this.specs)
        this.specPricesBackup = clone(this.specPrices)
      }
    },
    addSpecDimension() {
      const inputValue = String(this.newSpecPropertyId || '').trim()
      if (!inputValue) {
        this.$message.warning('请选择规格类型')
        return
      }
      if (this.specs.length >= this.maxSpecNumLimit) {
        this.$message.warning(`最多支持 ${this.maxSpecNumLimit} 个规格类型`)
        return
      }
      const target = this.specTypeRuleOptions.find(item => {
        return String(item.property_id) === inputValue || String(item.property_name) === inputValue
      })
      if (!target && !this.supportSpecPropertyDiy) {
        this.$message.warning('当前类目不支持自定义规格类型')
        return
      }
      if (target && this.isSpecTypeOptionDisabled(target)) {
        this.$message.warning('该规格类型已添加')
        return
      }
      if (this.isSpecCombinationLimitExceededForNewValue(-1)) {
        this.$message.warning(`SKU组合数量不能超过 ${this.specCombinationLimit}`)
        return
      }
      if (target && !target.support_diy && !target.property_values.length) {
        this.$message.warning('当前规格项没有可选规格值')
        return
      }
      const customName = target ? '' : inputValue
      if (!target && this.specs.some(spec => String(spec.name).trim() === customName)) {
        this.$message.warning('规格类型已存在，请勿重复添加')
        return
      }
      const specId = target ? String(target.property_id) : `custom_spec_${Date.now()}`
      const specName = target ? (target.property_name || '规格') : customName
      this.specs.push({
        id: specId,
        property_id: specId,
        name: specName,
        values: [{
          name: '',
          value_id: target && !target.support_diy ? '' : '0',
          id: `${specId}_${Date.now()}`,
          pid: specId,
          remark: '',
          isClear: false,
        }],
      })
      this.newSpecPropertyId = ''
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.syncSpecSelectionState()
      this.markDirty()
    },
    addSpecValue(specIndex) {
      const spec = this.specs[specIndex]
      if (!spec) return
      if (this.specSingleLimit && (spec.values || []).length >= this.specSingleLimit) {
        this.$message.warning(`单个规格最多支持 ${this.specSingleLimit} 个规格值`)
        return
      }
      if (this.isSpecCombinationLimitExceededForNewValue(specIndex)) {
        this.$message.warning(`SKU组合数量不能超过 ${this.specCombinationLimit}`)
        return
      }
      if (!this.canSpecValueDiy(spec)) {
        const options = this.getSpecValueOptions(spec)
        if (!options.length) {
          this.$message.warning('当前规格项没有可选规格值')
          return
        }
        const hasBlankValue = (spec.values || []).some(value => value.value_id === '' || value.value_id === null || value.value_id === undefined)
        if (hasBlankValue) {
          this.$message.warning('请先选择已有空规格值')
          return
        }
        const usedIds = (spec.values || []).map(value => String(value.value_id))
        const hasAvailable = options.some(option => !usedIds.includes(String(option.value_id)))
        if (!hasAvailable) {
          this.$message.warning('当前规格项可选规格值已全部添加')
          return
        }
      }
      const data = {
        name: '',
        value_id: this.canSpecValueDiy(spec) ? '0' : '',
        id: `${spec.id}_${Date.now()}`,
        pid: spec.id,
        remark: '',
        isClear: false,
      }
      spec.values.push(data)
      if (specIndex === 0) {
        this.form.spec_pic.push({
          spec_detail_id: data.id,
          pic: this.form.pic[0] || '',
        })
      }
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.syncSpecSelectionState()
      this.markDirty()
    },
    removeSpecValue(specIndex, valueIndex) {
      const spec = this.specs[specIndex]
      if (!spec) return
      spec.values.splice(valueIndex, 1)
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      const allIds = this.allSpecValueIds.map(id => String(id))
      this.selectedSpecValueIds = this.selectedSpecValueIds.filter(id => allIds.includes(String(id)))
      this.syncSpecSelectionState()
      this.markDirty()
    },
    removeSpecDimension(index) {
      const spec = this.specs[index]
      if (!spec) return
      if ((spec.values || []).length) {
        this.$message.warning('请先删除该规格项下的规格值')
        return
      }
      this.specs.splice(index, 1)
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      const allIds = this.allSpecValueIds.map(id => String(id))
      this.selectedSpecValueIds = this.selectedSpecValueIds.filter(id => allIds.includes(String(id)))
      this.syncSpecSelectionState()
      this.markDirty()
    },
    moveSpecDimension(index, step) {
      const target = index + step
      if (target < 0 || target >= this.specs.length) return
      const current = this.specs.splice(index, 1)[0]
      this.specs.splice(target, 0, current)
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.syncSpecSelectionState()
      this.markDirty()
    },
    moveSpecValue(specIndex, valueIndex, step) {
      const spec = this.specs[specIndex]
      if (!spec || !Array.isArray(spec.values)) return
      const target = valueIndex + step
      if (target < 0 || target >= spec.values.length) return
      const current = spec.values.splice(valueIndex, 1)[0]
      spec.values.splice(target, 0, current)
      if (specIndex === 0) {
        this.alignSpecPics()
      }
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.syncSpecSelectionState()
      this.markDirty()
    },
    handleSpecValueInput(value) {
      this.specPrices.forEach(item => {
        if (!(item.spec_detail_ids || []).some(id => String(id) === String(value.id))) return
        ;(item.sell_properties || []).forEach(row => {
          if (String(row.value_spec_detail_id) === String(value.id)) {
            row.value_name = value.name
          }
        })
      })
      this.syncSizeChartWithSpecs()
      this.markDirty()
    },
    handleSpecValueSelect(spec, value) {
      const option = this.getSpecValueOptions(spec).find(item => String(item.value_id) === String(value.value_id))
      if (!option) return
      value.value_id = option.value_id
      value.name = option.value_name
      this.handleSpecValueInput(value)
    },
    restoreSpecValue(specIndex, valueIndex) {
      const backupValue = (((this.specsBackup || [])[specIndex] || {}).values || [])[valueIndex]
      if (!backupValue || !this.specs[specIndex]) return
      this.$set(this.specs[specIndex].values, valueIndex, clone(backupValue))
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.markDirty()
    },
    onClickClearStock(value) {
      value.isClear = !value.isClear
      this.toggleSpecValueStock(value)
    },
    toggleSpecValueStock(value) {
      this.specPrices.forEach((item, index) => {
        if (!(item.spec_detail_ids || []).some(id => String(id) === String(value.id))) return
        item.stock_num = value.isClear ? 0 : Number(((this.specPricesBackup[index] || {}).stock_num) || 0)
      })
      this.markDirty()
    },
    alignSpecPics() {
      const firstSpec = this.specs[0]
      if (!firstSpec || !Array.isArray(firstSpec.values)) {
        this.form.spec_pic = []
        return
      }
      const oldMap = {}
      ;(this.form.spec_pic || []).forEach(item => {
        if (item && item.spec_detail_id) {
          oldMap[item.spec_detail_id] = item.pic || ''
        }
      })
      this.form.spec_pic = firstSpec.values.map(value => ({
        spec_detail_id: value.id,
        pic: oldMap[value.id] || '',
      }))
    },
    recalculateSpecPrices() {
      const specs = this.specs.map(spec => spec.values || []).filter(values => values.length)
      const oldMap = {}
      this.specPrices.forEach(item => {
        oldMap[this.getSpecPriceKey(item.spec_detail_ids || [])] = item
      })
      const combinations = this.cartesianProduct(...specs)
      this.specPrices = combinations.map(group => {
        const sellProperties = group.map(value => {
          const parent = this.specs.find(spec => String(spec.id) === String(value.pid))
          return {
            value_name: value.name,
            property_name: parent ? parent.name : '',
            value_spec_detail_id: value.id,
          }
        })
        const ids = sellProperties.map(item => item.value_spec_detail_id)
        const old = oldMap[this.getSpecPriceKey(ids)]
        return {
          sell_properties: sellProperties,
          spec_detail_ids: ids,
          stock_num: old ? Number(old.stock_num || 0) : 0,
          price: old ? Number(old.price || 0) : 0,
          code: old ? old.code || '' : '',
          sku_status: old ? old.sku_status !== false : true,
        }
      })
    },
    cartesianProduct(...sets) {
      if (!sets.length) return []
      return sets.reduce((acc, set) => acc.flatMap(item => set.map(value => [...item, value])), [[]])
    },
    getSpecPriceKey(ids) {
      return clone(ids).sort().join('|')
    },
    formatSellProperties(list) {
      return (list || []).map(item => `${item.property_name}:${item.value_name}`).join('，')
    },
    handleAllSpecValuesChange(checked) {
      this.selectedSpecValueIds = checked ? clone(this.allSpecValueIds) : []
      this.syncSpecSelectionState()
    },
    handleSpecValueSelectionChange() {
      this.syncSpecSelectionState()
    },
    syncSpecSelectionState() {
      const total = this.allSpecValueIds.length
      const count = this.selectedSpecValueIds.length
      this.allSpecValuesSelected = total > 0 && count === total
      this.specSelectionIndeterminate = count > 0 && count < total
    },
    shouldApplySkuBatch(row) {
      if (this.batchForm.range === 'all') return true
      if (!this.selectedSpecValueIds.length) return false
      return (row.spec_detail_ids || []).some(id => this.selectedSpecValueIds.some(value => String(value) === String(id)))
    },
    ensureSelectedSkuRange() {
      if (this.batchForm.range === 'selected' && !this.selectedSpecValueIds.length) {
        this.$message.warning('请先勾选规格值')
        return false
      }
      return true
    },
    applyBatchPrice() {
      if (!this.ensureSelectedSkuRange() || this.batchForm.price === null) return
      this.specPrices.forEach(item => {
        if (this.shouldApplySkuBatch(item)) {
          item.price = Number(this.batchForm.price || 0)
        }
      })
      this.batchForm.price = null
      this.markDirty()
    },
    applyBatchStock() {
      if (!this.ensureSelectedSkuRange() || this.batchForm.stock === null) return
      this.specPrices.forEach(item => {
        if (this.shouldApplySkuBatch(item)) {
          item.stock_num = Number(this.batchForm.stock || 0)
        }
      })
      this.batchForm.stock = null
      this.markDirty()
    },
    applyBatchCode() {
      if (!this.ensureSelectedSkuRange()) return
      this.specPrices.forEach(item => {
        if (this.shouldApplySkuBatch(item)) {
          item.code = this.batchForm.code || ''
        }
      })
      this.batchForm.code = ''
      this.markDirty()
    },
    applyBatchSkuStatus() {
      if (!this.ensureSelectedSkuRange()) return
      this.specPrices.forEach(item => {
        if (this.shouldApplySkuBatch(item)) {
          item.sku_status = this.batchForm.sku_status
        }
      })
      if (!this.specPrices.some(item => item.sku_status !== false) && this.specPrices[0]) {
        this.specPrices[0].sku_status = true
      }
      this.markDirty()
    },
    initBatchRange() {
      this.batchRange.specs = this.specs.map(spec => ({
        id: spec.id,
        name: spec.name || '',
        values: (spec.values || []).map(v => ({ id: v.id, name: v.name || '' })),
        selectedIds: [],
        checkAll: false,
        indeterminate: false,
      }))
    },
    openAdvancedBatchDialog(type) {
      this.initBatchRange()
      this.visiblePrice = type === 'price'
      this.visibleStock = type === 'stock'
      this.visibleCode = type === 'code'
    },
    onBatchCheckAll(dimIndex) {
      const dim = this.batchRange.specs[dimIndex]
      if (!dim) return
      dim.selectedIds = dim.checkAll ? dim.values.map(v => v.id) : []
      dim.indeterminate = false
    },
    onBatchValueChange(dimIndex) {
      const dim = this.batchRange.specs[dimIndex]
      if (!dim) return
      const total = dim.values.length
      const checked = dim.selectedIds.length
      dim.checkAll = checked === total
      dim.indeterminate = checked > 0 && checked < total
    },
    matchBatchRange(row) {
      const dims = this.batchRange.specs.filter(d => d.selectedIds.length > 0)
      if (!dims.length) return false
      const rowIds = (row.spec_detail_ids || []).map(id => String(id))
      return dims.every(dim => dim.selectedIds.some(id => rowIds.includes(String(id))))
    },
    inBatchRange(row, range) {
      if (range === 'all') return true
      return this.matchBatchRange(row)
    },
    ensureBatchRange(range) {
      if (range === 'selected') {
        const hasSelection = this.batchRange.specs.some(d => d.selectedIds.length > 0)
        if (!hasSelection) {
          this.$message.warning('请先勾选要影响的规格值')
          return false
        }
      }
      return true
    },
    roundPrice(value) {
      return Math.max(0, Number(Number(value || 0).toFixed(2)))
    },
    applyAdvancedBatchPrice() {
      if (!this.ensureBatchRange(this.priceBatch.range)) return
      if (this.priceBatch.mode === 1 && this.priceBatch.value === null) return
      if (this.priceBatch.mode === 3 && this.priceBatch.decimal === null) return
      this.specPrices.forEach(item => {
        if (!this.inBatchRange(item, this.priceBatch.range)) return
        if (this.priceBatch.mode === 1) {
          item.price = this.roundPrice(this.priceBatch.value)
        }
        if (this.priceBatch.mode === 2) {
          const rate = this.priceBatch.rate === null ? 100 : Number(this.priceBatch.rate)
          item.price = this.roundPrice(Number(item.price || 0) * rate / 100 + Number(this.priceBatch.add || 0) - Number(this.priceBatch.dec || 0))
        }
        if (this.priceBatch.mode === 3) {
          const integer = Math.floor(Number(item.price || 0))
          const decimal = String(Number(this.priceBatch.decimal || 0)).slice(0, 2)
          item.price = this.roundPrice(`${integer}.${decimal}`)
        }
      })
      this.visiblePrice = false
      this.markDirty()
    },
    applyAdvancedBatchStock() {
      if (!this.ensureBatchRange(this.stockBatch.range)) return
      if (this.stockBatch.mode === 1 && this.stockBatch.value === null) return
      this.specPrices.forEach(item => {
        if (!this.inBatchRange(item, this.stockBatch.range)) return
        if (this.stockBatch.skipZero && Number(item.stock_num || 0) === 0) return
        if (this.stockBatch.mode === 1) {
          item.stock_num = Math.max(0, Number(this.stockBatch.value || 0))
        }
        if (this.stockBatch.mode === 2) {
          item.stock_num = Math.max(0, Number(item.stock_num || 0) + Number(this.stockBatch.add || 0))
        }
        if (this.stockBatch.mode === 3) {
          item.stock_num = Math.max(Number(this.stockBatch.min || 0), Number(item.stock_num || 0) - Number(this.stockBatch.dec || 0))
        }
      })
      this.visibleStock = false
      this.markDirty()
    },
    applyAdvancedBatchCode() {
      if (!this.ensureBatchRange(this.codeBatch.range)) return
      this.specPrices.forEach(item => {
        if (this.inBatchRange(item, this.codeBatch.range)) {
          item.code = this.codeBatch.value || ''
        }
      })
      this.visibleCode = false
      this.markDirty()
    },
    applyAllSkuStatus() {
      this.specPrices.forEach(item => {
        item.sku_status = this.allSkuStatus
      })
      if (!this.allSkuStatus && this.specPrices[0]) {
        this.specPrices[0].sku_status = true
      }
      this.visibleSkuStatus = false
      this.markDirty()
    },
    batchClearSelectedStock() {
      if (!this.selectedSpecValueIds.length) {
        this.$message.warning('请先勾选规格值')
        return
      }
      this.specPrices.forEach(item => {
        if ((item.spec_detail_ids || []).some(id => this.selectedSpecValueIds.some(value => String(value) === String(id)))) {
          item.stock_num = 0
        }
      })
      this.markDirty()
    },
    batchRemoveSelectedSpecValues() {
      if (!this.selectedSpecValueIds.length) {
        this.$message.warning('请选择要删除的规格')
        return
      }
      const selectedIds = this.selectedSpecValueIds.map(id => String(id))
      const willEmptySpec = this.specs.some(spec => {
        const rest = (spec.values || []).filter(value => !selectedIds.includes(String(value.id)))
        return !rest.length
      })
      if (willEmptySpec) {
        this.$message.error('请至少保留一个规格值')
        return
      }
      this.specs.forEach(spec => {
        spec.values = (spec.values || []).filter(value => !selectedIds.includes(String(value.id)))
      })
      this.selectedSpecValueIds = []
      this.alignSpecPics()
      this.recalculateSpecPrices()
      this.syncSizeChartWithSpecs()
      this.specsBackup = clone(this.specs)
      this.specPricesBackup = clone(this.specPrices)
      this.syncSpecSelectionState()
      this.markDirty()
    },
    selectedSpecValues() {
      const selected = []
      this.specs.forEach(spec => {
        ;(spec.values || []).forEach(value => {
          if (this.selectedSpecValueIds.some(id => String(id) === String(value.id))) {
            selected.push(value)
          }
        })
      })
      return selected
    },
    applyBatchRemark(applyAll) {
      const values = this.selectedSpecValues()
      if (!values.length) {
        this.$message.warning('请先勾选规格值')
        return
      }
      const mode = this.remarkForm.mode
      values.forEach(value => {
        if (!applyAll && value.remark) return
        if (mode === 1) {
          value.remark = this.remarkForm.remark1 || ''
        }
        if (mode === 2) {
          value.remark = `${this.remarkForm.prefix || ''}${value.remark || ''}${this.remarkForm.suffix || ''}`
        }
        if (mode === 3) {
          let remark = String(value.remark || '')
          this.remarkForm.pairs.forEach(pair => {
            if (pair.find) {
              remark = remark.replace(new RegExp(this.escapeRegExp(pair.find), 'g'), pair.replace || '')
            }
          })
          value.remark = remark
        }
        if (mode === 4) {
          let remark = String(value.remark || '')
          this.remarkForm.pairs.forEach(pair => {
            if (pair.find !== '' && remark === String(pair.find)) {
              remark = pair.replace || ''
            }
          })
          value.remark = remark
        }
        if (mode === 5 && this.remarkForm.remark5) {
          const words = String(this.remarkForm.remark5).split(',').map(item => item.trim()).filter(Boolean)
          words.forEach(word => {
            value.remark = String(value.remark || '').replace(new RegExp(this.escapeRegExp(word), 'g'), '')
          })
        }
        if (mode === 6) {
          value.remark = ''
        }
      })
      this.batchRemarkVisible = false
      this.markDirty()
    },
    addRemarkPair() {
      this.remarkForm.pairs.push({ find: '', replace: '' })
    },
    removeRemarkPair(index) {
      if (this.remarkForm.pairs.length > 1) {
        this.remarkForm.pairs.splice(index, 1)
      }
    },
    escapeRegExp(value) {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    openImageDialog(target, multiple, index = -1) {
      const existingUrls = {
        pic: this.form.pic,
        main_image_draft: this.mainImageEditor.images,
        description: this.form.description,
        main_image_three_to_four: this.form.main_image_three_to_four,
        spec_pic: this.form.spec_pic.map(item => item.pic).filter(Boolean),
        white_back_ground_pic_url: this.form.white_back_ground_pic_url ? [this.form.white_back_ground_pic_url] : [],
        long_pic_url: this.form.long_pic_url ? [this.form.long_pic_url] : [],
      }[target] || []

      this.imageDialog = {
        visible: true,
        target,
        multiple,
        index,
        propertyId: '',
        title: multiple ? '选择抖店素材图片' : '选择抖店素材图片',
        existingUrls,
        selectedUrls: [],
        maxSelect: this.getImageMaxSelect(target, multiple),
      }
      this.materialMediaType = 'image'
      this.materialRootCategory = this.getDefaultMaterialRootCategory('image')
      this.materialFolders = []
      this.materialFolderId = ''
      this.materialList = []
      this.materialPagination.page = 1
      this.materialPagination.total = 0
      this.openMaterialDialog()
    },
    getMaterialVideoCoverUrl(item) {
      const videoInfo = (item || {}).video_info || {}
      return String(
        videoInfo.video_cover_url ||
        videoInfo.VideoCoverUrl ||
        (item || {}).video_cover_url ||
        (item || {}).VideoCoverUrl ||
        (item || {}).cover_url ||
        ''
      )
    },
    getMaterialVideoPlayUrl(item) {
      const videoInfo = (item || {}).video_info || {}
      return String(
        videoInfo.main_url ||
        videoInfo.MainUrl ||
        (item || {}).main_url ||
        (item || {}).MainUrl ||
        ''
      )
    },
    getMaterialVideoVid(item) {
      const videoInfo = (item || {}).video_info || {}
      return String(videoInfo.vid || videoInfo.Vid || (item || {}).vid || (item || {}).Vid || '')
    },
    async queryMaterialVideoInfo(materialVideoId) {
      const id = String(materialVideoId || '').trim()
      if (!id) return {}
      const res = await this.actionRequest(this.getDoudianProductMaterialDetail, {
        id: this.productId,
        data: { vid: id },
      })
      const data = res.data || {}
      return {
        material_id: String(data.material_id || id),
        main_url: String(data.main_url || data.MainUrl || data.byte_url || data.url || ''),
        video_cover_url: String(data.video_cover_url || data.VideoCoverUrl || data.cover_url || ''),
      }
    },
    async loadMaterialVideoPreview() {
      const materialVideoId = String(this.form.material_video_id || '').trim()
      if (!materialVideoId || this.materialVideoPlayUrl || this.materialVideoCoverUrl) return
      try {
        const info = await this.queryMaterialVideoInfo(materialVideoId)
        if (String(this.form.material_video_id || '').trim() !== materialVideoId) return
        this.materialVideoCoverUrl = info.video_cover_url || ''
        this.materialVideoPlayUrl = info.main_url || ''
      } catch (error) {
        this.$message.error(error.message || '查询主图视频失败')
      }
    },
    async previewCurrentMaterialVideo() {
      const materialVideoId = String(this.form.material_video_id || '').trim()
      if (!materialVideoId) return
      try {
        if (!this.materialVideoPlayUrl) {
          const info = await this.queryMaterialVideoInfo(materialVideoId)
          this.materialVideoCoverUrl = info.video_cover_url || this.materialVideoCoverUrl
          this.materialVideoPlayUrl = info.main_url || ''
        }
        const url = this.materialVideoPlayUrl
        if (!url) {
          this.$message.warning('暂未获取到视频链接')
          return
        }
        this.previewDialog = { visible: true, url, type: 'video' }
      } catch (error) {
        this.$message.error(error.message || '查询主图视频失败')
      }
    },
    openMaterialVideoDialog() {
      this.imageDialog = {
        visible: true,
        target: 'material_video_id',
        multiple: false,
        index: -1,
        propertyId: '',
        title: '选择主图视频',
        existingUrls: this.form.material_video_id ? [this.form.material_video_id] : [],
        selectedUrls: [],
        maxSelect: 1,
      }
      this.materialMediaType = 'video'
      this.materialRootCategory = this.getDefaultMaterialRootCategory('video')
      this.materialFolders = []
      this.materialFolderId = ''
      this.materialList = []
      this.materialPagination.page = 1
      this.materialPagination.total = 0
      this.openMaterialDialog()
    },
    getImageMaxSelect(target, multiple) {
      if (!multiple) return 1
      const limits = {
        pic: 5,
        main_image_draft: 5,
        main_image_three_to_four: 5,
        description: 50,
      }
      const limit = limits[target] || 1
      const current = target === 'main_image_draft'
        ? this.mainImageEditor.images.length
        : (Array.isArray(this.form[target]) ? this.form[target].length : 0)
      return Math.max(1, limit - current)
    },
    async openMaterialDialog() {
      if (this.materialFolders.length) {
        this.loadMaterialFolderFiles()
        return
      }
      await this.loadMaterialFolders()
    },
    getDefaultMaterialRootCategory(mediaType = this.materialMediaType) {
      const current = (this.materialRootCategories || []).find(item => item.media_type === mediaType)
      return current ? String(current.id) : '0'
    },
    getCurrentMaterialFolderId() {
      const current = (this.materialFolders || []).find(item => String(item.folder_id) === String(this.materialFolderId))
      if (current && current.actual_folder_id !== undefined) {
        return String(current.actual_folder_id)
      }
      if (this.materialFolderId) {
        return String(this.materialFolderId)
      }
      return String(this.materialRootCategory || '')
    },
    async loadMaterialFolders() {
      this.materialLoading = true
      try {
        const res = await this.actionRequest(this.getDoudianProductMaterialFolders, {
          id: this.productId,
          data: {
            parent_folder_id: Number(this.materialRootCategory || 0),
          },
        })
        const folders = Array.isArray((res.data || {}).folder_info_list) ? res.data.folder_info_list : []
        const filteredFolders = folders.filter(item => Number(item.folder_attr) === 0 || Number(item.folder_attr) === 1)
        this.materialFolders = filteredFolders.length ? filteredFolders : folders
        const previousFolderId = String(this.materialFolderId || '')
        const hasPreviousFolder = this.materialFolders.some(item => String(item.folder_id) === previousFolderId)
        if (!hasPreviousFolder) {
          this.materialFolderId = (this.materialMediaType === 'video' && String(this.materialRootCategory) === '2' && this.materialFolders.length)
            ? this.materialFolders[0].folder_id
            : ''
        }
        await this.loadMaterialFolderFiles()
      } catch (error) {
        this.$message.error(error.message || '获取抖店素材文件夹失败')
      } finally {
        this.materialLoading = false
      }
    },
    async loadMaterialFolderFiles() {
      const folderId = this.getCurrentMaterialFolderId()
      if (!folderId) return
      this.materialLoading = true
      try {
        const res = await this.actionRequest(this.getDoudianProductMaterialFolderFiles, {
          id: this.productId,
          data: {
            folder_id: folderId,
            page: this.materialPagination.page,
            size: this.materialPagination.size,
          },
        })
        const folderInfo = (res.data || {}).folder_info || {}
        const childMaterials = Array.isArray(folderInfo.child_material) ? folderInfo.child_material : []
        this.materialList = childMaterials.filter(item => this.materialMediaType === 'video' ? this.getMaterialSelectValue(item) : item.byte_url)
        this.materialPagination.total = Number(folderInfo.total_child_material_num || 0)
      } catch (error) {
        this.$message.error(error.message || '获取抖店素材图片失败')
      } finally {
        this.materialLoading = false
      }
    },
    selectMaterialFolder(item) {
      this.materialFolderId = item.folder_id
      this.materialPagination.page = 1
      this.loadMaterialFolderFiles()
    },
    switchMaterialRootCategory(categoryId) {
      if (String(this.materialRootCategory) === String(categoryId)) return
      this.materialRootCategory = String(categoryId)
      this.materialFolders = []
      this.materialFolderId = ''
      this.materialList = []
      this.materialPagination.page = 1
      this.materialPagination.total = 0
      this.loadMaterialFolders()
    },
    switchMaterialMediaType(mediaType) {
      if (this.materialMediaType === mediaType) return
      this.materialMediaType = mediaType
      this.materialRootCategory = this.getDefaultMaterialRootCategory(mediaType)
      this.materialFolders = []
      this.materialFolderId = ''
      this.materialList = []
      this.materialPagination.page = 1
      this.materialPagination.total = 0
      this.loadMaterialFolders()
    },
    handleMaterialSizeChange(size) {
      this.materialPagination.size = size
      this.materialPagination.page = 1
      this.loadMaterialFolderFiles()
    },
    handleMaterialPageChange(page) {
      this.materialPagination.page = page
      this.loadMaterialFolderFiles()
    },
    beforeDoudianImageUpload(file) {
      const name = String((file && file.name) || '').toLowerCase()
      const isImage = /\.(jpg|png)$/.test(name)
      if (!isImage) {
        this.$message.error('仅支持 jpg、png 图片')
        return false
      }
      const maxSize = 10
      const isLtMax = file.size / 1024 / 1024 <= maxSize
      if (!isLtMax) {
        this.$message.error(`图片大小不能超过 ${maxSize}M`)
        return false
      }
      return true
    },
    beforeDoudianVideoUpload(file) {
      const name = String((file && file.name) || '').toLowerCase()
      if (!/\.mp4$/.test(name)) {
        this.$message.error('仅支持 mp4 视频')
        return false
      }
      const maxSize = 200
      if (file.size / 1024 / 1024 > maxSize) {
        this.$message.error(`视频大小不能超过 ${maxSize}M`)
        return false
      }
      return true
    },
    beforeDoudianMaterialUpload(file) {
      return this.materialMediaType === 'video'
        ? this.beforeDoudianVideoUpload(file)
        : this.beforeDoudianImageUpload(file)
    },
    async uploadDoudianMaterial(param) {
      const materialType = this.materialMediaType === 'video' ? 'video' : 'image'
      this.materialUploading = true
      try {
        const sourceUrl = await this.uploadMaterialFileToTempOss(param, materialType)
        if (materialType === 'video') {
          await this.uploadDoudianMaterialVideo(param, sourceUrl)
        } else {
          await this.uploadDoudianMaterialImage(sourceUrl)
        }
        if (param && param.onSuccess) {
          param.onSuccess({ code: 200, data: { url: sourceUrl, address: sourceUrl } })
        }
      } catch (error) {
        if (param && param.onError) param.onError(error)
        this.$message.error(error.message || '上传到抖店素材库失败')
      } finally {
        this.materialUploading = false
      }
    },
    async uploadDoudianMaterialImage(sourceUrl) {
      const res = await this.actionRequest(this.uploadDoudianProductMaterialImage, {
        id: this.productId,
        data: {
          source_url: sourceUrl,
          folder_id: this.getCurrentMaterialFolderId() || '0',
        },
      })
      const uploadData = res.data || {}
      const auditStatus = Number(uploadData.audit_status || 0)
      const url = ((res.data || {}).byte_url || (res.data || {}).url || '')
      if (auditStatus === 1 || auditStatus === 2) {
        this.$message.success('图片上传成功，审核中，请稍后刷新查看')
        return
      }
      if (auditStatus === 4) {
        this.$message.error('图片上传拒绝')
        return
      }
      if (!url) {
        throw new Error('抖店未返回图片地址')
      }
      this.addSelectedMaterialItem({ byte_url: url })
      this.$message.success(res.message || '已上传到抖店素材库')
      await this.loadMaterialFolderFiles()
    },
    async uploadDoudianMaterialVideo(param, sourceUrl) {
      const res = await this.actionRequest(this.uploadDoudianProductMaterialVideo, {
        id: this.productId,
        data: {
          source_url: sourceUrl,
          folder_id: this.getCurrentMaterialFolderId() || '0',
          name: this.getMaterialUploadName(param && param.file),
        },
      })
      const uploadData = res.data || {}
      const auditStatus = Number(uploadData.audit_status || 0)
      const materialId = String(uploadData.material_id || '')
      if (auditStatus === 0) {
        this.$message.success('视频上传成功，下载中，请稍后刷新查看')
        return
      }
      if (auditStatus === 1 || auditStatus === 2) {
        this.$message.success('视频上传成功，审核中，请稍后刷新查看')
        return
      }
      if (auditStatus === 4) {
        this.$message.error('视频上传拒绝')
        return
      }
      if (!materialId) {
        throw new Error('抖店未返回素材ID')
      }
      this.addSelectedMaterialItem({
        material_id: materialId,
        byte_url: uploadData.byte_url || uploadData.url || '',
      })
      this.$message.success(res.message || '已上传到抖店素材库')
      await this.loadMaterialFolderFiles()
    },
    async uploadMaterialFileToTempOss(param, materialType = 'image') {
      const file = param && param.file
      if (!file) {
        throw new Error(materialType === 'video' ? '请选择上传的视频' : '请选择上传的图片')
      }
      const result = await uploadDirectOss(file, {
        policyUrl: `${config.baseApi}/merchant/doudian-products/${this.productId}/material/oss-upload-token`,
        policyParams: { material_type: materialType },
        timeout: materialType === 'video' ? 600000 : 60000,
        onProgress: event => param && param.onProgress && param.onProgress(event),
      })
      return result.url
    },
    getMaterialUploadName(file) {
      const rawName = String((file && file.name) || '视频.mp4').trim() || '视频.mp4'
      const ext = '.mp4'
      const lowerName = rawName.toLowerCase()
      const name = lowerName.endsWith(ext) ? rawName : `${rawName}${ext}`
      if (name.length <= 50) return name
      return `${name.slice(0, 50 - ext.length)}${ext}`
    },
    getMaterialSelectValue(item) {
      if (!item) return ''
      if (this.materialMediaType === 'video' || this.imageDialog.target === 'material_video_id') {
        return this.getMaterialVideoVid(item) || String(item.video_id || item.material_id || item.MaterialId || item.id || '')
      }
      return String(item.byte_url || '')
    },
    isMaterialSelected(item) {
      const value = this.getMaterialSelectValue(item)
      return value ? this.imageDialog.selectedUrls.includes(value) : false
    },
    async previewMaterialVideoItem(item) {
      let url = this.getMaterialVideoPlayUrl(item)
      const videoId = this.getMaterialVideoVid(item)
      try {
        if (!url && videoId) {
          const info = await this.queryMaterialVideoInfo(videoId)
          url = info.main_url || ''
          if (item) {
            if (info.main_url) this.$set(item, 'main_url', info.main_url)
            if (info.video_cover_url) this.$set(item, 'video_cover_url', info.video_cover_url)
          }
        }
        if (!url) {
          this.$message.warning('暂未获取到视频链接')
          return
        }
        this.previewDialog = { visible: true, url, type: 'video' }
      } catch (error) {
        this.$message.error(error.message || '查询视频失败')
      }
    },
    toggleMaterialItem(item) {
      this.addSelectedMaterialItem(item)
    },
    addSelectedMaterialItem(item) {
      const value = this.getMaterialSelectValue(item)
      if (!value) return
      const selected = this.imageDialog.selectedUrls
      const index = selected.indexOf(value)
      if (index >= 0) {
        selected.splice(index, 1)
        return
      }
      if (selected.length >= this.imageDialog.maxSelect) {
        this.$message.warning(`最多选择${this.imageDialog.maxSelect}${this.materialSelectUnit}`)
        return
      }
      selected.push(value)
    },
    useMaterialItem(item) {
      const value = this.getMaterialSelectValue(item)
      if (!value) return
      if (!this.isMaterialSelected(item)) {
        this.addSelectedMaterialItem(item)
      }
      this.confirmMaterialImages()
    },
    handleMaterialDeleteCommand(command) {
      if (!command) return
      this.deleteCurrentFolderMaterials(command)
    },
    async deleteCurrentFolderMaterials(operateType = 'to_recycle') {
      const folderId = this.getCurrentMaterialFolderId()
      if (!folderId) {
        this.$message.warning('当前目录无效，暂无法删除素材')
        return
      }
      const mediaLabel = this.materialMediaType === 'video' ? '视频' : '图片'
      const folderLabel = this.materialFolderId
        ? (((this.materialFolders || []).find(item => String(item.folder_id) === String(this.materialFolderId)) || {}).name || '当前文件夹')
        : (((this.visibleMaterialRootCategories || []).find(item => String(item.id) === String(this.materialRootCategory)) || {}).name || '当前目录')
      const isDeleteForever = operateType === 'delete_forever'
      const confirmText = isDeleteForever
        ? `确定彻底删除${folderLabel}下的${mediaLabel}素材吗？删除后不可恢复。`
        : `确定将${folderLabel}下的${mediaLabel}素材移入回收站吗？`
      const confirmButtonText = isDeleteForever ? '彻底删除' : '移入回收站'
      try {
        await this.$confirm(confirmText, '提示', {
          type: 'warning',
          confirmButtonText,
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
      } catch (error) {
        return
      }

      this.materialDeleting = true
      try {
        const res = await this.actionRequest(this.recycleDoudianProductMaterialFolderFiles, {
          id: this.productId,
          data: {
            folder_id: folderId,
            material_type: this.materialMediaType,
            operate_type: operateType,
          },
        })
        this.imageDialog.selectedUrls = []
        this.materialPagination.page = 1
        await this.loadMaterialFolderFiles()
        this.$message.success((res && res.message) || (isDeleteForever ? '已彻底删除' : '已移入回收站'))
      } catch (error) {
        this.$message.error(error.message || '删除素材失败')
      } finally {
        this.materialDeleting = false
      }
    },
    confirmMaterialImages() {
      if (!this.imageDialog.selectedUrls.length) {
        this.$message.warning(this.imageDialog.target === 'material_video_id' ? '请选择视频' : '请选择图片')
        return
      }
      this.handleImageSelected(clone(this.imageDialog.selectedUrls))
      this.imageDialog.visible = false
    },
    handleImageSelected(urls) {
      if (!Array.isArray(urls) || !urls.length) return
      const target = this.imageDialog.target
      if (target === 'material_video_id') {
        this.form.material_video_id = urls[0]
        const selectedItem = (this.materialList || []).find(item => this.getMaterialSelectValue(item) === urls[0])
        this.materialVideoCoverUrl = selectedItem ? this.getMaterialVideoCoverUrl(selectedItem) : ''
        this.materialVideoPlayUrl = selectedItem ? this.getMaterialVideoPlayUrl(selectedItem) : ''
        this.markDirty()
        return
      }
      if (target === 'main_image_draft') {
        const current = this.mainImageEditor.images || []
        const merged = current.concat(urls.filter(url => !current.includes(url)))
        this.$set(this.mainImageEditor, 'images', merged.slice(0, 5))
        return
      }
      if (target === 'spec_pic') {
        if (this.form.spec_pic[this.imageDialog.index]) {
          this.$set(this.form.spec_pic[this.imageDialog.index], 'pic', urls[0])
        }
        this.markDirty()
        return
      }
      if (target === 'white_back_ground_pic_url' || target === 'long_pic_url') {
        this.form[target] = urls[0]
        this.markDirty()
        return
      }
      if (target === 'category_property_pics') {
        const propertyId = String(this.imageDialog.propertyId || '')
        if (!propertyId) return
        const current = ((((this.form || {}).category_property_pics || {})[propertyId] || {}).urls || [])
        const merged = current.concat(urls.filter(url => !current.includes(url)))
        const propertyItem = this.getPropertyPicItem(propertyId)
        this.$set(this.form.category_property_pics, propertyId, {
          urls: merged.slice(0, this.getPropertyPicLimit(propertyItem || { property_id: propertyId })),
        })
        this.markDirty()
        return
      }
      if (target === 'quality_list') {
        const key = String(this.imageDialog.propertyId || '')
        if (!key) return
        const current = ((((this.form || {}).quality_list || {})[key] || {}).urls || [])
        const merged = current.concat(urls.filter(url => !current.includes(url))).slice(0, 20)
        const rule = this.qualificationRules.find(item => item.key === key) || {}
        this.$set(this.form.quality_list, key, {
          quality_key: key,
          quality_name: rule.name || '',
          urls: merged,
        })
        this.markDirty()
        return
      }
      const current = Array.isArray(this.form[target]) ? this.form[target] : []
      const merged = current.concat(urls.filter(url => !current.includes(url)))
      this.$set(this.form, target, merged)
      this.markDirty()
    },
    clearMaterialVideo() {
      this.form.material_video_id = ''
      this.materialVideoCoverUrl = ''
      this.materialVideoPlayUrl = ''
      this.markDirty()
    },
    clearSpecPic(index) {
      if (this.form.spec_pic[index]) {
        this.$set(this.form.spec_pic[index], 'pic', '')
      }
      this.markDirty()
    },
    ensurePropertyOptionExists(item, value) {
      const label = String(value || '').trim()
      if (!label) return
      if (!Array.isArray(item.options)) {
        this.$set(item, 'options', [])
      }
      const exists = item.options.some(option => String(option.value_id) === label || String(option.name) === label)
      if (!exists) {
        item.options.push({
          name: label,
          value_id: label,
          value: label,
        })
      }
    },
    formatMeasureValueWithUnit(item) {
      const value = item && item.value !== undefined && item.value !== null ? String(item.value).trim() : ''
      if (!value) return ''
      return `${(item || {}).prefix || ''}${value}${(item || {}).unit_name || ''}${(item || {}).suffix || ''}`
    },
    composeMeasureRowName(item) {
      const values = (((item || {}).measure_info || {}).values || [])
      return values.map(value => this.formatMeasureValueWithUnit(value)).filter(Boolean).join('')
    },
    syncMeasurePropertyName(propertyItem, item) {
      if (propertyItem) {
        const modules = this.getMeasureModules(propertyItem, item)
        const values = ((((item || {}).measure_info) || {}).values) || []
        values.forEach((value, index) => {
          if (value.unit_name) return
          const module = modules[index] || {}
          const firstUnit = (((module || {}).units) || [])[0] || {}
          value.unit_name = firstUnit.unit_name || ''
          value.unit_id = value.unit_id || firstUnit.unit_id || 0
          value.prefix = value.prefix || module.prefix || ''
          value.suffix = value.suffix || module.suffix || ''
        })
      }
      item.name = this.composeMeasureRowName(item)
      this.markDirty()
    },
    moveImage(key, index, step) {
      const list = this.form[key]
      const target = index + step
      if (!Array.isArray(list) || target < 0 || target >= list.length) return
      const current = list.splice(index, 1)[0]
      list.splice(target, 0, current)
      this.markDirty()
    },
    removeImage(key, index) {
      if (!Array.isArray(this.form[key])) return
      this.form[key].splice(index, 1)
      this.markDirty()
    },
    markDirty() {
      if (this.bootstrapping) return
      this.dirty = this.serializeDirtyState() !== this.initialDirtySnapshot
    },
    buildSpecInfo() {
      return {
        spec_values: this.specs.map(spec => ({
          property_name: spec.name,
          property_id: spec.property_id,
          values: (spec.values || []).map(value => {
            const data = {
              value_name: value.name,
              value_id: value.value_id,
            }
            if (value.remark) {
              data.remark = value.remark
            }
            return data
          }),
        })),
      }
    },
    buildSpecPrices() {
      return this.specPrices.map(item => ({
        sell_properties: (item.sell_properties || []).map(row => ({
          value_name: row.value_name,
          property_name: row.property_name,
        })),
        stock_num: Number(item.stock_num || 0),
        price: Number(item.price || 0),
        code: item.code || '',
        sku_status: item.sku_status !== false,
      }))
    },
    buildProductFormatNewForSubmit() {
      const result = {}
      Object.keys(this.form.product_format_new || {}).forEach(key => {
        const propertyItem = (this.categoryProperties || []).find(item => String(item.property_id) === String(key))
        const current = clone(this.form.product_format_new[key] || [])
        if (propertyItem && this.isMeasureProperty(propertyItem)) {
          const measureRows = current.filter(row => this.isMeasureRowStarted(row))
          result[key] = (this.isMultiValueMeasureProperty(propertyItem) ? measureRows : measureRows.slice(0, 1)).map(row => ({
            ...row,
            name: this.composeMeasureRowName(row),
          }))
          return
        }
        result[key] = current
      })
      return result
    },
    syncThreeGuarantees() {
      const serviceType = this.threeGuarantees.service_type
      const duration = this.threeGuarantees.duration
      if (!serviceType) {
        this.form.after_sale_service_v2 = {}
        return
      }
      this.form.after_sale_service_v2 = {
        is_large_product: 0,
        three_guarantees: {
          service_type: Number(serviceType),
          duration: duration === '' || duration === null ? 0 : Number(duration),
        },
      }
    },
    syncSupplyDayReturnSelector() {
      if (!this.form.after_sale_service || typeof this.form.after_sale_service !== 'object') {
        this.$set(this.form, 'after_sale_service', {})
      }
      const current = String(this.form.after_sale_service.supply_day_return_selector || '').trim()
      const matched = this.supplyDayOptions.find(item => item.value === current)
        || (/^\d+$/.test(current)
          ? this.supplyDayOptions.find(item => item.value.startsWith(`${current}-`))
          : null)
      const nextValue = matched
        ? matched.value
        : (this.supplyDayReturnRequired && this.supplyDayOptions.length ? this.supplyDayOptions[0].value : '')
      this.$set(this.form.after_sale_service, 'supply_day_return_selector', nextValue)
    },
    buildAfterSaleServiceForSubmit() {
      const current = String(((this.form.after_sale_service || {}).supply_day_return_selector) || '').trim()
      const matched = this.supplyDayOptions.find(item => item.value === current)
      if (!matched) return {}
      return {
        supply_day_return_selector: matched.value,
      }
    },
    validateRequiredProperties() {
      const requiredProperties = (this.categoryProperties || []).filter(item => this.isRequiredProperty(item))
      for (const item of requiredProperties) {
        const key = item.property_id
        const current = this.form.product_format_new[key]
        if (item.type === 'multi_select') {
          if (!Array.isArray(current) || !current.length) {
            this.$message.warning(`请填写必填属性：${item.property_name}`)
            return false
          }
          continue
        }
        if (this.isMeasureProperty(item)) {
          const measureRows = Array.isArray(current) ? current : []
          const hasCompleteRow = measureRows.some(row => this.isMeasureRowComplete(item, row))
          const hasIncompleteRow = measureRows.some(row => this.isMeasureRowStarted(row) && !this.isMeasureRowComplete(item, row))
          if (!hasCompleteRow || hasIncompleteRow) {
            this.$message.warning(`请填写必填属性：${item.property_name}`)
            return false
          }
          continue
        }
        if (!Array.isArray(current) || !current.length) {
          this.$message.warning(`请填写必填属性：${item.property_name}`)
          return false
        }
        const first = current[0] || {}
        const value = this.isTextProperty(item)
          ? String(first.name || '').trim()
          : String(first.diy_type === 1 ? (first.name || '') : (first.value || '')).trim()
        if (!value) {
          this.$message.warning(`请填写必填属性：${item.property_name}`)
          return false
        }
      }
      return true
    },
    validateMeasureProperties() {
      const measureProperties = (this.categoryProperties || []).filter(item => this.isMeasureProperty(item))
      for (const item of measureProperties) {
        const rows = this.getMeasureRows(item)
        const hasIncompleteRow = rows.some(row => this.isMeasureRowStarted(row) && !this.isMeasureRowComplete(item, row))
        if (hasIncompleteRow) {
          this.$message.warning(`请完整填写度量衡属性：${item.property_name}`)
          return false
        }
        for (const row of rows) {
          if (!this.isMeasureRowStarted(row)) continue
          const invalid = this.validateMeasureRowRules(item, row)
          if (invalid) {
            this.$message.warning(invalid)
            return false
          }
        }
        const percentError = this.validateMeasurePercentTotals(item, rows)
        if (percentError) {
          this.$message.warning(percentError)
          return false
        }
      }
      return true
    },
    validateRequiredPropertyPics() {
      const requiredPicProperties = (this.categoryProperties || []).filter(item => this.isRequiredPropertyPic(item))
      for (const item of requiredPicProperties) {
        if (!this.getPropertyPicUrls(item).length) {
          this.$message.warning(`请上传${item.property_name}的水洗标/吊牌图`)
          return false
        }
      }
      return true
    },
    validateRequiredQualifications() {
      const requiredRules = this.qualificationRules.filter(item => item.is_required)
      for (const item of requiredRules) {
        if (!this.getQualityUrls(item).length) {
          this.$message.warning(`请上传必填资质：${item.name}`)
          return false
        }
      }
      return true
    },
    validateMeasurePercentTotals(item, rows) {
      const totals = {}
      rows.forEach(row => {
        if (!this.isMeasureRowStarted(row)) return
        const values = (((row || {}).measure_info || {}).values || [])
        values.forEach((value, index) => {
          if (!this.isMeasurePercentValue(value)) return
          const numericValue = Number(value.value || 0)
          if (!Number.isFinite(numericValue)) return
          const key = `${(value && value.module_id) || index}`
          totals[key] = (totals[key] || 0) + numericValue
        })
      })
      const overflowEntry = Object.values(totals).find(total => Number(total) > 100 + 0.000001)
      if (overflowEntry === undefined) {
        return ''
      }
      return `${item.property_name} 百分比合计不能超过100%，当前为 ${Number(overflowEntry).toFixed(2)}%`
    },
    isMeasurePercentValue(value) {
      const unitName = String(((value || {}).unit_name) || '').trim()
      return unitName.includes('%')
    },
    validateMeasureRowRules(item, row) {
      const modules = this.getMeasureModules(item, row)
      const values = (((row || {}).measure_info || {}).values || [])
      for (let index = 0; index < modules.length; index++) {
        const module = modules[index] || {}
        const current = values[index] || {}
        const rawValue = current.value
        const stringValue = String(rawValue === undefined || rawValue === null ? '' : rawValue).trim()
        if (!stringValue) continue
        if (!this.isMeasureNumericModule(module)) continue
        const numericValue = Number(rawValue)
        if (!Number.isFinite(numericValue)) {
          return `${item.property_name} 需要填写有效数值`
        }
        const min = this.getMeasureModuleMin(module)
        if (min !== undefined && numericValue < min) {
          return `${item.property_name} 不能小于 ${min}`
        }
        const max = this.getMeasureModuleMax(module)
        if (max !== undefined && numericValue > max) {
          return `${item.property_name} 不能大于 ${max}`
        }
        const precision = this.getMeasureModulePrecision(module)
        if (precision >= 0 && stringValue.includes('.')) {
          const decimalPart = stringValue.split('.')[1] || ''
          if (decimalPart.length > precision) {
            return `${item.property_name} 最多保留 ${precision} 位小数`
          }
        }
      }
      return ''
    },
    isMeasureRowStarted(row) {
      const values = (((row || {}).measure_info || {}).values || [])
      return values.some(value => String((value && value.value) || '').trim() !== '')
    },
    isMeasureRowComplete(item, row) {
      const modules = this.getMeasureModules(item, row)
      const values = (((row || {}).measure_info || {}).values || [])
      if (!modules.length) return false
      return modules.every((module, index) => {
        const current = values[index] || {}
        const required = this.parsePropertyFlag(module.value_required !== undefined ? module.value_required : 1) === 1
        if (!required) return true
        return String(current.value || '').trim() !== ''
      })
    },
    validateSpecRules() {
      if (this.specs.length > this.maxSpecNumLimit) {
        this.$message.warning(`最多支持 ${this.maxSpecNumLimit} 个规格类型`)
        return false
      }
      if (!this.supportSpecPropertyDiy) {
        const customSpec = this.specs.find(spec => String(spec.property_id || spec.id || '').indexOf('custom_spec_') === 0)
        if (customSpec) {
          this.$message.warning('当前类目不支持自定义规格类型')
          return false
        }
      }
      if (this.specSingleLimit) {
        const overLimitSpec = this.specs.find(spec => (spec.values || []).length > this.specSingleLimit)
        if (overLimitSpec) {
          this.$message.warning(`单个规格最多支持 ${this.specSingleLimit} 个规格值`)
          return false
        }
      }
      if (this.specCombinationLimit && this.getSpecCombinationCount() > this.specCombinationLimit) {
        this.$message.warning(`SKU组合数量不能超过 ${this.specCombinationLimit}`)
        return false
      }
      if (!this.validateSpecValueRules()) {
        return false
      }
      if (this.allSpecPicRequired && this.specPicRows.length) {
        const filledCount = this.specPicRows.filter(item => item.pic).length
        if (filledCount > 0 && filledCount < this.specPicRows.length) {
          this.$message.warning('规格图需要全部设置或全部不设置')
          return false
        }
      }
      return true
    },
    validateSpecValueRules() {
      for (const spec of this.specs) {
        if (this.canSpecValueDiy(spec)) continue
        const options = this.getSpecValueOptions(spec)
        if (!options.length) {
          this.$message.warning(`${spec.name || '规格项'}没有可选规格值`)
          return false
        }
        for (const value of spec.values || []) {
          const option = options.find(item => String(item.value_id) === String(value.value_id))
          if (!option) {
            this.$message.warning(`${spec.name || '规格项'}只能选择发布规则中的规格值`)
            return false
          }
          value.value_id = option.value_id
          value.name = option.value_name
        }
      }
      return true
    },
    validateBeforeSubmit() {
      if (!this.form.name.trim()) {
        this.$message.warning('请填写商品标题')
        return false
      }
      const titleLength = getLengthConsideringChineseChars(this.form.name.trim())
      if (titleLength < 8) {
        this.$message.warning('商品标题至少8个字符（4个汉字）')
        return false
      }
      if (titleLength > 60) {
        this.$message.warning('商品标题最多60个字符（30个汉字）')
        return false
      }
      if (!this.currentCategoryLeafId) {
        this.$message.warning('请选择商品类目')
        return false
      }
      if (this.supplyDayReturnRequired && !this.buildAfterSaleServiceForSubmit().supply_day_return_selector) {
        this.$message.warning('请选择当前类目要求的退货天数')
        return false
      }
      if (this.titleNeedsPrediction) {
        this.$message.warning('商品标题已修改，请先确认标题并完成类目预测')
        return false
      }
      if (this.mainImagesNeedPrediction) {
        this.$message.warning('商品主图已修改，请先确认主图并完成类目预测')
        return false
      }
      if (this.categoryNeedsPrediction) {
        this.$message.warning('商品类目已修改，请重新完成类目预测')
        return false
      }
      if (!this.form.pic.length) {
        this.$message.warning('请至少保留一张商品主图')
        return false
      }
      if (!this.form.description.length) {
        this.$message.warning('请至少保留一张详情图')
        return false
      }
      if (!this.specPrices.length) {
        this.$message.warning('请至少保留一个SKU')
        return false
      }
      if (!this.validateSpecRules()) {
        return false
      }
      const invalidPrice = this.specPrices.find(item => Number(item.price || 0) <= 0)
      if (invalidPrice) {
        this.$message.warning('SKU价格必须大于0')
        return false
      }
      if (!this.validateRequiredProperties()) {
        return false
      }
      if (!this.validateMeasureProperties()) {
        return false
      }
      if (!this.validateRequiredPropertyPics()) {
        return false
      }
      if (!this.validateRequiredQualifications()) {
        return false
      }
      if (!this.validateSizeChart()) {
        return false
      }
      return true
    },
    async submit(keepOpen = false) {
      this.syncThreeGuarantees()
      if (!this.validateBeforeSubmit()) return
      this.saving = true
      try {
        const payload = {
          name: this.form.name.trim(),
          short_product_name: this.form.short_product_name.trim(),
          standard_brand_id: this.form.standard_brand_id,
          reduce_type: this.form.reduce_type,
          freight_id: this.form.freight_id,
          start_sale_type: this.form.start_sale_type,
          presell_type: this.normalizePresellType(this.form.presell_type),
          delivery_delay_day: this.isSpotDeliveryMode ? this.normalizeDeliveryDelayDay(this.form.delivery_delay_day) : this.form.delivery_delay_day,
          presell_delay: this.form.presell_delay,
          presell_end_time: this.form.presell_end_time,
          maximum_per_order: this.form.maximum_per_order,
          minimum_per_order: this.form.minimum_per_order,
          limit_per_buyer: this.form.limit_per_buyer,
          is_evaluate_opened: this.form.is_evaluate_opened,
          reference_price: this.form.reference_price,
          after_sale_service: this.buildAfterSaleServiceForSubmit(),
          after_sale_service_v2: this.form.after_sale_service_v2,
          category_leaf_id: this.currentCategoryLeafId,
          pic: clone(this.form.pic),
          description: clone(this.form.description),
          spec_pic: this.form.spec_pic.map(item => item.pic).filter(Boolean),
          main_image_three_to_four: clone(this.form.main_image_three_to_four),
          material_video_id: this.form.material_video_id,
          white_back_ground_pic_url: this.form.white_back_ground_pic_url,
          long_pic_url: this.form.long_pic_url,
          size_info_template_id: this.form.size_info_template_id,
          size_chart_dirty: this.isSizeChartDirty() ? 1 : 0,
          size_chart: this.buildSizeChartForSubmit(),
          product_format_new: this.buildProductFormatNewForSubmit(),
          category_property_pics: clone(this.form.category_property_pics),
          quality_list: this.buildQualityListForSubmit(),
          spec_info: this.buildSpecInfo(),
          spec_prices_v2: this.buildSpecPrices(),
        }
        if (this.recommendIds.category_recommend_id) {
          payload.recommend_ids = clone(this.recommendIds)
        }
        const res = await this.actionRequest(this.saveDoudianProductEdit, {
          id: this.productId,
          data: payload,
        })
        this.$message.success(res.message || '保存成功')
        await this.capturePristineSnapshot()
        if (keepOpen) {
          this.$emit('saved', res.data || {}, true)
          this.syncSidebarList()
        } else {
          this.$emit('saved', res.data || {})
          this.$emit('update:visible', false)
        }
      } catch (error) {
        this.$message.error(error.message || '保存失败')
      } finally {
        this.saving = false
      }
    },
    closeDialog() {
      this.handleBeforeClose()
    },
    finishDialogClose(done) {
      if (typeof done === 'function') {
        done()
      }
      this.$emit('update:visible', false)
    },
    handleBeforeClose(done) {
      if (!this.dirty) {
        this.finishDialogClose(done)
        return
      }
      this.$confirm('当前有未保存修改，确认关闭吗？', '提示', {
        type: 'warning',
        confirmButtonText: '关闭',
        cancelButtonText: '继续编辑',
      }).then(() => {
        this.finishDialogClose(done)
      }).catch(() => {})
    },
    resetState() {
      this.loading = false
      this.saving = false
      this.dirty = false
      this.activeTab = 'info'
      this.bootstrapping = false
      this.freightLoading = false
      this.sizeTemplateLoading = false
      this.productInfo = {}
      this.brandList = []
      this.freightTemplates = []
      this.sizeTemplateList = []
      this.materialFolders = []
      this.materialList = []
      this.materialMediaType = 'image'
      this.materialRootCategory = '0'
      this.materialVideoCoverUrl = ''
      this.materialVideoPlayUrl = ''
      this.updateRule = {}
      this.categoryProperties = []
      this.newSpecPropertyId = ''
      this.supportTemplateSubType = ''
      this.materialFolderId = ''
      this.materialLoading = false
      this.materialUploading = false
      this.materialDeleting = false
      this.predictionLoadingSource = ''
      this.recommendIds = {}
      this.criticalPredictionSnapshot = {
        title: '',
        images: [],
        category_leaf_id: 0,
      }
      this.categoryPrediction = {
        visible: false,
        source: '',
        recommendId: '',
        selectedLeafId: 0,
        items: [],
        predictedSnapshot: {
          title: '',
          images: [],
        },
      }
      this.materialPagination = {
        page: 1,
        size: 15,
        total: 0,
      }
      this.form = this.createEmptyForm()
      this.specs = []
      this.specPrices = []
      this.specsBackup = []
      this.specPricesBackup = []
      this.selectedSpecValueIds = []
      this.allSpecValuesSelected = false
      this.specSelectionIndeterminate = false
      this.skuOpen = true
      this.batchEditVisible = false
      this.batchRemarkVisible = false
      this.visiblePrice = false
      this.visibleStock = false
      this.visibleCode = false
      this.visibleSkuStatus = false
      this.batchForm = {
        range: 'all',
        price: null,
        stock: null,
        code: '',
        sku_status: true,
      }
      this.priceBatch = {
        mode: 1,
        value: null,
        rate: 100,
        add: 0,
        dec: 0,
        decimal: null,
        range: 'all',
      }
      this.stockBatch = {
        mode: 1,
        value: null,
        add: 0,
        dec: 0,
        min: 0,
        skipZero: false,
        range: 'all',
      }
      this.codeBatch = {
        value: '',
        range: 'all',
      }
      this.allSkuStatus = true
      this.remarkForm = {
        mode: 1,
        remark1: '',
        prefix: '',
        suffix: '',
        pairs: [{ find: '', replace: '' }],
        remark5: '',
      }
      this.batchRange = {
        specs: [],
      }
      this.sizeChartLoading = false
      this.sizeChartSettingVisible = false
      this.sizeChart = createEmptySizeChartState()
      this.initialSizeChartSnapshot = ''
      this.previewDialog = {
        visible: false,
        url: '',
        type: 'image',
      }
      this.threeGuarantees = {
        service_type: '',
        duration: '',
      }
      this.imageDialog = {
        visible: false,
        target: '',
        multiple: true,
        index: -1,
        title: '添加图片',
        existingUrls: [],
        selectedUrls: [],
        maxSelect: 1,
      }
      this.titleEditor = {
        visible: false,
        value: '',
      }
      this.mainImageEditor = {
        visible: false,
        images: [],
      }
      this.sidebarList = []
      this.sidebarLoading = false
      this.sidebarPagination = {
        page: 1,
        page_size: 20,
        total: 0,
      }
      this.sidebarSearch = {
        title: '',
        product_id: '',
      }
      this.currentEditingId = ''
      this.propertyDiyDrafts = {}
      this.propertyDiyEditing = {}
      this.initialDirtySnapshot = ''
      this.specSortDialog = {
        visible: false,
        specIndex: -1,
        list: [],
      }
      this.specDimSortDialog = {
        visible: false,
        list: [],
      }
    },
  },
}
</script>

<style scoped>
::v-deep(.doudian-editor-shell) {
  --editor-accent: #f46b55;
  --editor-accent-strong: #ef5a43;
  --editor-accent-soft: #fff2ed;
  --editor-accent-border: #f4ddd5;
  --editor-text-main: #2f3137;
  --editor-text-sub: #78665f;
  --editor-panel-soft: #fffaf7;
  border-radius: 22px;
  overflow: hidden;
  background: #fffaf8;
  box-shadow: 0 24px 60px rgba(23, 28, 38, 0.16);
}

::v-deep(.doudian-editor-shell .el-dialog__header) {
  padding: 14px 20px 10px;
  border-bottom: 1px solid #f2e5df;
  background:
    radial-gradient(circle at top right, rgba(255, 119, 87, 0.12), transparent 34%),
    linear-gradient(180deg, #fffaf8 0%, #fff 100%);
}

::v-deep(.doudian-editor-shell .el-dialog__body) {
  padding: 0;
}

::v-deep(.doudian-editor-shell .el-dialog__footer) {
  padding: 10px 20px 12px;
  border-top: 1px solid #f2e5df;
  background: rgba(255, 255, 255, 0.94);
}

::v-deep(.doudian-editor-shell .el-dialog__headerbtn) {
  top: 14px;
  right: 18px;
}

::v-deep(.doudian-editor-shell .el-dialog__close) {
  font-size: 20px;
  color: #8d746a;
  transition: color 0.2s ease;
}

::v-deep(.doudian-editor-shell .el-dialog__headerbtn:hover .el-dialog__close) {
  color: #f46b55;
}

.editor-dialog {
  --editor-accent: #f46b55;
  --editor-accent-strong: #ef5a43;
  --editor-accent-soft: #fff2ed;
  --editor-accent-border: #f4ddd5;
  --editor-text-main: #2f3137;
  --editor-text-sub: #78665f;
  --editor-panel-soft: #fffaf7;
  max-height: 82vh;
  overflow-y: auto;
  padding: 4px 8px 4px 0;
  background: #f5f6f8;
}

.editor-section {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 18px 20px;
  margin-bottom: 16px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.editor-tabs {
  box-shadow: none;
  min-width: 0;
}

.editor-form {
  min-width: 0;
}

.property-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px 28px;
}

.property-row {
  min-width: 0;
}

.property-form-item {
  margin-bottom: 0;
}

.property-form-item ::v-deep .el-form-item__label {
  float: none;
  display: block;
  width: auto !important;
  line-height: 24px;
  text-align: left;
  padding: 0;
  margin-bottom: 10px;
}

.property-form-item ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  line-height: normal;
}

.property-pic-uploader {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #f2e7e2;
}

.property-pic-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.property-pic-title {
  font-size: 12px;
  font-weight: 600;
  color: #8f6d62;
}

.property-pic-required {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgba(255, 103, 74, 0.12);
  color: #ff674a;
  font-size: 12px;
  line-height: 20px;
}

.property-pic-limit {
  color: #909399;
  font-size: 12px;
}

.property-pic-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.property-pic-card {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 16px;
  overflow: hidden;
  background: #fff7f2;
  border: 1px solid #f2e7e2;
  box-sizing: border-box;
}

.property-pic-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.property-pic-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(70, 42, 34, 0.55);
  color: #fff;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.property-pic-card:hover .property-pic-mask {
  opacity: 1;
}

.property-pic-mask i {
  font-size: 18px;
  cursor: pointer;
}

.property-pic-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #ff674a;
  cursor: pointer;
}

.property-pic-add i {
  font-size: 18px;
}

.property-pic-add span {
  font-size: 12px;
  line-height: 1;
}

.quality-list {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.quality-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 18px;
  align-items: flex-start;
}

.quality-label {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding-top: 8px;
  color: #606266;
  font-size: 15px;
  line-height: 22px;
  text-align: right;
  word-break: break-word;
}

.quality-required {
  color: #f56c6c;
}

.quality-content {
  min-width: 0;
}

.quality-hints {
  margin-bottom: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.quality-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.quality-image-card {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px dashed #c0c4cc;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  background: #fafafa;
}

.quality-image-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.quality-image-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.quality-image-card:hover .quality-image-mask {
  opacity: 1;
}

.quality-image-mask i {
  font-size: 18px;
  cursor: pointer;
}

.quality-image-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #606266;
  cursor: pointer;
}

.quality-image-add i {
  font-size: 28px;
}

.quality-image-add span {
  font-size: 16px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-left: 10px;
  position: relative;
}
.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: var(--red, #f23030);
  border-radius: 2px;
}
.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.section-title-row .section-title {
  margin-bottom: 0;
}
.section-meta {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  color: #606266;
  font-size: 13px;
}
.section-meta-item {
  line-height: 20px;
}

.sub-group {
  padding: 14px 0 4px;
  border-top: 1px dashed #ebeef5;
}
.sub-group:first-of-type {
  border-top: 0;
  padding-top: 0;
}
.sub-group-title {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 14px;
  padding-left: 8px;
  border-left: 2px solid #dcdfe6;
  line-height: 1;
}

.inline-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.field-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.category-select-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.plain-field-value {
  flex: 1;
  min-width: 0;
  padding: 5px 0;
  color: #303133;
  font-size: 14px;
  line-height: 22px;
  word-break: break-all;
}

.plain-field-value.is-empty {
  color: #909399;
}

.prediction-summary {
  margin-bottom: 16px;
  color: #606266;
}

.prediction-category-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.prediction-category-list .el-radio {
  width: 100%;
  height: auto;
  min-height: 42px;
  margin: 0;
  padding: 12px 16px;
  white-space: normal;
}

.prediction-unavailable {
  color: #c0c4cc;
}

.image-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.image-item {
  width: 120px;
}

.thumb {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  object-fit: cover;
  background: #f5f7fa;
}

.empty-thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.video-empty-thumb {
  flex-direction: column;
  gap: 6px;
  padding: 8px;
  box-sizing: border-box;
  word-break: break-all;
  text-align: center;
}

.video-empty-thumb i {
  font-size: 24px;
}

.image-toolbar {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 6px;
  color: #606266;
}

.image-toolbar i {
  cursor: pointer;
}

.single-image-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.single-image-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.spec-block {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  margin-bottom: 12px;
  background: #fafafa;
}

.sku-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f5f7fa;
}

.sku-page {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.sku-delivery-card {
  padding: 14px 16px 2px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
}

.sku-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fafbfc;
}

.sku-summary .section-title {
  margin-bottom: 4px;
}

.sku-summary-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.sku-summary-actions .action-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 12px;
  margin-right: 12px;
  border-right: 1px solid #e4e7ed;
}
.sku-summary-actions .action-group:last-child {
  border-right: 0;
  margin-right: 0;
  padding-right: 0;
}

::v-deep(.sku-summary-actions .el-button--primary),
::v-deep(.sku-summary-actions .el-button--danger) {
  color: #fff !important;
}

::v-deep(.sku-summary-actions .el-button--primary span),
::v-deep(.sku-summary-actions .el-button--primary i),
::v-deep(.sku-summary-actions .el-button--danger span),
::v-deep(.sku-summary-actions .el-button--danger i) {
  color: #fff !important;
}

::v-deep(.sku-summary-actions .el-button--danger:not(.is-disabled)) {
  border-color: var(--editor-accent-strong) !important;
  background: linear-gradient(180deg, #ff8466 0%, var(--editor-accent-strong) 100%) !important;
  box-shadow: 0 10px 20px rgba(244, 107, 85, 0.2);
}

::v-deep(.sku-summary-actions .el-button--danger:not(.is-disabled):hover) {
  border-color: #e75139 !important;
  background: linear-gradient(180deg, #ff7a5f 0%, #e75139 100%) !important;
}

.sku-editor-layout {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
  min-width: 0;
  overflow: hidden;
  padding-bottom: 2px;
}

.sku-spec-panel,
.sku-table-panel {
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: #fff;
}

.sku-spec-panel {
  padding: 12px;
  width: 100%;
  min-width: 0;
  max-width: none;
  max-height: none;
  overflow: visible;
  flex-shrink: 1;
}

.spec-add-inline {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.spec-add-inline-empty {
  margin-bottom: 14px;
}

.spec-inline-add-select {
  width: 220px;
}

.sku-panel-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 600;
}

.sku-table-panel {
  padding: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}

.size-chart-page {
  border: 1px solid #e8e1dd;
  border-radius: 18px;
  background: linear-gradient(180deg, #fffdfc 0%, #fff 100%);
  box-shadow: 0 18px 36px rgba(96, 58, 36, 0.06);
  overflow: hidden;
}

.size-chart-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(233, 220, 214, 0.9);
  background: rgba(255, 248, 245, 0.72);
}

.size-setting-panel {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.size-setting-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.size-setting-title {
  font-weight: 600;
  color: #5f4942;
}

.size-setting-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}

.size-chart-empty {
  padding: 34px 20px;
}

.size-chart-table-wrap {
  overflow-x: auto;
}

.size-chart-table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
}

.size-chart-table th,
.size-chart-table td {
  border-right: 1px solid #efe3de;
  border-bottom: 1px solid #efe3de;
  padding: 18px 16px;
  vertical-align: middle;
  background: #fff;
}

.size-chart-table th:last-child,
.size-chart-table td:last-child {
  border-right: 0;
}

.size-chart-table thead th {
  background: #fff7f3;
  color: #5c443d;
  font-weight: 700;
}

.size-chart-size-col {
  width: 120px;
  min-width: 120px;
}

.size-chart-action-col {
  width: 120px;
  min-width: 120px;
}

.size-chart-head-cell {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.size-chart-head-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
}

.size-important-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #6c95ff;
  border-radius: 999px;
  background: #f3f7ff;
  color: #3262ff;
  font-size: 12px;
  font-weight: 700;
}

.size-chart-size-cell {
  font-size: 16px;
  font-weight: 700;
  color: #4e3831;
}

.size-chart-range-inputs {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 10px;
  align-items: center;
}

.size-chart-range-sep {
  color: #8d756d;
  font-weight: 600;
}

.size-chart-action-cell {
  white-space: nowrap;
}

.size-chart-action-cell .el-button + .el-button {
  margin-left: 8px;
}

.spec-card {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 12px;
  background: #fafafa;
}

.sku-spec-head,
.sku-spec-cell {
  display: inline-block;
  margin-right: 14px;
}

.sku-status-popover {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.sku-batch-form-wrap {
  width: 100%;
  pointer-events: auto;
}

.sku-batch-form {
  width: 100%;
}

::v-deep(.el-popover.sku-batch-popover) {
  z-index: 4005 !important;
  pointer-events: auto !important;
}

::v-deep(.el-popover.sku-batch-popover .el-form),
::v-deep(.el-popover.sku-batch-popover .el-form-item),
::v-deep(.el-popover.sku-batch-popover .el-radio-group),
::v-deep(.el-popover.sku-batch-popover .el-checkbox-group),
::v-deep(.el-popover.sku-batch-popover .el-button),
::v-deep(.el-popover.sku-batch-popover .el-switch),
::v-deep(.el-popover.sku-batch-popover .el-input),
::v-deep(.el-popover.sku-batch-popover .el-input-number) {
  position: relative;
  z-index: 1;
  pointer-events: auto !important;
}

::v-deep(.el-popover.sku-batch-popover .el-radio),
::v-deep(.el-popover.sku-batch-popover .el-radio__input),
::v-deep(.el-popover.sku-batch-popover .el-radio__label) {
  pointer-events: auto !important;
}

::v-deep(.sku-table .cell) {
  overflow: visible;
}

.spec-block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-weight: 600;
  margin-bottom: 10px;
}

.spec-block-head-main {
  min-width: 0;
}

.spec-block-head-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.spec-values {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px 16px;
}

.spec-value-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto auto;
  gap: 8px;
  align-items: center;
  min-width: 0;
  margin-bottom: 0;
}

.spec-value-row .el-checkbox {
  margin-right: 0;
}

.spec-value-row .el-input {
  max-width: none;
}

.portrait-thumb {
  height: 160px;
  object-fit: contain;
}

.detail-image-list .image-item {
  width: 140px;
}

.detail-thumb {
  width: 140px;
  height: 160px;
  object-fit: contain;
}

.spec-pic-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 140px));
  align-items: start;
  gap: 16px 18px;
}

.spec-pic-list .spec-pic-item {
  width: 140px;
}

.spec-pic-list .spec-pic-item .thumb {
  width: 140px;
  height: 140px;
  display: flex;
  box-sizing: border-box;
}

.spec-pic-label {
  height: 40px;
  margin-bottom: 8px;
  font-size: 12px;
  line-height: 20px;
  color: #606266;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.sku-table {
  margin-top: 12px;
  min-width: 930px;
}

.measure-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.measure-row {
  display: block;
  min-width: 0;
}

.measure-row-main {
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
}

.measure-module-field {
  flex: 0 1 360px;
  min-width: 220px;
  max-width: 420px;
}

.measure-row-main > .measure-module-field {
  max-width: 100%;
}

.measure-row > .el-button {
  margin-top: 8px;
}

.measure-module-input-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.measure-module-number {
  flex: 1;
  min-width: 0;
}

.measure-module-input-wrap > .measure-module-number.el-input {
  width: auto;
  flex: 1 1 0;
}

.measure-module-number.el-input-number {
  width: 100%;
}

.measure-module-field ::v-deep(.el-select),
.measure-module-field ::v-deep(.el-input),
.measure-module-field ::v-deep(.el-input-number) {
  width: 100%;
}

.measure-module-unit-select {
  width: 84px;
  flex-shrink: 0;
}

.measure-module-unit-text {
  flex-shrink: 0;
  min-width: 34px;
  padding: 0 8px;
  height: 36px;
  line-height: 34px;
  border: 1px solid #eadfd9;
  border-radius: 12px;
  background: #fff8f4;
  color: #8b6b61;
  text-align: center;
}

.measure-add-button {
  align-self: flex-start;
  min-width: 72px;
  padding: 0 14px;
}

.dirty-tip {
  float: left;
  color: #e6a23c;
  line-height: 32px;
}

.size-dialog-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.size-template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  min-height: 180px;
}

.size-template-card {
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 10px;
  background: #fff;
}

.size-template-image {
  width: 100%;
  height: 150px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #f5f7fa;
}

.size-template-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.size-template-name {
  margin-top: 8px;
  min-height: 36px;
  font-size: 12px;
  color: #606266;
  word-break: break-all;
}

.size-template-actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
}

.preview-image {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
  object-fit: contain;
}

.preview-video {
  display: block;
  width: 100%;
  max-height: 70vh;
  background: #000;
}

.material-dialog {
  display: flex;
  height: 620px;
  border: 1px solid #ebeef5;
}

.material-sidebar {
  width: 220px;
  flex-shrink: 0;
  border-right: 1px solid #ebeef5;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fafafa;
}

.material-media-tabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  padding: 12px 12px 0;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 2;
}

.material-media-tab {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e9e7ef;
  border-bottom: 0;
  border-radius: 14px 14px 0 0;
  background: #f8f8fb;
  color: #6c6f7b;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.material-media-tab.active {
  background: #fff;
  color: #2f6bff;
  border-color: #e5e9f5;
  box-shadow: 0 -6px 16px rgba(47, 107, 255, 0.08);
}

.material-root-tabs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  position: sticky;
  top: 56px;
  z-index: 1;
}

.material-root-tab {
  min-height: 34px;
  padding: 0 12px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #5f6368;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.material-root-tab:hover {
  background: #f5f8ff;
  color: #1966ff;
}

.material-root-tab.active {
  background: #eef4ff;
  color: #1966ff;
  font-weight: 600;
}

.material-folder {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
  cursor: pointer;
  color: #606266;
  overflow: hidden;
}

.material-folder i {
  flex-shrink: 0;
}

.material-folder span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.material-folder:hover,
.material-folder.active {
  color: #1966ff;
  background: #eef4ff;
}

.material-main {
  flex: 1;
  padding: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.material-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.material-toolbar > div:last-child {
  display: flex;
  gap: 8px;
  align-items: center;
}

.material-grid {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 14px;
}

.material-card {
  width: 118px;
  height: 140px;
  border: 2px solid transparent;
  border-radius: 6px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background: #f5f7fa;
}

.material-card.selected {
  border-color: #1966ff;
}

.material-card img {
  width: 100%;
  height: 118px;
  object-fit: cover;
  display: block;
}

.material-video-thumb {
  width: 100%;
  height: 118px;
  object-fit: cover;
  display: block;
}

.material-video-placeholder {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  box-sizing: border-box;
  color: #909399;
  font-size: 12px;
  text-align: center;
  word-break: break-all;
}

.material-video-placeholder i {
  font-size: 24px;
}

.material-card-mask {
  position: absolute;
  inset: 0 0 22px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(25, 102, 255, 0.18);
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.material-card:hover .material-card-mask,
.material-card.selected .material-card-mask {
  opacity: 1;
  pointer-events: auto;
}

.material-use-btn {
  min-width: 68px;
  box-shadow: 0 8px 20px rgba(25, 102, 255, 0.2);
}

.material-size {
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
  color: #606266;
}

.material-preview {
  position: absolute;
  right: 6px;
  top: 6px;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  padding: 4px;
}

.editor-container {
  display: flex;
  height: 78vh;
  min-width: 0;
}

.editor-sidebar {
  border-right: 1px solid #ebeef5;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-search {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.sidebar-search .el-button {
  grid-column: 1 / 3;
}

.sidebar-list {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
}

.sidebar-item {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 6px;
  border: 1px solid transparent;
}

.sidebar-item:hover {
  background: #eef4ff;
}

.sidebar-item.active {
  background: #eef4ff;
  border-color: #1966ff;
}

.sidebar-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.sidebar-thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  object-fit: cover;
  flex-shrink: 0;
}

.sidebar-thumb-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #c0c4cc;
  background: #f5f7fa;
}

.sidebar-info {
  flex: 1;
  min-width: 0;
}

.sidebar-title {
  font-size: 12px;
  color: #303133;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.sidebar-id {
  font-size: 11px;
  color: #909399;
  margin-top: 2px;
}

.sidebar-status {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.editor-main {
  flex: 1;
  min-width: 0;
  padding: 14px 16px;
  overflow-y: auto;
  overflow-x: hidden;
}

.char-counter {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}

.char-over {
  color: #f56c6c;
}

.image-drag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.image-card {
  position: relative;
  width: 120px;
}

.image-card .img-hover-mask {
  position: absolute;
  inset: 0;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}

.image-card:hover .img-hover-mask {
  opacity: 1;
}

.img-hover-mask i {
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.img-hover-mask i:hover {
  color: #1966ff;
}

.image-slot {
  width: 120px;
  height: 120px;
  border: 1px dashed #c0c4cc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fafafa;
  color: #909399;
  font-size: 28px;
}

.image-slot:hover {
  border-color: #1966ff;
  color: #1966ff;
}

.image-slot-portrait {
  height: 160px;
}

.spec-sort-list {
  min-height: 60px;
}

.spec-sort-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #fff;
  cursor: move;
}

.drag-handle {
  color: #909399;
  cursor: grab;
}

.batch-range-select {
  margin-top: 8px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 8px;
  background: #fafafa;
}

.batch-toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

::v-deep(.batch-toggle-group .el-radio-button__inner) {
  border-left: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
}

::v-deep(.batch-toggle-group .el-radio-button.is-active .el-radio-button__inner) {
  border-color: #f0413e !important;
}

.batch-range-dim {
  margin-bottom: 10px;
}

.batch-range-dim:last-child {
  margin-bottom: 0;
}

.batch-range-values {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 4px;
  margin-left: 22px;
}

.remark-pairs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.remark-pair-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.remark-pair-row .el-input {
  flex: 1;
}

.remark-arrow {
  color: #909399;
  flex-shrink: 0;
}

.half-price-tip {
  color: #e6a23c;
  font-size: 12px;
  margin-left: 8px;
  cursor: help;
}

.sku-header-batch-btn {
  padding: 2px 6px;
  margin-left: 4px;
  font-size: 12px;
  line-height: 1.2;
}

.spec-name-select {
  width: 140px;
}

.spec-sort-link {
  color: #1966ff;
  cursor: pointer;
  margin-left: 12px;
  font-size: 13px;
}

.spec-delete-link {
  color: #f56c6c;
  cursor: pointer;
  font-size: 13px;
}

.spec-value-input {
  width: 100% !important;
}

.sku-border-check {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #606266;
  margin-left: 4px;
  user-select: none;
}

.custom-check {
  width: 16px;
  height: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.custom-check.checked {
  background: #1966ff;
  border-color: #1966ff;
  color: #fff;
}

.sku-icon-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  margin-left: 4px;
}

.sku-icon-btn:hover {
  color: #1966ff;
  border-color: #1966ff;
}

.sku-add-icon {
  grid-column: 1 / -1;
}

.sku-add-icon {
  font-size: 20px;
  color: #1966ff;
  cursor: pointer;
  margin-top: 6px;
  margin-left: 4px;
}

.remark-modes {
  display: flex;
  flex-direction: column;
}

.remark-mode-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.remark-mode-inner {
  display: flex;
  align-items: center;
  color: #333;
  flex-wrap: wrap;
  gap: 4px;
}

.remark-mode-label {
  width: 56px;
  display: inline-block;
}

.remark-help-icon {
  color: #898b8f;
  margin-left: 4px;
}

.remark-pairs-inline {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 8px;
}

.remark-add-icon,
.remark-del-icon {
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
  color: #1966ff;
}

.remark-del-icon {
  color: #f56c6c;
}

.remark-apply-bar {
  text-align: center;
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-right: 28px;
}

.dialog-title-main {
  min-width: 0;
}

.dialog-title-text {
  font-size: 17px;
  line-height: 1.2;
  font-weight: 700;
  color: var(--editor-text-main);
  letter-spacing: 0.01em;
}

.dialog-title-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #8b746c;
  line-height: 1.35;
  max-width: 720px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #f2e5df;
}

.sidebar-head-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--editor-text-main);
}

.sidebar-head-desc {
  margin-top: 0;
  font-size: 12px;
  color: #977d73;
}

.dialog-footer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.dialog-footer-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
}

.dialog-footer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.editor-dialog {
  padding: 10px 14px 12px;
  background:
    linear-gradient(180deg, #fff8f5 0%, #f7f8fb 48%, #f6f8fb 100%);
}

.editor-container {
  border: 1px solid #f0e1db;
  border-radius: 20px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 16px 36px rgba(31, 35, 41, 0.05);
}

.editor-sidebar {
  border-right-color: #f1e4de;
  background: linear-gradient(180deg, #fffaf7 0%, #ffffff 52%, #fff8f5 100%);
}

.sidebar-search {
  gap: 8px;
  padding: 14px;
  border-bottom-color: #f2e5df;
  background: rgba(255, 255, 255, 0.56);
}

.sidebar-list {
  padding: 10px;
}

.sidebar-item {
  gap: 10px;
  padding: 10px;
  border-radius: 16px;
  margin-bottom: 10px;
  border-color: #f1e4de;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 8px 18px rgba(31, 35, 41, 0.04);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
  position: relative;
}

.sidebar-item:hover {
  background: #fff6f1;
  border-color: #f3cfc4;
  transform: translateY(-1px);
  box-shadow: 0 12px 22px rgba(31, 35, 41, 0.07);
}

.sidebar-item.active {
  background: linear-gradient(180deg, #fff6f1 0%, #fff 100%);
  border-color: var(--editor-accent);
  box-shadow: 0 14px 26px rgba(244, 107, 85, 0.12);
}

.sidebar-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 12px;
  bottom: 12px;
  width: 4px;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, #ff8e6d 0%, var(--editor-accent-strong) 100%);
}

.sidebar-item.disabled {
  opacity: 0.58;
}

.sidebar-thumb {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border-color: #f0e2db;
  background: #fff6f1;
}

.sidebar-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--editor-text-main);
}

.sidebar-id {
  color: #9b847b;
  margin-top: 4px;
}

.editor-main {
  padding: 18px 20px 20px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f7f8fb 100%);
}

.editor-section {
  border-color: var(--editor-accent-border);
  border-radius: 18px;
  padding: 22px 24px;
  margin-bottom: 18px;
  background: linear-gradient(180deg, #fff 0%, var(--editor-panel-soft) 100%);
  box-shadow: 0 10px 28px rgba(31, 35, 41, 0.05);
}

::v-deep(.editor-tabs.el-tabs--border-card) {
  border: 0;
  background: transparent;
  box-shadow: none;
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__header) {
  margin: 0;
  padding: 8px;
  border: 1px solid #f1e4de;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 24px rgba(31, 35, 41, 0.04);
  position: sticky;
  top: 0;
  z-index: 5;
  backdrop-filter: blur(10px);
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__header .el-tabs__nav-wrap::after) {
  display: none;
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__header .el-tabs__item) {
  height: 42px;
  line-height: 42px;
  padding: 0 18px;
  border: 0;
  border-radius: 12px;
  color: #7c6860;
  font-weight: 600;
  transition: all 0.2s ease;
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover) {
  color: var(--editor-accent-strong);
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active) {
  color: var(--editor-accent-strong);
  background: var(--editor-accent-soft);
  box-shadow: inset 0 0 0 1px var(--editor-accent-border);
}

::v-deep(.editor-tabs.el-tabs--border-card > .el-tabs__content) {
  padding: 18px 4px 8px;
  border: 0;
  background: transparent;
}

.property-grid {
  gap: 18px 24px;
}

.property-row {
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #f2e7e2;
  background: rgba(255, 255, 255, 0.9);
}

::v-deep(.el-select-dropdown__item.property-diy-option) {
  display: flex !important;
  align-items: stretch !important;
  height: auto !important;
  min-height: 48px;
  line-height: normal !important;
  cursor: default;
  padding: 0 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: initial !important;
  box-sizing: border-box;
}

::v-deep(.el-select-dropdown__item.property-diy-option.is-editing) {
  min-height: 60px;
}

::v-deep(.el-select-dropdown__item.property-diy-option.hover),
::v-deep(.el-select-dropdown__item.property-diy-option.selected) {
  background: #fffaf7 !important;
  color: inherit !important;
}

::v-deep(.el-select-dropdown .el-scrollbar__view) {
  padding-bottom: 6px;
}

::v-deep(.el-select-dropdown .el-scrollbar__wrap) {
  overflow-x: hidden !important;
}

.property-diy-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border-top: 1px solid #f2e7e2;
  background: #fffaf7;
  display: flex;
  align-items: center;
  min-height: 48px;
}

::v-deep(.el-select-dropdown__item.property-diy-option.is-editing .property-diy-footer) {
  min-height: 60px;
}

.property-diy-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 32px;
}

.property-diy-input-row .el-input {
  flex: 1;
}

.property-diy-confirm,
.property-diy-cancel {
  font-size: 18px;
  cursor: pointer;
  flex-shrink: 0;
}

.property-diy-confirm {
  color: #2eb67d;
}

.property-diy-cancel {
  color: #f56c6c;
}

.section-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--editor-text-main);
  margin-bottom: 18px;
  padding-left: 12px;
}

.section-title::before {
  width: 4px;
  height: 16px;
  background: linear-gradient(180deg, #ff8d69 0%, var(--editor-accent-strong) 100%);
}

.section-meta {
  gap: 12px;
  color: var(--editor-text-sub);
  font-size: 12px;
}

.section-meta-item {
  line-height: 1;
  padding: 8px 12px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #f3e6e0;
  font-weight: 500;
}

.editor-status-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 0 0;
  padding: 12px 14px;
  border-radius: 14px;
  border: 1px solid #f8d6a8;
  background: linear-gradient(180deg, #fff8ef 0%, #fff4e5 100%);
  color: #b76a16;
  font-size: 13px;
  line-height: 1.7;
}

.editor-status-warning i {
  flex: 0 0 auto;
  margin-top: 2px;
  font-size: 16px;
}

.sub-group {
  padding: 16px 18px 8px;
  margin-top: 14px;
  border: 1px solid #f2e7e2;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.86);
}

.sub-group:first-of-type {
  margin-top: 0;
}

.sub-group-title {
  color: #6e5c55;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 3px solid #f6b3a3;
}

.inline-field {
  gap: 10px;
  flex-wrap: wrap;
}

.field-hint {
  color: #9a847b;
  margin-top: 6px;
}

.char-counter {
  color: #9b847b;
}

.title-field-input {
  width: 100%;
  max-width: 760px;
}

.title-edit-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 760px;
}

::v-deep(.editor-form .critical-edit-trigger) {
  flex: 0 0 auto;
  min-width: 118px;
  min-height: 38px;
  margin: 0;
  padding: 0 18px;
  color: var(--editor-accent-strong);
  border-color: #efb5a5;
  border-radius: 12px;
  background: var(--editor-accent-soft);
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
  font-weight: 600;
}

::v-deep(.editor-form .critical-edit-trigger:not(.is-disabled):hover),
::v-deep(.editor-form .critical-edit-trigger:not(.is-disabled):focus) {
  color: #fff;
  border-color: var(--editor-accent-strong);
  background: var(--editor-accent-strong);
  box-shadow: 0 6px 14px rgba(244, 107, 85, 0.18);
}

::v-deep(.editor-form .critical-edit-trigger.is-disabled) {
  color: #b7aaa5;
  border-color: #e4e1df;
  background: #f5f5f5;
}

::v-deep(.editor-form .critical-section-action) {
  min-width: 112px;
  color: var(--editor-accent-strong);
  border-color: #efb5a5;
  background: var(--editor-accent-soft);
  box-shadow: none;
  font-weight: 600;
}

::v-deep(.editor-form .critical-section-action:not(.is-disabled):hover),
::v-deep(.editor-form .critical-section-action:not(.is-disabled):focus) {
  color: #fff;
  border-color: var(--editor-accent-strong);
  background: var(--editor-accent-strong);
  box-shadow: 0 8px 18px rgba(244, 107, 85, 0.18);
}

.thumb {
  border-radius: 14px;
  border-color: #f0e2db;
  background: #fff7f3;
  box-shadow: 0 8px 22px rgba(31, 35, 41, 0.06);
}

.spec-block,
.spec-card {
  border-color: #f2e6e0;
  border-radius: 14px;
  background: #fffaf7;
}

.sku-toolbar,
.sku-summary {
  border-color: #f0e1db;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffaf7 0%, #fff 100%);
}

.sku-summary {
  box-shadow: 0 10px 24px rgba(31, 35, 41, 0.04);
}

.sku-spec-panel,
.sku-table-panel {
  border-color: #f0e1db;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(31, 35, 41, 0.04);
}

.spec-values {
  gap: 14px 16px;
}

.spec-value-row {
  padding: 10px 12px;
  border: 1px solid #f2e7e2;
  border-radius: 14px;
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.dirty-tip {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #fff1e8;
  color: #dd6a2c;
  border: 1px solid #f2ceb3;
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
}

.image-card .img-hover-mask {
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(39, 42, 47, 0.08) 0%, rgba(39, 42, 47, 0.52) 100%);
}

.img-hover-mask i:hover {
  color: #ffd7cd;
}

.image-slot {
  border-color: #efc7bb;
  border-radius: 14px;
  background: linear-gradient(180deg, #fffaf7 0%, #fff3ee 100%);
  color: #b48d81;
  transition: all 0.2s ease;
}

.image-slot:hover {
  border-color: var(--editor-accent);
  color: var(--editor-accent-strong);
  transform: translateY(-1px);
}

.custom-check.checked {
  background: var(--editor-accent);
  border-color: var(--editor-accent);
}

.sku-icon-btn:hover,
.remark-add-icon,
.sku-add-icon {
  color: var(--editor-accent-strong);
}

::v-deep(.editor-form .el-form-item__label) {
  color: #5f4f49;
  font-weight: 600;
}

::v-deep(.editor-form .el-input__inner),
::v-deep(.editor-form .el-textarea__inner),
::v-deep(.editor-form .el-input-number .el-input__inner),
::v-deep(.editor-form .el-cascader .el-input__inner),
::v-deep(.editor-form .el-select .el-input__inner) {
  border-radius: 12px;
  border-color: #eadbd4;
  background: #fff;
  color: var(--editor-text-main);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

::v-deep(.editor-form .el-input__inner:hover),
::v-deep(.editor-form .el-textarea__inner:hover),
::v-deep(.editor-form .el-input-number .el-input__inner:hover),
::v-deep(.editor-form .el-cascader .el-input__inner:hover),
::v-deep(.editor-form .el-select .el-input__inner:hover) {
  border-color: #e3c6bc;
}

::v-deep(.editor-form .el-input.is-focus .el-input__inner),
::v-deep(.editor-form .el-textarea__inner:focus),
::v-deep(.editor-form .el-input-number.is-focus .el-input__inner),
::v-deep(.editor-form .el-select .el-input.is-focus .el-input__inner),
::v-deep(.editor-form .el-cascader .el-input.is-focus .el-input__inner) {
  border-color: var(--editor-accent);
  box-shadow: 0 0 0 3px rgba(244, 107, 85, 0.12);
}

::v-deep(.editor-form .el-radio__input.is-checked .el-radio__inner),
::v-deep(.editor-form .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: var(--editor-accent);
  background: var(--editor-accent);
}

::v-deep(.editor-form .el-radio__input.is-checked + .el-radio__label),
::v-deep(.editor-form .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: var(--editor-accent-strong);
}

::v-deep(.editor-form .el-button) {
  min-height: 36px;
  border-radius: 12px;
}

::v-deep(.editor-form .el-button--primary),
::v-deep(.dialog-footer-actions .el-button--primary) {
  color: #fff !important;
  border-color: var(--editor-accent-strong);
  background: linear-gradient(180deg, #ff8466 0%, var(--editor-accent-strong) 100%);
  box-shadow: 0 10px 20px rgba(244, 107, 85, 0.2);
}

::v-deep(.editor-form .el-button--primary span),
::v-deep(.editor-form .el-button--primary i),
::v-deep(.dialog-footer-actions .el-button--primary span),
::v-deep(.dialog-footer-actions .el-button--primary i) {
  color: #fff !important;
}

::v-deep(.editor-form .el-button--primary:hover),
::v-deep(.dialog-footer-actions .el-button--primary:hover) {
  border-color: #e75139;
  background: linear-gradient(180deg, #ff7a5f 0%, #e75139 100%);
}

::v-deep(.dialog-footer-actions .el-button) {
  min-width: 124px;
  height: 44px;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 600;
}

::v-deep(.dialog-footer-actions .el-button--default) {
  color: #5f4f49;
  background: #fff;
  border-color: #d9dce3;
}

::v-deep(.dialog-footer-actions .el-button--primary) {
  color: #fff !important;
  border-color: var(--editor-accent-strong) !important;
  background: linear-gradient(180deg, #ff8466 0%, var(--editor-accent-strong) 100%) !important;
}

::v-deep(.dialog-footer-actions .el-button span),
::v-deep(.dialog-footer-actions .el-button i) {
  color: inherit !important;
}

::v-deep(.editor-sidebar .el-pagination) {
  padding: 12px 14px 14px;
  border-top: 1px solid #f2e5df;
  background: rgba(255, 255, 255, 0.75);
  text-align: center;
}

::v-deep(.editor-sidebar .el-pager li.active) {
  background: var(--editor-accent);
  border-radius: 8px;
}

@media (max-width: 1200px) {
  .editor-container {
    height: auto;
    flex-direction: column;
  }

  .editor-sidebar {
    width: 100% !important;
    border-right: 0;
    border-bottom: 1px solid #f1e4de;
  }

  .property-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 20px;
  }

  .quality-row {
    grid-template-columns: 140px minmax(0, 1fr);
  }

  .measure-row-main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .sku-editor-layout {
    flex-direction: column;
    overflow-x: visible;
  }

  .sku-spec-panel {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .sku-table-panel {
    width: 100%;
    min-width: 0;
    flex-basis: auto;
  }

}

@media (max-width: 768px) {
  .editor-dialog {
    padding: 10px;
  }

  .dialog-title {
    align-items: flex-start;
    flex-direction: column;
    padding-right: 28px;
  }

  .dialog-title-sub {
    white-space: normal;
  }

  .editor-section {
    padding: 18px 16px;
    border-radius: 16px;
  }

  .section-title-row {
    align-items: flex-start;
  }

  .section-meta {
    gap: 8px;
  }

  .editor-status-warning {
    margin-top: 14px;
    padding: 10px 12px;
  }

  .sub-group {
    padding: 14px 14px 6px;
  }

  .title-edit-row {
    align-items: stretch;
    flex-direction: column;
  }

  ::v-deep(.editor-form .title-edit-row .critical-edit-trigger) {
    width: 100%;
  }

  .property-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .quality-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .quality-label {
    justify-content: flex-start;
    text-align: left;
  }

  .spec-values {
    grid-template-columns: 1fr;
  }

  .dialog-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .dialog-footer-actions {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>

<style>
.doudian-property-select-dropdown .el-select-dropdown__item.property-diy-option {
  display: flex !important;
  align-items: stretch !important;
  height: auto !important;
  min-height: 48px;
  line-height: normal !important;
  cursor: default;
  padding: 0 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: initial !important;
  box-sizing: border-box;
}

.doudian-property-select-dropdown .el-select-dropdown__item.property-diy-option.is-editing {
  min-height: 60px;
}

.doudian-property-select-dropdown .el-select-dropdown__item.property-diy-option.hover,
.doudian-property-select-dropdown .el-select-dropdown__item.property-diy-option.selected {
  background: #fffaf7 !important;
  color: inherit !important;
}

.doudian-property-select-dropdown .el-scrollbar__view {
  padding-bottom: 6px;
}

.doudian-property-select-dropdown .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

.critical-edit-dialog {
  --critical-accent: #f46b55;
  --critical-accent-strong: #ef5a43;
  --critical-accent-soft: #fff2ed;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(23, 28, 38, 0.18);
}

.critical-edit-dialog .el-dialog__header {
  padding: 18px 22px 15px;
  border-bottom: 1px solid #f2e5df;
  background: linear-gradient(180deg, #fffaf8 0%, #fff 100%);
}

.critical-edit-dialog .el-dialog__title {
  color: #2f3137;
  font-size: 17px;
  font-weight: 700;
}

.critical-edit-dialog .el-dialog__headerbtn {
  top: 18px;
  right: 20px;
}

.critical-edit-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: var(--critical-accent-strong);
}

.critical-edit-dialog .el-dialog__body {
  padding: 22px 24px;
  color: #493f3b;
  background: #fff;
}

.critical-edit-dialog .el-dialog__footer {
  padding: 14px 22px 18px;
  border-top: 1px solid #f2e5df;
  background: #fffaf8;
}

.critical-edit-dialog-intro {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px 16px;
  border: 1px solid #f3d5cc;
  border-radius: 14px;
  color: #6f5a52;
  background: linear-gradient(180deg, #fff8f5 0%, #fff3ee 100%);
}

.critical-edit-dialog-intro > i {
  flex: 0 0 auto;
  margin-top: 1px;
  color: var(--critical-accent-strong);
  font-size: 20px;
}

.critical-edit-dialog-intro-title {
  color: #493f3b;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.5;
}

.critical-edit-dialog-intro-desc {
  margin-top: 2px;
  color: #8e766d;
  font-size: 12px;
  line-height: 1.6;
}

.critical-edit-dialog .el-form-item__label {
  color: #5f4f49;
  font-weight: 600;
}

.critical-edit-dialog .el-input__inner {
  border-color: #e8d6cf;
  border-radius: 10px;
}

.critical-edit-dialog .el-input__inner:hover {
  border-color: #e3b9ab;
}

.critical-edit-dialog .el-input.is-focus .el-input__inner {
  border-color: var(--critical-accent);
  box-shadow: 0 0 0 3px rgba(244, 107, 85, 0.12);
}

.critical-edit-dialog-footer {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.critical-edit-dialog-footer .el-button {
  min-width: 112px;
  min-height: 40px;
  margin-left: 0;
  border-radius: 10px;
  font-weight: 600;
}

.critical-edit-dialog .el-button--primary {
  color: #fff;
  border-color: var(--critical-accent-strong);
  background: linear-gradient(180deg, #ff8466 0%, var(--critical-accent-strong) 100%);
  box-shadow: 0 8px 18px rgba(244, 107, 85, 0.2);
}

.critical-edit-dialog .el-button--primary:not(.is-disabled):hover,
.critical-edit-dialog .el-button--primary:not(.is-disabled):focus {
  border-color: #e75139;
  background: linear-gradient(180deg, #ff765b 0%, #e75139 100%);
}

.critical-image-count {
  flex: 0 0 auto;
  min-width: 48px;
  margin-left: auto;
  padding: 5px 10px;
  border: 1px solid #efc9bd;
  border-radius: 999px;
  color: var(--critical-accent-strong);
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.critical-image-editor-list {
  min-height: 152px;
  padding: 16px;
  border: 1px dashed #efc9bd;
  border-radius: 14px;
  background: #fffaf8;
}

.critical-image-dialog .image-card {
  cursor: move;
}

.critical-image-index {
  position: absolute;
  top: 7px;
  left: 7px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  color: #fff;
  background: rgba(47, 49, 55, 0.76);
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.16);
}

.critical-image-dialog .image-slot {
  flex-direction: column;
  gap: 8px;
  color: #a97869;
  font-size: 13px;
  font-weight: 600;
}

.critical-image-dialog .image-slot i {
  font-size: 24px;
}

.critical-category-dialog .prediction-summary {
  margin-bottom: 16px;
}

.critical-category-dialog .prediction-category-list .el-radio {
  box-sizing: border-box;
  transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.critical-category-dialog .prediction-category-list > .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}

.critical-category-dialog .prediction-category-list .el-radio:not(.is-disabled):hover {
  border-color: #efb5a5;
  background: #fff8f5;
}

.critical-category-dialog .prediction-category-list .el-radio.is-bordered.is-checked {
  border-color: var(--critical-accent);
  background: var(--critical-accent-soft);
  box-shadow: 0 6px 14px rgba(244, 107, 85, 0.1);
}

.critical-category-dialog .el-radio__input.is-checked .el-radio__inner {
  border-color: var(--critical-accent);
  background: var(--critical-accent);
}

.critical-category-dialog .el-radio__input.is-checked + .el-radio__label {
  color: var(--critical-accent-strong);
}

@media (max-width: 768px) {
  .critical-edit-dialog {
    width: calc(100% - 24px) !important;
    margin-top: 5vh !important;
  }

  .critical-edit-dialog .el-dialog__body {
    padding: 18px 16px;
  }

  .critical-edit-dialog-intro {
    padding: 12px;
  }

  .critical-image-count {
    margin-left: 0;
  }

  .critical-edit-dialog-footer {
    display: flex;
    width: 100%;
  }

  .critical-edit-dialog-footer .el-button {
    flex: 1;
    min-width: 0;
  }
}
</style>
